import { ColDef } from "ag-grid-community";
import {
  ISelectableOption,
  SetupListInfoResponse,
  SetupListNavInfoByDepartment,
  SetupListResponse,
  StoreState,
  UserData,
  IAMUserState,
  GenericRowData,
  JsonSchema,
  RowData,
} from "../../types";
import {
  MOCK_CHART_OF_ACCOUNTS_DEPENDENCIES,
  MOCK_LASER_FORM_TABLE_DEPENDENCIES,
  MOCK_RECURRING_JOURNAL_ENTRIES_DEPENDENCIES,
} from "./MockSchemaDependencies";

export const MOCK_STORES: Array<StoreState> = [
  {
    id: "S000000123",
    name: "Dealership Store 23",
    defaultStore: false,
  },
  {
    id: "S000000001",
    name: "Dealership Store 51",
    defaultStore: true,
  },
];

export const MOCK_STORE_OPTIONS: ISelectableOption[] = [
  {
    label: "S100119371 - Company 5",
    value: "S100119371",
  },
  {
    label: "S100119370 - Company 4",
    value: "S100119370",
  },
  {
    label: "S100119373 - Company 7",
    value: "S100119373",
  },
];

export const MOCK_SCHEMA_LIST: SetupListResponse = {
  department: "accounting",
  setups: {
    AccountsPayable: "Accounts Payable",
    AccountsReceivable: "Accounts Receivable",
  },
};

export const MOCK_USER_DATA: UserData = {
  user: {
    userGuid: "0B90FC9073BA53F1E063F10863641455",
    loginId: "OM@E339440.com",
    firstName: "Office",
    middleInitial: null,
    lastName: "Manager",
    dmsUserIdentifier: null,
    locked: false,
    adminNotes: null,
    creationDate: "2023-12-04T17:33:49+0000",
    lastLoginDate: null,
    locale: "",
    state: 2,
    prefix: null,
    suffix: "Sr",
    nickName: "CDCMOfficeManager",
    employeeId: null,
    jobTitle: null,
    selfServiceEnabled: 1,
    accountStatus: "Active",
    communicationEdgeId: "ome339440com@dit.cdkcollaborate.com",
    uniquePrincipalName: null,
    createdBy: "ramulu.suddewar@cdk.com",
    mfaEnabled: false,
    dmsUserStatus: null,
    externallyFederated: false,
  },
  contacts: [
    {
      typeCode: "Email",
      value: "CDK.racedev@cdk.com",
      contactGuid: "0B90FC9073BC53F1E063F10863641455",
      preferred: true,
      secondary: false,
    },
  ],
  enterprise: {
    idpName: null,
    id: "E339440",
    name: "Enterprise1",
    vanityDomain: null,
  },
  stores: [
    {
      id: "S100119371",
      name: "Company 5",
      defaultStore: true,
    },
    {
      id: "S100119370",
      name: "Company 4",
      defaultStore: false,
    },
    {
      id: "S100119373",
      name: "Company 7",
      defaultStore: false,
    },
  ],
  roles: [
    {
      roleGuid: "0BADCECC75A74FFCE063F1086364D000",
      roleName: "CDCM - Office Manager",
    },
  ],
  alternateIdentifiers: [],
  roleAssignedBy: "ramulu.suddewar@cdk.com",
  roleAssignedOn: 1701711234664,
  warnings: [],
  securityQuestionsStatus: false,
  userAliases: [],
};

export const MOCK_IAM_USER_DATA: IAMUserState = {
  iamUser: {
    username: "OM@E339440.com",
    authorities: [
      {
        authority: "CDCM_ACCESS_APP",
      },
      {
        authority: "CDCM_ACCOUNTING_ACCESS",
      },
      {
        authority: "CDCM_FUNCTIONAL_UNIT_CREATE",
      },
      {
        authority: "CDCM_FUNCTIONAL_UNIT_DELETE",
      },
      {
        authority: "CDCM_FUNCTIONAL_UNIT_LIST",
      },
      {
        authority: "CDCM_FUNCTIONAL_UNIT_UPDATE",
      },
      {
        authority: "CDCM_FUNCTIONAL_UNIT_VIEW",
      },
      {
        authority: "CDCM_LCM_ACCESS",
      },
      {
        authority: "CDCM_LCM_FA",
      },
      {
        authority: "CDCM_LCM_FU",
      },
      {
        authority: "CDCM_PARTS_ACCESS",
      },
      {
        authority: "CDCM_SERVICE_ACCESS",
      },
      {
        authority: "SETUPS_SCHEMA_ACCESS_APP",
      },
      {
        authority: "SETUPS_SCHEMA_CREATE",
      },
      {
        authority: "SETUPS_SCHEMA_LIST",
      },
      {
        authority: "SETUPS_SCHEMA_PUBLISH",
      },
      {
        authority: "SETUPS_SCHEMA_UPDATE",
      },
      {
        authority: "SETUPS_SCHEMA_VIEW",
      },
      {
        authority: "SETUP_SCHEMA_ADMIN",
      },
    ],
    accountNonExpired: true,
    accountNonLocked: true,
    credentialsNonExpired: true,
    enabled: true,
    enterprise: {
      id: "E339440",
    },
    assignments: [
      {
        stores: [
          {
            storeId: "S100119371",
            name: "Company 5",
            defaultStore: true,
          },
          {
            storeId: "S100119370",
            name: "Company 4",
            defaultStore: false,
          },
          {
            storeId: "S100119373",
            name: "Company 7",
            defaultStore: false,
          },
        ],
        roles: [
          {
            roleGuid: "0BADCECC75A74FFCE063F1086364D000",
            code: "CDCM_OFFICE_MANAGER",
          },
        ],
      },
    ],
    firstName: "Office",
    middleName: null,
    lastName: "Manager",
    locale: "en_US",
    isServiceUser: false,
  },
  extendedAccountInfo: [
    {
      storeId: "S100119371",
      storeName: "Company 5",
      companyId: "5",
      accounts: ["PLF-A"],
      departmentIds: ["D100096236"],
    },
    {
      storeId: "S100119370",
      storeName: "Company 4",
      companyId: "4",
      accounts: ["BDC-A"],
      departmentIds: ["D100096248"],
    },
    {
      storeId: "S100119373",
      storeName: "Company 7",
      companyId: "7",
      accounts: ["PLF-A"],
      departmentIds: ["D100096236"],
    },
  ],
  eisGroups: {
    groups: [
      {
        name: "5 - Company 5",
        groupId: "G000008445",
        type: "GL_GROUP",
        organizationUnits: ["S100119371"],
        companyId: "5",
      },
      {
        name: "4 - Company 4",
        groupId: "G000008446",
        type: "GL_GROUP",
        organizationUnits: ["S100119370"],
        companyId: "4",
      },
      {
        name: "7 - Company 7",
        groupId: "G000008447",
        type: "GL_GROUP",
        organizationUnits: ["S100119373"],
        companyId: "7",
      },
      {
        name: "PLF-A",
        groupId: "G000008454",
        type: "ACCOUNTING_GROUP",
        organizationUnits: ["G000008447", "G000008445", "G000008450"],
        stores: [
          {
            storeId: "S100119373",
            storeName: "Company 7",
          },
          {
            storeId: "S100119371",
            storeName: "Company 5",
          },
        ],
      },
      {
        name: "BDC-A",
        groupId: "G000008455",
        type: "ACCOUNTING_GROUP",
        organizationUnits: ["G000008446"],
        stores: [
          {
            storeId: "S100119370",
            storeName: "Company 4",
          },
        ],
      },
    ],
  },
};

export const MOCK_USER_ROLES = [
  {
    roleGuid: "E92F9C325E8A4527E053F10863647328",
    roleName: "CDCM - USER",
  },
  {
    roleGuid: "EB4AD09E31C74BD8E053F1086364E848",
    roleName: "CDCM - DEVELOPER",
  },
  {
    roleGuid: "EB516EC57EB505E8E053F1086364F4EA",
    roleName: "CDCM - VIC",
  },
  {
    roleGuid: "EB51731CDDC276CCE053F10863647D82",
    roleName: "CDCM - ADMIN",
  },
  {
    roleGuid: "09003B9EE8CA1C75E063F10863641BCD",
    roleName: "CDCM - Accounting Manager",
  },
  {
    roleGuid: "09003B9EE8CA1C75E063F10862341BCD",
    roleName: "CDCM - Office Manager",
  },
  {
    roleGuid: "09003B9EE8CA1C75E063F10862341BCD",
    roleName: "CDCM - Parts Manager",
  },
  {
    roleGuid: "09003B9EE8CA1C75E063F10862341BCD",
    roleName: "CDCM - Service Manager",
  },
  {
    roleGuid: "09003B9EE8CA1C75E063F10862341BCD",
    roleName: "Setups Administrator",
  },
];

export const MOCK_FULL_SETUP_LIST_INFO: SetupListInfoResponse[] = [
  {
    department: "parts",
    setups: [
      {
        code: "InventoryBuildings",
        name: "Inventory Buildings",
        description: "Description is not defined for the setup",
        isFavorite: true,
      },
      {
        code: "CustomPricing",
        name: "Custom Pricing",
        description: "Description is not defined for the setup",
        isFavorite: false,
      },
    ],
    departmentIds: [
      {
        storeId: "S100119370",
        name: "BDC-I",
        departmentId: "D100096250",
      },
      {
        storeId: "S100119371",
        name: "PL-I",
        departmentId: "D100096244",
      },
      {
        storeId: "S100119373",
        name: "PLF-I",
        departmentId: "D100096230",
      },
    ],
  },
  {
    department: "service",
    setups: [
      {
        code: "Opcodes",
        name: "Op Codes",
        description: "Description is not defined for the setup",
        isFavorite: false,
      },
      {
        code: "SourceAccountingService",
        name: "Source Accounting Service",
        description: "Description is not defined for the setup",
        isFavorite: false,
      },
      {
        code: "Discounts",
        name: "Discounts",
        description: "Description is not defined for the setup",
        isFavorite: false,
      },
      {
        code: "LaborServiceFeeCodes",
        name: "Labor Fee Codes",
        description: "Description is not defined for the setup",
        isFavorite: false,
      },
      {
        code: "LaborPricingGrids",
        name: "Labor Pricing Grids",
        description: "Description is not defined for the setup",
        isFavorite: false,
      },
      {
        code: "LaborTypes",
        name: "Labor Types",
        description: "Description is not defined for the setup",
        isFavorite: false,
      },
      {
        code: "ServicePaymentTypes",
        name: "Payment Types",
        description: "Description is not defined for the setup",
        isFavorite: false,
      },
      {
        code: "TaxCodes",
        name: "Tax Codes",
        description: "Description is not defined for the setup",
        isFavorite: false,
      },
      {
        code: "ServiceInvoice",
        name: "Invoice",
        description: "Description is not defined for the setup",
        isFavorite: false,
      },
    ],
    departmentIds: [
      {
        storeId: "S100119370",
        name: "BDC-S",
        departmentId: "D100096252",
      },
      {
        storeId: "S100119371",
        name: "PL-S",
        departmentId: "D100096245",
      },
      {
        storeId: "S100119373",
        name: "PLF-S",
        departmentId: "D100096231",
      },
    ],
  },
  {
    department: "accounting",
    setups: [
      {
        code: "COA",
        name: "Chart of Accounts (COA)",
        description: "A flattened schema definition for a COA setup item",
        isFavorite: false,
      },
      {
        code: "VendorCompanyType",
        name: "Vendor Company Type",
        description: "A schema definition for vendor company types",
        isFavorite: false,
      },
      {
        code: "ETCTimeZonesMasterData",
        name: "ETC TimeZones Master Data",
        description:
          "The ETC TimeZones Master Data setup is not yet implemented",
        isFavorite: false,
      },
      {
        code: "MISReportFormats",
        name: "MIS Report Formats",
        description: "The MIS Report Formats setup is not yet implemented",
        isFavorite: false,
      },
      {
        code: "POGroupMembers",
        name: "PO Group Members",
        description: "Description is not defined for the setup",
        isFavorite: false,
      },
      {
        code: "POGroupCompany",
        name: "PO Group Company",
        description: "Description is not defined for the setup",
        isFavorite: false,
      },
      {
        code: "GLFiscalYearCalendar",
        name: "GL Fiscal Year Calendar",
        description:
          "A schema definition for merged GL Calendar & Fiscal Year End setups",
        isFavorite: false,
      },
      {
        code: "AccountsPayable",
        name: "Accounts Payable",
        description:
          "A flattened schema definition for an Accounts Payable open item setup object",
        isFavorite: false,
      },
      {
        code: "AccountsReceivable",
        name: "Accounts Receivable",
        description: "A schema definition for an Accounts Receivable object",
        isFavorite: true,
      },
      {
        code: "AcctsPayablePayments",
        name: "Accounts Payable Payments",
        description:
          "The Accounts Payable Payments setup is not yet implemented",
        isFavorite: false,
      },
      {
        code: "CAPDefaults",
        name: "Cash App Defaults",
        description: "A schema definition for a CAP defaults object",
        isFavorite: false,
      },
      {
        code: "CashInBanks",
        name: "Cash In Bank",
        description: "A schema definition for Cash In Bank setups",
        isFavorite: false,
      },
      {
        code: "CREDefaults",
        name: "Cash Receipt Defaults",
        description: "A schema definition for CRE Cash Receipts setups",
        isFavorite: false,
      },
      {
        code: "PaymentTypes",
        name: "Cash Receipt Payment Types",
        description: "A schema definition for cash receipt payment types",
        isFavorite: false,
      },
      {
        code: "DataRetention",
        name: "Data Retention",
        description: "The Data Retention setup is not yet implemented",
        isFavorite: false,
      },
      {
        code: "Departments",
        name: "Departments",
        description: "The Departments setup is not yet implemented",
        isFavorite: false,
      },
      {
        code: "DetailGeneralLedger",
        name: "Detail General Ledger",
        description: "The Detail General Ledger setup is not yet implemented",
        isFavorite: false,
      },
      {
        code: "EtcAbsenceCodes",
        name: "ETC Absence Codes",
        description:
          "A schema definition for an Electronic Time Clock absence codes",
        isFavorite: false,
      },
      {
        code: "EtcHolidays",
        name: "ETC Holidays",
        description:
          "A schema definition for an Electronic Time Clock holidays",
        isFavorite: false,
      },
      {
        code: "EtcPayrollFields",
        name: "ETC Payroll Fields",
        description:
          "A schema definition for Electronic Time Clock payroll fields",
        isFavorite: false,
      },
      {
        code: "EtcTardyCodes",
        name: "ETC Tardy Codes",
        description:
          "A schema definition for an Electronic Time Clock Tardy codes",
        isFavorite: false,
      },
      {
        code: "EtcTechPayrollRecordTypes",
        name: "ETC Technician Payroll Record Types",
        description:
          "A schema definition for an Electronic Time Clock technician payroll record types",
        isFavorite: false,
      },
      {
        code: "EtcTimeZones",
        name: "ETC Time Zones",
        description:
          "A schema definition for an Electronic Time Clock time zones",
        isFavorite: false,
      },
      {
        code: "ExpenseAllocations",
        name: "Expense Allocations",
        description:
          "A schema definition for an accounting expense allocation setup item",
        isFavorite: false,
      },
      {
        code: "GLCalendar",
        name: "GL Calendar",
        description: "A schema definition for GL Calendar setups",
        isFavorite: false,
      },
      {
        code: "GroupCodes",
        name: "Group Codes",
        description:
          "A schema definition for accounting report group codes setup item",
        isFavorite: false,
      },
      {
        code: "IntercoTransfer",
        name: "Interco Transfer",
        description: "A schema definition for Interco Transfer setups",
        isFavorite: false,
      },
      {
        code: "Journals",
        name: "Journals",
        description: "A schema definition for accounting journal setup item",
        isFavorite: false,
      },
      {
        code: "JournalTemplates",
        name: "Journal Templates",
        description: "Stores optional journal entry posting templates data",
        isFavorite: false,
      },
      {
        code: "Checks",
        name: "On Demand Checks (Checks)",
        description: "A schema definition for ODC Check writing setups",
        isFavorite: false,
      },
      {
        code: "RecurringJournalEntries",
        name: "Recurring Journal Entries",
        description:
          "A schema definition for accounting recurring journal entries setup item",
        isFavorite: false,
      },
      {
        code: "SaleChains",
        name: "Sale Chains",
        description:
          "A schema definition for COA related accounting sale chains setups",
        isFavorite: false,
      },
      {
        code: "Schedules",
        name: "Schedules",
        description: "The Schedules setup is not yet implemented",
        isFavorite: false,
      },
      {
        code: "VendorCategory",
        name: "Vendor Category",
        description: "A schema definition for vendor categories",
        isFavorite: false,
      },
      {
        code: "VendorPaymentTypes",
        name: "Vendor Payment Types",
        description:
          "A schema definition for Accounts Payable vendor payments types",
        isFavorite: false,
      },
      {
        code: "WriteOffs",
        name: "Write Offs",
        description: "A schema definition for accounting Write-Offs setup item",
        isFavorite: false,
      },
      {
        code: "GLFiscalYearEnd",
        name: "Fiscal Year End",
        description: "A schema definition for GL Fiscal Year end setups",
        isFavorite: false,
      },
      {
        code: "POCatalogItem",
        name: "PO Catalog Item",
        description: "Description is not defined for the setup",
        isFavorite: false,
      },
      {
        code: "POGroups",
        name: "PO Groups",
        description: "Description is not defined for the setup",
        isFavorite: false,
      },
      {
        code: "POInvoiceStatus",
        name: "PO Invoice Status",
        description: "Description is not defined for the setup",
        isFavorite: false,
      },
      {
        code: "POItemBrand",
        name: "PO Item Brand",
        description: "Description is not defined for the setup",
        isFavorite: false,
      },
      {
        code: "POItemCategory",
        name: "PO Item Category",
        description: "Description is not defined for the setup",
        isFavorite: false,
      },
      {
        code: "POSecurityOperations",
        name: "PO Security Operation",
        description: "Description is not defined for the setup",
        isFavorite: false,
      },
      {
        code: "POShipVia",
        name: "PO Ship Via",
        description: "Description is not defined for the setup",
        isFavorite: false,
      },
      {
        code: "POStatus",
        name: "PO Status",
        description: "Description is not defined for the setup",
        isFavorite: false,
      },
      {
        code: "POTypes",
        name: "PO Types",
        description: "Description is not defined for the setup",
        isFavorite: false,
      },
      {
        code: "POUnitsOfMeasure",
        name: "PO Unit of Measure",
        description: "A schema definition for Purchase Order Units of Measure",
        isFavorite: false,
      },
      {
        code: "POGroupTenantLink",
        name: "PO Group Tenant Link",
        description: "Description is not defined for the setup",
        isFavorite: false,
      },
      {
        code: "AccCompanyMasterData",
        name: "PO Company (Account Company Master Data)",
        description: "Description is not defined for the setup",
        isFavorite: false,
      },
      {
        code: "VendorGLAccounts",
        name: "Vendor GL Accounts",
        description: "The Vendor GL Accounts setup is not yet implemented",
        isFavorite: false,
      },
      {
        code: "ARPortal",
        name: "AR Portal Setup",
        description: "A schema definition for AR Portal Setup",
        isFavorite: false,
      },
      {
        code: "EtcPayPeriod",
        name: "ETC pay period",
        description:
          "A schema definition for Electronic Time Clock payment types",
        isFavorite: false,
      },
      {
        code: "CashClearingSetup",
        name: "Cash Clearing Setup",
        description: "A schema definition for Cash Clearing Setup",
        isFavorite: false,
      },
      {
        code: "InvoiceAutoPost",
        name: "Invoice Auto Post",
        description: "A schema definition for Invoice Auto Post",
        isFavorite: false,
      },
      {
        code: "LaserFormTable",
        name: "Laser Form Table",
        description: "A schema definition for a Laser Form Table object",
        isFavorite: false,
      },
      {
        code: "POConfigurationGroup",
        name: "PO Configuration Group",
        description: "A schema definition for Purchase Order Group setups",
        isFavorite: false,
      },
      {
        code: "PORoleLevelInfo",
        name: "PO Approval Limit",
        description: "A schema definition for PO RoleLevel Info setups",
        isFavorite: false,
      },
      {
        code: "POVendorChangeControl",
        name: "PO Vendor Change Control",
        description: "A schema definition for po vendor change control",
        isFavorite: false,
      },
      {
        code: "RemitToParent",
        name: "Vendor Remit To Parent",
        description: "A schema definition for Remit To Parent",
        isFavorite: false,
      },
      {
        code: "RemittanceFormMapping",
        name: "Remittance Form Mapping",
        description: "A schema definition for a Remittance Form Mapping object",
        isFavorite: false,
      },
    ],
    departmentIds: [
      {
        storeId: "S100119370",
        name: "BDC-A",
        departmentId: "D100096248",
      },
      {
        storeId: "S100119371",
        name: "PLF-A",
        departmentId: "D100096236",
      },
      {
        storeId: "S100119373",
        name: "PLF-A",
        departmentId: "D100096236",
      },
    ],
  },
];

export const MOCK_EVENTS_DATA: GenericRowData[] = [
  {
    username: "OM@E339440.com",
    eventStatus: "CREATE",
    eventTime: "13/05/2024 06:26 pm",
  },
  {
    username: "OM@E339440.com",
    eventStatus: "UPDATE",
    eventTime: "14/05/2024 11:52 pm",
  },
  {
    username: "OM@E339440.com",
    eventStatus: "DELETE",
    eventTime: "15/05/2024 11:54 pm",
  },
];
export const MOCK_EVENTS_COL_DEFS = [
  {
    field: "username",
    headerName: "User Name",
    headerCheckboxSelection: true,
    checkboxSelection: true,
  },
  {
    field: "eventStatus",
    headerName: "Event Status",
  },
  {
    field: "eventTime",
    headerName: "Event Time",
  },
];
export const MOCK_EVENTS = [
  {
    label: "CREATE",
    value: "CREATE",
    disabled: false,
  },
  {
    label: "UPDATE",
    value: "UPDATE",
    disabled: false,
  },
  {
    label: "DELETE",
    value: "DELETE",
    disabled: false,
  },
];
export const MOCK_EVENTS_DETAILS_DATA = [
  {
    fields: "Retention months",
    oldVale: "",
    newValue: "",
  },
  {
    fields: "Journal Entry Reference Advice",
    oldValue: "Invoice",
    newValue: "PO",
  },
  {
    fields: "Share check numbers",
    oldValue: "Separate checks form number series",
    newValue: "Do not keep retained check number",
  },
  {
    fields: "Account",
    oldValue: "",
    newValue: "",
  },
  {
    fields: "Void checks vendor number",
    oldValue: "",
    newValue: "",
  },
  {
    fields: "Journal",
    oldValue: "",
    newValue: "",
  },
];
export const MOCK_EVENTS_DETAILS_COL_DEFS = [
  {
    field: "fields",
    headerName: "Fields",
  },
  {
    field: "newValue",
    headerName: "new Value",
  },
  {
    field: "oldValue",
    headerName: "Old Value",
  },
];

export const MOCK_SETUPBASEREQUESTINFO = {
  accountName: "PLF-A",
  enterpriseId: "E339440",
  functionalArea: "accounting",
  functionalUnitName: "RemittanceFormMapping",
  storeId: "S100119371",
  departmentId: "D100096236",
};

export const MOCK_SETUP_LIST_NAV_INFO_BY_DEPARTMENT: SetupListNavInfoByDepartment =
  {
    parts: {
      setups: [
        {
          id: "InventoryBin",
          text: "Inventory Bin",
          department: {
            label: "Parts",
            value: "parts",
            disabled: false,
          },
          description: "Description is not defined for the setup",
        },
        {
          id: "InventoryBuildings",
          text: "Inventory Buildings",
          description: "Description is not defined for the setup",
        },
        {
          id: "InventoryRoutes",
          text: "Inventory Routes",
          description: "Description is not defined for the setup",
        },
        {
          id: "InventoryZones",
          text: "Inventory Zones",
          description: "Description is not defined for the setup",
        },
        {
          id: "CustomPricing",
          text: "Custom Pricing",
          description: "Description is not defined for the setup",
        },
      ],
      departmentIds: [
        {
          departmentId: "D100096250",
          name: "BDC-I",
          storeId: "S100119370",
        },
        {
          departmentId: "D100096244",
          name: "PL-I",
          storeId: "S100119371",
        },
        {
          departmentId: "D100096230",
          name: "PLF-I",
          storeId: "S100119373",
        },
      ],
    },
    service: {
      setups: [
        {
          id: "Discounts",
          text: "Discounts",
          department: {
            label: "Service",
            value: "service",
            disabled: false,
          },
          description: "Description is not defined for the setup",
        },
        {
          id: "ServiceInvoice",
          text: "Invoice",
          description: "Description is not defined for the setup",
        },
        {
          id: "LaborServiceFeeCodes",
          text: "Labor Fee Codes",
          description: "Description is not defined for the setup",
        },
        {
          id: "LaborPricingGrids",
          text: "Labor Pricing Grids",
          description: "Description is not defined for the setup",
        },
        {
          id: "LaborTypes",
          text: "Labor Types",
          description: "Description is not defined for the setup",
        },
        {
          id: "Opcodes",
          text: "Op Codes",
          description: "Description is not defined for the setup",
        },
        {
          id: "ServicePaymentTypes",
          text: "Payment Types",
          description: "Description is not defined for the setup",
        },
        {
          id: "SourceAccountingService",
          text: "Source Accounting Service",
          description: "Description is not defined for the setup",
        },
        {
          id: "TaxCodes",
          text: "Tax Codes",
          description: "Description is not defined for the setup",
        },
      ],
      departmentIds: [
        {
          departmentId: "D100096252",
          name: "BDC-S",
          storeId: "S100119370",
        },
        {
          departmentId: "D100096245",
          name: "PL-S",
          storeId: "S100119371",
        },
        {
          departmentId: "D100096231",
          name: "PLF-S",
          storeId: "S100119373",
        },
      ],
    },
    accounting: {
      setups: [
        {
          id: "AccountsPayable",
          text: "Accounts Payable",
          department: {
            label: "Accounting",
            value: "accounting",
            disabled: false,
          },
          description:
            "A flattened schema definition for an Accounts Payable open item setup object",
        },
        {
          id: "AcctsPayablePayments",
          text: "Accounts Payable Payments",
          description:
            "The Accounts Payable Payments setup is not yet implemented",
        },
        {
          id: "AccountsReceivable",
          text: "Accounts Receivable",
          description: "A schema definition for an Accounts Receivable object",
        },
        {
          id: "ARPortal",
          text: "AR Portal Setup",
          description: "A schema definition for AR Portal Setup",
        },
        {
          id: "CAPDefaults",
          text: "Cash App Defaults",
          description: "A schema definition for a CAP defaults object",
        },
        {
          id: "CashClearingSetup",
          text: "Cash Clearing Setup",
          description: "A schema definition for Cash Clearing Setup",
        },
        {
          id: "CashInBanks",
          text: "Cash In Bank",
          description: "A schema definition for Cash In Bank setups",
        },
        {
          id: "CREDefaults",
          text: "Cash Receipt Defaults",
          description: "A schema definition for CRE Cash Receipts setups",
        },
        {
          id: "PaymentTypes",
          text: "Cash Receipt Payment Types",
          description: "A schema definition for cash receipt payment types",
        },
        {
          id: "COA",
          text: "Chart of Accounts (COA)",
          description: "A flattened schema definition for a COA setup item",
        },
        {
          id: "DataRetention",
          text: "Data Retention",
          description: "The Data Retention setup is not yet implemented",
        },
        {
          id: "Departments",
          text: "Departments",
          description: "The Departments setup is not yet implemented",
        },
        {
          id: "DetailGeneralLedger",
          text: "Detail General Ledger",
          description: "The Detail General Ledger setup is not yet implemented",
        },
        {
          id: "EtcAbsenceCodes",
          text: "ETC Absence Codes",
          description:
            "A schema definition for an Electronic Time Clock absence codes",
        },
        {
          id: "EtcHolidays",
          text: "ETC Holidays",
          description:
            "A schema definition for an Electronic Time Clock holidays",
        },
        {
          id: "EtcPayPeriod",
          text: "ETC pay period",
          description:
            "A schema definition for Electronic Time Clock payment types",
        },
        {
          id: "EtcPayrollFields",
          text: "ETC Payroll Fields",
          description:
            "A schema definition for Electronic Time Clock payroll fields",
        },
        {
          id: "EtcTardyCodes",
          text: "ETC Tardy Codes",
          description:
            "A schema definition for an Electronic Time Clock Tardy codes",
        },
        {
          id: "EtcTechPayrollRecordTypes",
          text: "ETC Technician Payroll Record Types",
          description:
            "A schema definition for an Electronic Time Clock technician payroll record types",
        },
        {
          id: "EtcTimeZones",
          text: "ETC Time Zones",
          description:
            "A schema definition for an Electronic Time Clock time zones",
        },
        {
          id: "ETCTimeZonesMasterData",
          text: "ETC TimeZones Master Data",
          description:
            "The ETC TimeZones Master Data setup is not yet implemented",
        },
        {
          id: "ExpenseAllocations",
          text: "Expense Allocations",
          description:
            "A schema definition for an accounting expense allocation setup item",
        },
        {
          id: "GLFiscalYearEnd",
          text: "Fiscal Year End",
          description: "A schema definition for GL Fiscal Year end setups",
        },
        {
          id: "GLCalendar",
          text: "GL Calendar",
          description: "A schema definition for GL Calendar setups",
        },
        {
          id: "GLFiscalYearCalendar",
          text: "GL Fiscal Year Calendar",
          description:
            "A schema definition for merged GL Calendar & Fiscal Year End setups",
        },
        {
          id: "GroupCodes",
          text: "Group Codes",
          description:
            "A schema definition for accounting report group codes setup item",
        },
        {
          id: "IntercoTransfer",
          text: "Interco Transfer",
          description: "A schema definition for Interco Transfer setups",
        },
        {
          id: "InvoiceAutoPost",
          text: "Invoice Auto Post",
          description: "A schema definition for Invoice Auto Post",
        },
        {
          id: "JournalTemplates",
          text: "Journal Templates",
          description: "Stores optional journal entry posting templates data",
        },
        {
          id: "Journals",
          text: "Journals",
          description: "A schema definition for accounting journal setup item",
        },
        {
          id: "LaserFormTable",
          text: "Laser Form Table",
          description: "A schema definition for a Laser Form Table object",
        },
        {
          id: "MISReportFormats",
          text: "MIS Report Formats",
          description: "The MIS Report Formats setup is not yet implemented",
        },
        {
          id: "Checks",
          text: "On Demand Checks (Checks)",
          description: "A schema definition for ODC Check writing setups",
        },
        {
          id: "PORoleLevelInfo",
          text: "PO Approval Limit",
          description: "A schema definition for PO RoleLevel Info setups",
        },
        {
          id: "POCatalogItem",
          text: "PO Catalog Item",
          description: "Description is not defined for the setup",
        },
        {
          id: "AccCompanyMasterData",
          text: "PO Company (Account Company Master Data)",
          description: "Description is not defined for the setup",
        },
        {
          id: "POConfigurationGroup",
          text: "PO Configuration Group",
          description: "A schema definition for Purchase Order Group setups",
        },
        {
          id: "POGroupCompany",
          text: "PO Group Company",
          description: "Description is not defined for the setup",
        },
        {
          id: "POGroupMembers",
          text: "PO Group Members",
          description: "Description is not defined for the setup",
        },
        {
          id: "POGroupTenantLink",
          text: "PO Group Tenant Link",
          description: "Description is not defined for the setup",
        },
        {
          id: "POGroups",
          text: "PO Groups",
          description: "Description is not defined for the setup",
        },
        {
          id: "POInvoiceStatus",
          text: "PO Invoice Status",
          description: "Description is not defined for the setup",
        },
        {
          id: "POItemBrand",
          text: "PO Item Brand",
          description: "Description is not defined for the setup",
        },
        {
          id: "POItemCategory",
          text: "PO Item Category",
          description: "Description is not defined for the setup",
        },
        {
          id: "POSecurityOperations",
          text: "PO Security Operation",
          description: "Description is not defined for the setup",
        },
        {
          id: "POShipVia",
          text: "PO Ship Via",
          description: "Description is not defined for the setup",
        },
        {
          id: "POStatus",
          text: "PO Status",
          description: "Description is not defined for the setup",
        },
        {
          id: "POTypes",
          text: "PO Types",
          description: "Description is not defined for the setup",
        },
        {
          id: "POUnitsOfMeasure",
          text: "PO Unit of Measure",
          description:
            "A schema definition for Purchase Order Units of Measure",
        },
        {
          id: "POVendorChangeControl",
          text: "PO Vendor Change Control",
          description: "A schema definition for po vendor change control",
        },
        {
          id: "RecurringJournalEntries",
          text: "Recurring Journal Entries",
          description:
            "A schema definition for accounting recurring journal entries setup item",
        },
        {
          id: "RemittanceFormMapping",
          text: "Remittance Form Mapping",
          description:
            "A schema definition for a Remittance Form Mapping object",
        },
        {
          id: "SaleChains",
          text: "Sale Chains",
          description:
            "A schema definition for COA related accounting sale chains setups",
        },
        {
          id: "Schedules",
          text: "Schedules",
          description: "The Schedules setup is not yet implemented",
        },
        {
          id: "VendorCategory",
          text: "Vendor Category",
          description: "A schema definition for vendor categories",
        },
        {
          id: "VendorCompanyType",
          text: "Vendor Company Type",
          description: "A schema definition for vendor company types",
        },
        {
          id: "VendorGLAccounts",
          text: "Vendor GL Accounts",
          description: "The Vendor GL Accounts setup is not yet implemented",
        },
        {
          id: "VendorPaymentTypes",
          text: "Vendor Payment Types",
          description:
            "A schema definition for Accounts Payable vendor payments types",
        },
        {
          id: "RemitToParent",
          text: "Vendor Remit To Parent",
          description: "A schema definition for Remit To Parent",
        },
        {
          id: "WriteOffs",
          text: "Write Offs",
          description:
            "A schema definition for accounting Write-Offs setup item",
        },
      ],
      departmentIds: [
        {
          departmentId: "D100096248",
          name: "BDC-A",
          storeId: "S100119370",
        },
        {
          departmentId: "D100096236",
          name: "PLF-A",
          storeId: "S100119371",
        },
        {
          departmentId: "D100096236",
          name: "PLF-A",
          storeId: "S100119373",
        },
      ],
    },
  };

export const MOCK_ACCOUNTS_PAYABLE_NON_CLEANSED_ROW_DATA: RowData = {
  tenant_id: "cbcfdfc5-d6f5-4a51-8f40-a2eda90c8c63",
  id: "2604785c-d133-4a49-917e-121232b09061",
  ref_number: "",
  ref_company: "",
  ref_store: "",
  ref_account: "",
  use_restricted_form_queue: false,
  void_vendor: "999",
  temp_account_payable_account: "1",
  ref_journal: "",
  share_check_number: "Separate check forms number series",
  sappck_security_code: "",
  reuse_check_number_password: "3445",
  retention_months: 30,
  reference_flag: "Invoice",
  temp_account_payable_company: "",
  temp_account_payable_store: "",
  overflow_remittance: "Print from separate laser tray",
  eiv_realtime: true,
  close_requires_schedules: false,
  print_data_format: "",
  check_date_format: "YYYY-MM-DD",
  accounts_payable_company: "7",
  accounts_payable_store: "S100119373",
  purchase_order_prompt: false,
  record_type: "Base",
  version: "V1",
  bp_id: "",
  store_id: "S100119372",
  accounts_payable_account: "10010",
  serial_no: 2156,
  enterprise_id: "E339440",
  active_status: "active",
  created_by: "sys-user-dms-admin",
  created_at: "2024-09-02T11:40:48.935+00:00",
  updated_by: "sys-user-dms-admin",
  updated_at: "2024-09-09T11:04:31.815+00:00",
  purchase_journal: [
    {
      ref_number: "",
      ref_company: "",
      ref_store: "",
    },
  ],
  trade_discount: [
    {
      ref_account: "",
      ref_company: "",
      ref_store: "",
    },
  ],
  cash_in_bank: [
    {
      ref_account: "",
      ref_company: "",
      ref_store: "",
    },
  ],
};

export const MOCK_ACCOUNTS_PAYABLE_CLEANSED_ROW_DATA: RowData = {
  tenant_id: "cbcfdfc5-d6f5-4a51-8f40-a2eda90c8c63",
  id: "2604785c-d133-4a49-917e-121232b09061",
  ref_number: null,
  ref_company: null,
  ref_store: null,
  ref_account: null,
  use_restricted_form_queue: false,
  void_vendor: "999",
  temp_account_payable_account: "1",
  ref_journal: null,
  share_check_number: "Separate check forms number series",
  sappck_security_code: null,
  reuse_check_number_password: "3445",
  retention_months: 30,
  reference_flag: "Invoice",
  temp_account_payable_company: null,
  temp_account_payable_store: null,
  overflow_remittance: "Print from separate laser tray",
  eiv_realtime: true,
  close_requires_schedules: false,
  print_data_format: null,
  check_date_format: "YYYY-MM-DD",
  accounts_payable_company: "7",
  accounts_payable_store: "S100119373",
  purchase_order_prompt: false,
  record_type: "Base",
  version: "V1",
  bp_id: null,
  store_id: "S100119372",
  accounts_payable_account: "10010",
  serial_no: 2156,
  enterprise_id: "E339440",
  active_status: "active",
  created_by: "sys-user-dms-admin",
  created_at: "2024-09-02T11:40:48.935+00:00",
  updated_by: "sys-user-dms-admin",
  updated_at: "2024-09-09T11:04:31.815+00:00",
  purchase_journal: [
    {
      ref_number: null,
      ref_company: null,
      ref_store: null,
    },
  ],
  trade_discount: [
    {
      ref_account: null,
      ref_company: null,
      ref_store: null,
    },
  ],
  cash_in_bank: [
    {
      ref_account: null,
      ref_company: null,
      ref_store: null,
    },
  ],
};

export const MOCK_ACCOUNTS_PAYABLE_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-accountspayable-schema.json",
  title: "AccountsPayable",
  description:
    "A flattened schema definition for an Accounts Payable open item setup object",
  type: "object",
  properties: {
    accounts_payable_account: {
      title: "Account",
      description: "Chart of Accounts Payable account",
      type: "string",
      isEditable: false,
      isUnique: true,
      disabled: true,
    },
    accounts_payable_company: {
      title: "Company",
      description: "Account payable company ",
      type: "string",
      minLength: 1,
      disabled: true,
    },
    purchase_order_prompt: {
      title: "Prompt for PO",
      description: "Prompt for PO number during enter invoices EIV function",
      default: false,
      type: "boolean",
    },
    check_date_format: {
      title: "Check date format",
      description: "The check date format to be used for print/display",
      type: ["string", "null"],
      enum: [
        "DDMMMYY",
        "M/DD/YY",
        "MMDDYY",
        "DDMMMYYYY",
        "MM/DD/YYYY",
        "YYYY-MM-DD",
        "DD.MM.YYYY",
        null,
      ],
      default: null,
    },
    print_data_format: {
      title: "Print date format",
      description: "Standard print data format indicator",
      type: ["string", "null"],
      enum: ["Laser AP format", "Laser ODC format", null],
      default: null,
    },
    close_requires_schedules: {
      title: "AP schedule required for closing",
      description: "Schedule required for month end flag",
      type: "boolean",
      default: true,
    },
    eiv_realtime: {
      title: "Eiv realtime",
      description: "Indicates if Realtime or Batch mode processing is used",
      type: "boolean",
      default: true,
    },
    overflow_remittance: {
      title: "Overflow remittance advice",
      description: "Remittance overflow during printing",
      type: ["string", "null"],
      enum: [
        "Print on check stubs",
        "Print on separate sheet",
        "Print from separate laser tray",
        null,
      ],
      default: null,
    },
    reference_flag: {
      title: "Journal entry reference",
      description: "Journal entries reference ",
      type: ["string", "null"],
      enum: ["Invoice", "PO", null],
      default: null,
    },
    retention_months: {
      title: "Retention months",
      description: "Number of months to keep check/invoice detail",
      type: "integer",
      minimum: 15,
      maximum: 96,
      default: 28,
    },
    reuse_check_number_password: {
      title: "Reuse check number password",
      description: "Enables the reuse check number feature in print checks ",
      type: ["string", "null"],
      pattern: "^[0-9]+$",
      minLength: 1,
      maxLength: 6,
      default: null,
    },
    sappck_security_code: {
      title: "SAP and PCK security code",
      description: "Security code for SAP and PCK functions",
      type: ["string", "null"],
      default: null,
    },
    share_check_number: {
      title: "Share check numbers",
      description: "Share check numbers between On Demand and AP checks",
      type: "string",
      default: "Same check forms number series as CHK",
      enum: [
        "Separate check forms number series",
        "Same check forms number series as CHK",
        "Do not keep retained check number",
      ],
    },
    temp_account_payable_company: {
      title: "Temporary accounts payable company",
      description: "Temporary accounts payable company number",
      type: ["string", "null"],
      default: null,
      disabled: true,
    },
    temp_account_payable_account: {
      title: "Temporary accounts payable account",
      description: "Temporary accounts payable account",
      type: ["string", "null"],
      default: null,
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
          ],
          responseFields: ["account_number", "account_description"],
        },
        storeId: "$temp_account_payable_store",
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    void_vendor: {
      title: "Void checks vendor number",
      description: "New vendor number for void checks",
      type: ["string", "null"],
      pattern: "^[a-zA-Z0-9]+$",
      default: null,
    },
    use_restricted_form_queue: {
      title: "Use restricted form queue",
      description: "Use restricted form queue for laser printing",
      default: true,
      type: "boolean",
    },
    is_vendor_editable: {
      title: "AP Invoice Vendor Editable Status",
      description: "Allow editing vendor number on an invoice with a PO",
      type: ["boolean", "null"],
      default: null,
    },
    ref_account: {
      title: "Account",
      description: "A valid account identifier",
      type: ["string", "null"],
      default: null,
    },
    ref_journal: {
      title: "Journal",
      description: "A valid journal identifier",
      type: ["string", "null"],
      default: null,
    },
    ref_company: {
      title: "Company",
      description: "A valid company identifier",
      type: ["string", "null"],
      default: null,
    },
    ref_store: {
      title: "Store",
      description: "Store for ref_company",
      type: ["string", "null"],
      default: null,
    },
    accounts_payable_store: {
      title: "Accounts Payable Store",
      description: "Store for accounts_payable_company",
      type: "string",
      isStore: true,
      isEditable: false,
      companyKey: "accounts_payable_company",
      dependentFields: ["accounts_payable_account"],
    },
    temp_account_payable_store: {
      title: "Temp Account Payable Store",
      description: "Store for temp_account_payable_company",
      type: ["string", "null"],
      isStore: true,
      companyKey: "temp_account_payable_company",
      dependentFields: ["temp_account_payable_account"],
    },
    ref_number: {
      title: "Number",
      description: "A valid purchase journal number",
      type: ["string", "null"],
      default: null,
    },
    record_type: {
      title: "Record type",
      description: "Identifies the flattened record type",
      type: "string",
      enum: [
        "Base",
        "Cash Disbursement",
        "Cash In Bank",
        "Trade Discount",
        "Purchase Journal",
      ],
      default: "Base",
    },
    cash_disbursement: {
      title: "Cash Disbursement",
      description: "Cash Disbursement",
      type: "array",
      items: {
        type: "object",
        properties: {
          ref_store: {
            title: "Store",
            type: "string",
            isStore: true,
            companyKey: "ref_company",
            dependentFields: ["ref_journal"],
          },
          ref_company: {
            title: "Company",
            type: "string",
            disabled: true,
          },
          ref_journal: {
            title: "Journal",
            type: "string",
            typeaheadConfig: {
              url: "/v2/search/Journals",
              storeId: "$ref_store",
              minChars: 2,
              body: {
                filters: [
                  {
                    field: "record_type",
                    operator: "EQUALS",
                    value: "Base",
                  },
                  {
                    field: "journal_type",
                    operator: "IN",
                    value: [
                      "Sales",
                      "Set Up Schedule Balances",
                      "Generic",
                      "Intercompany Transfer",
                      "Year-To-Date Adjustment",
                      "Install Account Balances",
                      "Accounts Receivable Finance Charge",
                      "Open-Item Payable",
                    ],
                  },
                ],
                responseFields: ["journal_id", "journal_name"],
              },
              valueField: "journal_id",
              labelField: ["journal_id", "journal_name"],
            },
          },
        },
        required: ["ref_journal", "ref_store", "ref_company"],
      },
    },
    cash_in_bank: {
      title: "Cash In Bank",
      description: "Cash In Bank",
      type: "array",
      items: {
        type: "object",
        properties: {
          ref_store: {
            title: "Store",
            type: "string",
            isStore: true,
            companyKey: "ref_company",
            dependentFields: ["ref_account"],
          },
          ref_company: {
            title: "Company",
            type: "string",
            disabled: true,
          },
          ref_account: {
            title: "Account",
            type: "string",
            typeaheadConfig: {
              url: "/v2/search/COA",
              minChars: 2,
              body: {
                filters: [
                  {
                    field: "record_type",
                    operator: "EQUALS",
                    value: "Base",
                  },
                  {
                    field: "sub_type",
                    operator: "EQUALS",
                    value: "Cash",
                  },
                ],
                responseFields: ["account_number", "account_description"],
              },
              valueField: "account_number",
              storeId: "$ref_store",
              labelField: ["account_number", "account_description"],
            },
          },
        },
        required: ["ref_account", "ref_store", "ref_company"],
      },
    },
    trade_discount: {
      title: "Trade Discount",
      description: "Trade Discount",
      type: "array",
      items: {
        type: "object",
        properties: {
          ref_store: {
            title: "Store",
            type: "string",
            isStore: true,
            companyKey: "ref_company",
            dependentFields: ["ref_account"],
          },
          ref_company: {
            title: "Company",
            type: "string",
            disabled: true,
          },
          ref_account: {
            title: "Account",
            type: "string",
            typeaheadConfig: {
              url: "/v2/search/COA",
              minChars: 2,
              body: {
                filters: [
                  {
                    field: "record_type",
                    operator: "EQUALS",
                    value: "Base",
                  },
                ],
                responseFields: ["account_number", "account_description"],
              },
              storeId: "$ref_store",
              valueField: "account_number",
              labelField: ["account_number", "account_description"],
            },
          },
        },
        required: ["ref_account", "ref_store", "ref_company"],
      },
    },
    purchase_journal: {
      title: "Purchase Journal",
      description: "Purchase Journal",
      type: "array",
      items: {
        type: "object",
        properties: {
          ref_store: {
            title: "Store",
            type: "string",
            isStore: true,
            companyKey: "ref_company",
            dependentFields: ["ref_number"],
          },
          ref_company: {
            title: "Company",
            type: "string",
            disabled: true,
          },
          ref_number: {
            type: "string",
            title: "Number",
            typeaheadConfig: {
              url: "/v2/search/Journals",
              minChars: 2,
              body: {
                filters: [
                  {
                    field: "record_type",
                    operator: "EQUALS",
                    value: "Base",
                  },
                  {
                    field: "journal_type",
                    operator: "IN",
                    value: [
                      "Accounts Receivable Finance Charge",
                      "Generic",
                      "Install Account Balances",
                      "Intercompany Transfer",
                      "Open-Item Payable",
                      "Sales",
                      "Set Up Schedule Balances",
                      "Year-To-Date Adjustment",
                    ],
                  },
                ],
                responseFields: ["journal_id", "journal_name"],
              },
              storeId: "$ref_store",
              valueField: "journal_id",
              labelField: ["journal_id", "journal_name"],
            },
          },
        },
        required: ["ref_number", "ref_store", "ref_company"],
      },
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    store_id: {
      title: "Store",
      description: "Store identifier",
      type: "string",
      minLength: 1,
    },
    tenant_id: {
      title: "Tenant",
      description: "Tenant identifier",
      type: "string",
      minLength: 1,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
      default: "inactive",
    },
    transaction_id: {
      title: "Transaction Id",
      description: "Transaction identifier",
      type: ["string", "null"],
      minLength: 1,
      default: null,
    },
  },
  required: [
    "accounts_payable_account",
    "accounts_payable_company",
    "close_requires_schedules",
    "retention_months",
    "share_check_number",
    "accounts_payable_store",
    "enterprise_id",
    "store_id",
  ],
  sections: {
    grid_fields: [
      "accounts_payable_account",
      "accounts_payable_company",
      "accounts_payable_store",
      "check_date_format",
      "reference_flag",
      "retention_months",
      "temp_account_payable_account",
    ],
    general_fields: [
      "accounts_payable_store",
      "accounts_payable_company",
      "accounts_payable_account",
      "reference_flag",
      "share_check_number",
      "retention_months",
      "temp_account_payable_company",
      "temp_account_payable_account",
      "check_date_format",
      "reuse_check_number_password",
    ],
    AP_options: ["close_requires_schedules", "is_vendor_editable"],
    corelation_fields: [
      "cash_disbursement",
      "cash_in_bank",
      "trade_discount",
      "purchase_journal",
    ],
  },
  sectionsInfo: {
    general_fields:
      "This section define the general setup for accounts payable including account information, check formatting",
    AP_options:
      "This section define the options for accounts payable processing.",
    cash_disbursement:
      "This section define the setup for cash disbursement transactions.",
    cash_in_bank:
      "This section define the setup for cash in bank transactions.",
    trade_discount:
      "This section define the setup for trade discount transactions.",
    purchase_journal:
      "This section define the setup for purchase journal transactions.",
  },
};

export const MOCK_ACCOUNTS_PAYABLE_ROW_DATA: RowData = {
  tenant_id: "cbcfdfc5-d6f5-4a51-8f40-a2eda90c8c63",
  id: "2604785c-d133-4a49-917e-121232b09061",
  ref_number: null,
  ref_company: null,
  ref_store: null,
  ref_account: null,
  use_restricted_form_queue: false,
  void_vendor: "999",
  temp_account_payable_account: "1",
  ref_journal: null,
  share_check_number: "Separate check forms number series",
  sappck_security_code: null,
  reuse_check_number_password: "3445",
  retention_months: 30,
  reference_flag: "Invoice",
  temp_account_payable_company: null,
  temp_account_payable_store: "S100119373",
  overflow_remittance: "Print from separate laser tray",
  eiv_realtime: true,
  close_requires_schedules: false,
  print_data_format: null,
  check_date_format: "YYYY-MM-DD",
  accounts_payable_company: "7",
  accounts_payable_store: "S100119373",
  purchase_order_prompt: false,
  record_type: "Base",
  version: "V1",
  bp_id: null,
  store_id: "S100119372",
  accounts_payable_account: "10010",
  serial_no: 2156,
  enterprise_id: "E339440",
  active_status: "active",
  created_by: "sys-user-dms-admin",
  created_at: "2024-09-02T11:40:48.935+00:00",
  updated_by: "sys-user-dms-admin",
  updated_at: "2024-09-09T11:04:31.815+00:00",
  purchase_journal: [
    {
      id: "5d28a60f-7e48-440b-b951-dce6844da22e",
      ref_number: "75",
      ref_company: "7",
      ref_store: "S100119373",
    },
  ],
  trade_discount: [
    {
      id: "c6443464-7063-4083-aaa6-bfce0138a839",
      ref_account: "94000",
      ref_company: "7",
      ref_store: "S100119373",
    },
  ],
  cash_in_bank: [
    {
      id: "b85ceb1f-4e25-4eb7-baee-e0224c474e54",
      ref_account: "2041",
      ref_company: "1",
      ref_store: "S100119367",
    },
  ],
  cash_disbursement: [
    {
      id: "d8a5988e-19bc-47fb-8619-64c8d0f948c2",
      ref_journal: "60",
      ref_company: "7",
      ref_store: "S100119373",
    },
  ],
};

export const MOCK_ACCOUNTS_PAYABLE_ROW_DATA_LIST: RowData[] = [
  {
    tenant_id: "cbcfdfc5-d6f5-4a51-8f40-a2eda90c8c63",
    id: "2604785c-d133-4a49-917e-121232b09061",
    ref_number: null,
    ref_company: null,
    ref_store: null,
    ref_account: null,
    use_restricted_form_queue: false,
    void_vendor: "999",
    temp_account_payable_account: "1",
    ref_journal: null,
    share_check_number: "Separate check forms number series",
    sappck_security_code: null,
    reuse_check_number_password: "3445",
    retention_months: 30,
    reference_flag: "Invoice",
    temp_account_payable_company: null,
    temp_account_payable_store: "",
    overflow_remittance: "Print from separate laser tray",
    eiv_realtime: true,
    close_requires_schedules: false,
    print_data_format: null,
    check_date_format: "YYYY-MM-DD",
    accounts_payable_company: "7",
    accounts_payable_store: "S100119373",
    purchase_order_prompt: false,
    record_type: "Base",
    version: "V1",
    bp_id: null,
    store_id: "S100119372",
    accounts_payable_account: "10010",
    serial_no: 2156,
    enterprise_id: "E339440",
    active_status: "active",
    created_by: "sys-user-dms-admin",
    created_at: "2024-09-02T11:40:48.935+00:00",
    updated_by: "sys-user-dms-admin",
    updated_at: "2024-09-09T11:04:31.815+00:00",
    purchase_journal: [
      {
        id: "5d28a60f-7e48-440b-b951-dce6844da22e",
        ref_number: "75",
        ref_company: "7",
        ref_store: "S100119373",
      },
    ],
    trade_discount: [
      {
        id: "c6443464-7063-4083-aaa6-bfce0138a839",
        ref_account: "94000",
        ref_company: "7",
        ref_store: "S100119373",
      },
    ],
    cash_in_bank: [
      {
        id: "b85ceb1f-4e25-4eb7-baee-e0224c474e54",
        ref_account: "2041",
        ref_company: "1",
        ref_store: "S100119367",
      },
    ],
    cash_disbursement: [
      {
        id: "d8a5988e-19bc-47fb-8619-64c8d0f948c2",
        ref_journal: "60",
        ref_company: "7",
        ref_store: "S100119373",
      },
    ],
  },
];

export const MOCK_ACCOUNTS_PAYABLE_COL_DEFS: ColDef[] = [
  {
    field: "accounts_payable_store",
    headerName: "Accounts Payable Store",
  },
  {
    field: "accounts_payable_company",
    headerName: "Company",
  },
  {
    field: "accounts_payable_account",
    headerName: "Account",
  },
  {
    field: "void_vendor",
    headerName: "Void checks vendor number",
  },
  {
    field: "reference_flag",
    headerName: "Journal entry reference",
  },
  {
    field: "purchase_order_prompt",
    headerName: "Prompt for PO",
  },
  {
    field: "overflow_remittance",
    headerName: "Overflow remittance advice",
  },
  {
    field: "share_check_number",
    headerName: "Share check numbers",
  },
  {
    field: "close_requires_schedules",
    headerName: "Close requires schedules",
  },
  {
    field: "eiv_realtime",
    headerName: "Eiv realtime",
  },
  {
    field: "retention_months",
    headerName: "Retention months",
  },
  {
    field: "temp_account_payable_store",
    headerName: "Temp Account Payable Store",
  },
  {
    field: "temp_account_payable_company",
    headerName: "Temporary accounts payable company",
  },
  {
    field: "temp_account_payable_account",
    headerName: "Temporary accounts payable account",
  },
  {
    field: "check_date_format",
    headerName: "Check date format",
  },
  {
    field: "print_data_format",
    headerName: "Print date format",
  },
  {
    field: "sappck_security_code",
    headerName: "SAP and PCK security code",
  },
  {
    field: "reuse_check_number_password",
    headerName: "Reuse check number password",
  },
  {
    field: "use_restricted_form_queue",
    headerName: "Use restricted form queue",
  },
  {
    field: "cash_disbursement",
    headerName: "Cash Disbursement Journal",
  },
  {
    field: "cash_in_bank",
    headerName: "Cash In Bank Accounts",
  },
  {
    field: "trade_discount",
    headerName: "Trade Discount",
  },
  {
    field: "purchase_journal",
    headerName: "Purchase Journal",
  },
];

export const MOCK_JOURNALS_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-journals-schema.json",
  title: "Journals",
  description: "A schema definition for accounting journal setup item",
  type: "object",
  properties: {
    journal_id: {
      title: "Journal ID",
      description: "Journal identifier",
      type: "string",
      pattern: "^[A-Z0-9]{1,5}$",
      isEditable: false,
      isUnique: true,
    },
    journal_name: {
      title: "Journal Name",
      description: "Journal description",
      type: "string",
      pattern: "^.{1,30}$",
    },
    journal_type: {
      title: "Journal type",
      description: "Journal type",
      type: "string",
      minLength: 1,
      enum: [
        "Accounts Receivable Finance Charge",
        "Financial Statement Statistical",
        "Generic",
        "Install Account Balances",
        "Intercompany Transfer",
        "Open-Item Cash Receipt",
        "Open-Item Payable",
        "Sales",
        "Schedule Changes",
        "Set Up History",
        "Set Up Schedule Balances",
        "Year-To-Date Adjustment",
      ],
      isEditable: false,
    },
    allow_inter_company_postings: {
      title: "Inter-Company Postings",
      description: "Allow intercompany postings in this journal",
      default: false,
      type: "boolean",
    },
    agje_default_document_type: {
      title: "AGJE Default Document Type",
      description: "AGJE Default Document Type",
      type: "string",
      enum: [
        "Cash Receipt",
        "Check",
        "Dealer Trade",
        "FMLR Credit Memo",
        "FMLR Invoice",
        "Finance Charge",
        "Journal Voucher",
        "Manufacturer Document",
        "Other",
        "Parts Credit Memo",
        "Parts Invoice",
        "Payable Invoice",
        "Recurring Entry",
        "Repair Order Invoice",
        "Vehicle Purchase Invoice",
        "Vehicle Sale Invoice",
        "Payroll",
      ],
    },
    horizontal_journal_format: {
      title: "Horizontal Format",
      description: "Horizontal journal format code",
      type: "string",
      enum: [
        "Sales-Cst-Asset-Liab-Exp",
        "Asset-Liab-Exp-Other",
        "Asset-Exp-Other",
      ],
    },
    restricted_access: {
      title: "Restrict Online Inquiry",
      description: "Restricted account flag",
      default: false,
      type: "boolean",
    },
    restrict_posting: {
      title: "Restrict Posting",
      description: "Restricted posting flag",
      default: false,
      type: "boolean",
    },
    require_je_description: {
      title: "Require JE Description",
      description:
        "Require a journal entry description for every entry in the journal",
      default: false,
      type: "boolean",
    },
    journal_begin_date: {
      title: "Begin date",
      description: "Date posting was allowed to this journal. ",
      type: "string",
      minLength: 1,
      format: "date",
    },
    journal_end_date: {
      title: "End date",
      description: "Last date when this record is valid.",
      type: ["string", "null"],
      format: "date",
      default: null,
    },
    warn_cost_account_without_sale: {
      title: "Warn Cost Account without Sale",
      description:
        "Warn the user that a cost account was entered without a sale account",
      default: false,
      type: "boolean",
    },
    remove_previous_sale_date: {
      title: "Remove Previous Sale Date",
      description:
        "Flag to determine whether or not to prompt to remove the sold date during posting",
      default: false,
      type: "boolean",
    },
    repeat_prior_control: {
      title: "Repeat Prior Control",
      description:
        "Flag to use the same control for an account type each time the account type is used within a posting",
      default: false,
      type: "boolean",
    },
    restrict_calendar_post: {
      title: "Restrict Calendar Post",
      description:
        "Calendar year posting restriction flag for journal type year-to-date adjustments.",
      default: false,
      type: "boolean",
    },
    repeat_previously_entered_account: {
      title: "Repeat Prior Account",
      description:
        "Flag to repeat the previously entered account. Indicates if journal uses the repeat option.",
      default: false,
      type: "boolean",
    },
    months_to_retain_journal_data: {
      default: null,
      description: "Months to retain this journal's data",
      pattern: "^([1-9]|[1-9][0-9]|null)$",
      title: "Journal Retention",
      type: ["integer", "null"],
    },
    record_type: {
      title: "Record type",
      description:
        "Identifies the de-normalized record types associated with the schema",
      type: "string",
      enum: ["Base", "Journal Template Reference", "Recurring Entry Reference"],
      default: "Base",
    },
    journal_template_reference: {
      title: "Journal Template Reference",
      description: "Journal Template Reference",
      key: "record_type_ref",
      type: "array",
      items: {
        type: "string",
      },
      typeaheadConfig: {
        url: "/v2/search/JournalTemplates",
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
          ],
          responseFields: ["template_id", "template_description"],
        },
        valueField: "template_id",
        labelField: ["template_id", "template_description"],
      },
    },
    recurring_entry_reference: {
      title: "Recurring Entry Reference",
      description: "Recurring Entry Reference",
      type: "array",
      key: "record_type_ref",
      items: {
        type: "string",
      },
      typeaheadConfig: {
        url: "/v2/search/RecurringJournalEntries",
        body: {
          filters: [
            {
              field: "journal_id",
              operator: "EQUALS",
              value: "$journal_id",
            },
          ],
          responseFields: ["recurring_je_reference_number", "je_description"],
        },
        valueField: "recurring_je_reference_number",
        labelField: ["recurring_je_reference_number", "je_description"],
      },
    },
    record_type_ref: {
      title: "Template/Recurring Entry Reference",
      description:
        "Reference ID to a Journal Template or Recurring Entry Item. Record Type Dependent",
      type: ["string", "null"],
      default: null,
    },
    created_by: {
      title: "Created By",
      description: "Party responsible for new record item construction.",
      type: "string",
      minLength: 1,
    },
    created_at: {
      title: "Created Date Time",
      description: "Date and Time of new record construction.",
      type: "string",
      minLength: 1,
    },
    updated_by: {
      title: "Last Updated By",
      description: "Party that performed the last record update. Required.",
      type: ["string", "null"],
      minLength: 1,
      default: null,
    },
    updated_at: {
      title: "Last Updated Date Time",
      description: "Last Date and Time the record was updated. Required.",
      type: ["string", "null"],
      minLength: 1,
      default: null,
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    store_id: {
      title: "Store",
      description: "Store identifier",
      type: "string",
      minLength: 1,
    },
    tenant_id: {
      title: "Tenant",
      description: "Tenant identifier",
      type: "string",
      minLength: 1,
    },
    company_id: {
      title: "Company ID",
      description: "Company identifier",
      type: ["string", "null"],
      pattern: "^[A-Z0-9]{1,3}$",
      default: null,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
      default: "inactive",
    },
    bp_id: {
      title: "Best practice ID",
      description:
        "Identifies the best practice template used to instantiate the object values",
      type: ["string", "null"],
      default: null,
    },
    version: {
      title: "Version",
      description: "Identifies the data version associated with the schema",
      type: "string",
      minLength: 1,
      default: "1",
    },
  },
  required: [
    "created_by",
    "created_at",
    "updated_by",
    "updated_at",
    "enterprise_id",
    "store_id",
    "tenant_id",
    "company_id",
    "active_status",
    "bp_id",
    "version",
    "record_type",
    "journal_id",
    "journal_name",
    "journal_begin_date",
    "journal_end_date",
    "journal_type",
    "allow_inter_company_postings",
    "require_je_description",
    "agje_default_document_type",
    "warn_cost_account_without_sale",
    "repeat_prior_control",
    "horizontal_journal_format",
    "remove_previous_sale_date",
    "restrict_calendar_post",
    "months_to_retain_journal_data",
    "repeat_previously_entered_account",
    "restricted_access",
    "restrict_posting",
    "record_type_ref",
  ],
  sections: {
    grid_fields: [
      "journal_id",
      "journal_name",
      "journal_type",
      "allow_inter_company_postings",
      "journal_begin_date",
      "journal_end_date",
    ],
    general_fields: [
      "journal_id",
      "journal_name",
      "journal_type",
      "allow_inter_company_postings",
      "agje_default_document_type",
      "horizontal_journal_format",
      "restricted_access",
      "restrict_posting",
      "require_je_description",
      "journal_begin_date",
      "journal_end_date",
      "warn_cost_account_without_sale",
      "remove_previous_sale_date",
      "repeat_prior_control",
      "restrict_calendar_post",
      "repeat_previously_entered_account",
      "months_to_retain_journal_data",
      "journal_template_reference",
      "recurring_entry_reference",
    ],
    corelation_fields: [],
  },
};

export const MOCK_JOURNALS_ROW_DATA: RowData = {
  id: "55c23405-d214-4c14-9c62-a32fb7987fa5",
  tenant_id: "cbcfdfc5-d6f5-4a51-8f40-a2eda90c8c63",
  version: null,
  company_id: "2",
  bp_id: null,
  restrict_posting: true,
  store_id: "S100119371",
  record_type_ref: null,
  months_to_retain_journal_data: 24,
  restricted_access: true,
  restrict_calendar_post: true,
  repeat_previously_entered_account: true,
  remove_previous_sale_date: true,
  horizontal_journal_format: "Sales-Cst-Asset-Liab-Exp",
  agje_default_document_type: "Cash Receipt",
  repeat_prior_control: true,
  allow_inter_company_postings: true,
  require_je_description: true,
  journal_type: "Financial Statement Statistical",
  warn_cost_account_without_sale: true,
  journal_name: "Sample4",
  journal_id: "2",
  journal_end_date: "01/01/21",
  record_type: "Base",
  journal_begin_date: "01/01/2024",
  serial_no: 6067,
  enterprise_id: "E339440",
  active_status: "active",
  created_by: "sys-user-dms-admin",
  created_at: "2024-08-31T09:20:11.764+00:00",
  updated_by: "sys-user-dms-admin",
  updated_at: "2024-09-02T07:15:42.552+00:00",
  journal_template_reference: [
    {
      id: "cde3ee1a-c1a1-4a85-8dce-87035a84b609",
      record_type_ref: null,
    },
    {
      id: "1b19f50e-f5b7-4046-bcdb-2262704825c0",
      record_type_ref: "100",
    },
  ],
};

export const MOCK_JOURNALS_ROW_DATA_LIST: RowData[] = [
  {
    id: "55c23405-d214-4c14-9c62-a32fb7987fa5",
    tenant_id: "cbcfdfc5-d6f5-4a51-8f40-a2eda90c8c63",
    version: null,
    company_id: "2",
    bp_id: null,
    restrict_posting: true,
    store_id: "S100119371",
    record_type_ref: null,
    months_to_retain_journal_data: 24,
    restricted_access: true,
    restrict_calendar_post: true,
    repeat_previously_entered_account: true,
    remove_previous_sale_date: true,
    horizontal_journal_format: "Sales-Cst-Asset-Liab-Exp",
    agje_default_document_type: "Cash Receipt",
    repeat_prior_control: true,
    allow_inter_company_postings: true,
    require_je_description: true,
    journal_type: null,
    warn_cost_account_without_sale: true,
    journal_name: "Sample4",
    journal_id: "2",
    journal_end_date: "01/01/21",
    record_type: "Base",
    journal_begin_date: "01/01/2024",
    serial_no: 6067,
    enterprise_id: "E339440",
    active_status: "active",
    created_by: "sys-user-dms-admin",
    created_at: "2024-08-31T09:20:11.764+00:00",
    updated_by: "sys-user-dms-admin",
    updated_at: "2024-09-02T07:15:42.552+00:00",
    journal_template_reference: [
      {
        id: "cde3ee1a-c1a1-4a85-8dce-87035a84b609",
        record_type_ref: null,
      },
      {
        id: "1b19f50e-f5b7-4046-bcdb-2262704825c0",
        record_type_ref: "100",
      },
    ],
    recurring_entry_reference: [],
  },
  {
    id: "1f5f63fd-7db0-4ec7-bf35-ee675c5a692b",
    tenant_id: "cbcfdfc5-d6f5-4a51-8f40-a2eda90c8c63",
    version: null,
    company_id: "3",
    bp_id: null,
    restrict_posting: true,
    store_id: "S100119371",
    record_type_ref: null,
    months_to_retain_journal_data: 24,
    restricted_access: true,
    restrict_calendar_post: true,
    repeat_previously_entered_account: true,
    remove_previous_sale_date: true,
    horizontal_journal_format: "Sales-Cst-Asset-Liab-Exp",
    agje_default_document_type: "Cash Receipt",
    repeat_prior_control: true,
    allow_inter_company_postings: true,
    require_je_description: true,
    journal_type: "Financial Statement Statistical",
    warn_cost_account_without_sale: true,
    journal_name: "Sample4",
    journal_id: "7",
    journal_end_date: "2024-09-28",
    record_type: "Base",
    journal_begin_date: "2024-09-25",
    serial_no: 6302,
    enterprise_id: "E339440",
    active_status: "active",
    created_by: "sys-user-dms-admin",
    created_at: "2024-09-11T02:39:36.648+00:00",
    updated_by: "sys-user-dms-admin",
    updated_at: "2024-09-25T17:24:28.174+00:00",
    journal_template_reference: [
      {
        id: "e3dec098-feba-4a56-abdd-3b3ef306ebbe",
        record_type_ref: "100",
      },
    ],
    recurring_entry_reference: [],
  },
];

export const MOCK_JOURNALS_COL_DEFS: ColDef[] = [
  {
    field: "journal_id",
    headerName: "Journal ID",
  },
  {
    field: "journal_name",
    headerName: "Journal Name",
  },
  {
    field: "journal_type",
    headerName: "Journal type",
  },
  {
    field: "allow_inter_company_postings",
    headerName: "Inter-Company Postings",
  },
  {
    field: "agje_default_document_type",
    headerName: "AGJE Default Document Type",
  },
  {
    field: "horizontal_journal_format",
    headerName: "Horizontal Format",
  },
  {
    field: "restricted_access",
    headerName: "Restrict Online Inquiry",
  },
  {
    field: "restrict_posting",
    headerName: "Restrict Posting",
  },
  {
    field: "require_je_description",
    headerName: "Require JE Description",
  },
  {
    field: "journal_begin_date",
    headerName: "Begin date",
  },
  {
    field: "journal_end_date",
    headerName: "End date",
  },
  {
    field: "warn_cost_account_without_sale",
    headerName: "Warn Cost Account without Sale",
  },
  {
    field: "remove_previous_sale_date",
    headerName: "Remove Previous Sale Date",
  },
  {
    field: "repeat_prior_control",
    headerName: "Repeat Prior Control",
  },
  {
    field: "restrict_calendar_post",
    headerName: "Restrict Calendar Post",
  },
  {
    field: "repeat_previously_entered_account",
    headerName: "Repeat Prior Account",
  },
  {
    field: "months_to_retain_journal_data",
    headerName: "Journal Retention",
  },
  {
    field: "journal_template_reference",
    headerName: "Journal Template Reference",
  },
  {
    field: "recurring_entry_reference",
    headerName: "Recurring Entry Reference",
  },
];

export const MOCK_CHART_OF_ACCOUNTS_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-coa-schema.json",
  title: "ChartOfAccounts",
  description: "A flattened schema definition for a COA setup item",
  functional_area: "ACCT",
  type: "object",
  properties: {
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    store_id: {
      title: "Store",
      description: "Store identifier",
      type: "string",
      minLength: 1,
    },
    tenant_id: {
      title: "Tenant",
      description: "Tenant identifier",
      type: "string",
      minLength: 1,
    },
    company_id: {
      title: "Company",
      description: "Company identifier",
      type: ["string", "null"],
      default: null,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
      default: "inactive",
    },
    bp_id: {
      title: "Best practice ID",
      description:
        "Identifies the best practice template used to instantiate the object values",
      type: ["string", "null"],
      default: null,
    },
    version: {
      title: "Version",
      description: "Identifies the schema version",
      type: "string",
      minLength: 1,
      default: "1",
    },
    record_type: {
      title: "Record type",
      description:
        "Identifies the de-normalized record types associated with the schema",
      type: "string",
      enum: [
        "Base",
        "Sale Chain Reference",
        "Report Group Codes",
        "Detail Forward Schedule",
        "Balance Forward Schedule",
        "Productivity Schedule",
        "Current Month Schedule",
        "Cash In Bank Report",
      ],
      default: "Base",
    },
    account_number: {
      title: "Account number",
      description: "COA number",
      type: "string",
      pattern: "^[A-Z0-9]+$",
      minLength: 1,
      maxLength: 7,
      isEditable: false,
    },
    account_description: {
      title: "Account description",
      description: "COA description",
      type: "string",
      minLength: 1,
    },
    account_type: {
      title: "Account type",
      description: "COA type",
      type: "string",
      enum: [
        "Asset",
        "Cost Of Sale",
        "Operating Expense",
        "Non-operating Income",
        "Liability",
        "Equity",
        "Memo",
        "Expense Allocation",
        "Sale",
        "Non-operating Expense",
      ],
    },
    sub_type: {
      title: "Account sub type",
      description: "COA subtype",
      type: ["string", "null"],
      enum: [
        "Cash",
        "Inter-Company",
        "Vehicle Inventory",
        "Profit",
        "Retained Earnings",
        "Balance-forward Payable",
        "Vehicle Sale",
        "Open-Item Payable",
        "Open-Item Receivable",
        "Balance-forward Receivable",
        null,
      ],
      default: null,
    },
    begin_date: {
      title: "Account begin date",
      description: "COA begin date for this setup",
      type: "string",
      format: "date",
    },
    end_date: {
      title: "Account end date",
      description: "COA end date for this setup",
      type: ["string", "null"],
      format: "date",
      default: null,
    },
    statistical_count_type_code: {
      title: "Statistical count type code",
      description: "COA statistical count type code",
      type: "string",
      enum: ["No count", "Auto count", "Auto count with override"],
      default: "No count",
    },
    ar_schedule_code: {
      title: "Accounts receivable schedule",
      description: "COA receivable schedule code",
      type: ["string", "null"],
      pattern: "^[A-Y]+$",
      default: null,
      disabled: true,
    },
    productivity_type_code: {
      title: "Productivity type",
      description: "COA productivity type code",
      type: "string",
      enum: ["None", "Salesperson", "Service Advisor/Technician"],
      default: "None",
    },
    control_type_code: {
      title: "Control type",
      description: "COA control type code",
      type: "string",
      enum: [
        "None",
        "Vehicle Receivable Customer",
        "Vendor",
        "Miscellaneous",
        "A/R Customer",
        "Vehicle",
        "Cash Customer",
        "Salesperson",
        "Service Advisor or Technician",
        "Company",
        "Reference",
        "Pattern",
        "Required, not validated",
      ],
      default: "None",
    },
    control2_type_code: {
      title: "Control2 type",
      description: "COA control2 type code",
      type: "string",
      enum: ["None", "Vehicle", "Required, not validated"],
      default: "None",
    },
    is_posting_description_required: {
      title: "Posting description required",
      description: "COA posting description flag",
      default: true,
      type: "boolean",
    },
    income_balance_group_code: {
      title: "Income balance group",
      description: "COA income balance report group code",
      pattern: "^[A-Z0-9]{3}$",
      type: ["string", "null"],
      default: null,
      evalMethod: "updateCOAGroupCodeDescription",
      typeaheadConfig: {
        url: "/v2/search/GroupCodes",
        body: {
          filters: [
            {
              field: "group_code_type",
              operator: "EQUALS",
              value: "Income/Balance Report Group",
            },
          ],
          responseFields: ["group_code_id", "group_code_description"],
        },
        valueField: "group_code_id",
        labelField: ["group_code_id", "group_code_description"],
      },
    },
    income_balance_group_description: {
      title: "Income balance group description",
      description: "COA income balance report group description",
      type: ["string", "null"],
      default: null,
      disabled: true,
    },
    income_balance_sub_group_code: {
      title: "Income balance sub group",
      description: "COA income balance report sub group code",
      type: ["string", "null"],
      pattern: "^[A-Z0-9]{3}$",
      default: null,
      evalMethod: "updateCOAGroupCodeDescription",
      typeaheadConfig: {
        url: "/v2/search/GroupCodes",
        body: {
          filters: [
            {
              field: "group_code_type",
              operator: "EQUALS",
              value: "Income/Balance Report Subgroup",
            },
          ],
          responseFields: ["group_code_id", "group_code_description"],
        },
        valueField: "group_code_id",
        labelField: ["group_code_id", "group_code_description"],
      },
    },
    income_balance_sub_group_description: {
      title: "Income balance sub group description",
      description: "COA income balance report sub group description",
      type: ["string", "null"],
      default: null,
      disabled: true,
    },
    control_type_pattern: {
      title: "Control type 11 pattern",
      description: "COA control type pattern for control type 11",
      type: ["string", "null"],
      default: null,
    },
    unit_analysis_group_code: {
      title: "Unit analysis group",
      description: "COA unit analysis report group code",
      type: ["string", "null"],
      pattern: "^[A-Z0-9]{3}$",
      default: null,
      evalMethod: "updateCOAGroupCodeDescription",
      typeaheadConfig: {
        url: "/v2/search/GroupCodes",
        body: {
          filters: [
            {
              field: "group_code_type",
              operator: "EQUALS",
              value: "Unit Analysis Report Group",
            },
          ],
          responseFields: ["group_code_id", "group_code_description"],
        },
        valueField: "group_code_id",
        labelField: ["group_code_id", "group_code_description"],
      },
    },
    unit_analysis_group_description: {
      title: "Unit analysis group description",
      description: "COA unit analysis report group description",
      type: ["string", "null"],
      default: null,
      disabled: true,
    },
    is_restricted_account: {
      title: "Account view restricted",
      description:
        "COA restrict access flag. Restrict users from viewing account information.",
      default: true,
      type: "boolean",
    },
    swr_tech_flag: {
      title: "Account control advice",
      description:
        "COA use service writer or technician as control advice flag.",
      type: ["string", "null"],
      enum: [
        "Use service writer as control for account",
        "Use technician as control for account",
        null,
      ],
      default: null,
    },
    is_lr_profit_loss_account: {
      title: "LR Profit and Loss account",
      description: "COA LR flag.",
      default: true,
      type: "boolean",
    },
    is_fml_profit_loss_account: {
      title: "FML Profit and Loss account",
      description:
        "COA LSE flag. Indicates if account is used for FML&R profit and loss",
      default: true,
      type: "boolean",
    },
    department: {
      title: "Department activity ID",
      description: "COA department activity identifier",
      type: ["string", "null"],
      default: null,
      typeaheadConfig: {
        url: "/v2/search/Departments",
        body: {
          filters: [],
          responseFields: ["department_code", "department_name"],
        },
        valueField: "department_code",
        labelField: ["department_code", "department_name"],
      },
    },
    ih_type: {
      title: "Navistar FS type",
      description: "COA Navistar financial statement type",
      type: ["string", "null"],
      default: null,
    },
    report_group_code: {
      title: "Report group codes",
      description: "Report group code",
      type: ["string", "null"],
      default: null,
    },
    schedule_type_number_ref: {
      title: "Schedule number",
      description: "A schedule number associated with the schedule type code",
      type: ["string", "null"],
      default: null,
    },
    cash_in_bank_report_number: {
      title: "Cash In Bank Report Number",
      description: "Identifies one of 0-N possible CIB report numbers",
      type: ["string", "null"],
      default: null,
    },
    sale_chain_id: {
      title: "Sale Chain ID",
      description: "Sale account identifier that chains to this COA",
      type: ["string", "null"],
      default: null,
    },
    report_group_codes: {
      title: "Report Group Codes",
      description: "Report Group Codes",
      key: "report_group_code",
      type: "array",
      items: {
        type: "string",
      },
      typeaheadConfig: {
        url: "/v2/search/GroupCodes",
        body: {
          filters: [
            {
              field: "group_code_type",
              operator: "EQUALS",
              value: "User Defined Report Group",
            },
          ],
          responseFields: ["group_code_id", "group_code_description"],
        },
        valueField: "group_code_id",
        labelField: ["group_code_id", "group_code_description"],
      },
    },
    sale_chain_reference: {
      title: "Sale Chain Reference",
      description: "Sale Chain Reference",
      key: "sale_chain_id",
      type: "array",
      items: {
        type: "string",
      },
      disabled: true,
    },
    cash_in_bank_report: {
      title: "Cash In Bank Report",
      description: "Cash In Bank Report",
      key: "cash_in_bank_report_number",
      type: "array",
      items: {
        type: "string",
      },
      disabled: true,
    },
    balance_forward_schedule: {
      title: "Balance Forward Schedule",
      description: "Balance Forward Schedule",
      key: "schedule_type_number_ref",
      type: "array",
      items: {
        type: "string",
      },
      disabled: true,
    },
    detail_forward_schedule: {
      title: "Detail Forward Schedule",
      description: "Detail Forward Schedule",
      key: "schedule_type_number_ref",
      type: "array",
      items: {
        type: "string",
      },
      disabled: true,
    },
    productivity_forward_schedule: {
      title: "Productivity Forward Schedule",
      description: "Productivity Forward Schedule",
      key: "schedule_type_number_ref",
      type: "array",
      items: {
        type: "string",
      },
      disabled: true,
    },
    current_month_schedule: {
      title: "Current Month Schedule",
      description: "Current Month Schedule",
      key: "schedule_type_number_ref",
      type: "array",
      items: {
        type: "string",
      },
      disabled: true,
    },
  },
  required: [
    "enterprise_id",
    "store_id",
    "tenant_id",
    "company_id",
    "active_status",
    "bp_id",
    "version",
    "record_type",
    "account_number",
    "account_description",
    "account_type",
    "sub_type",
    "begin_date",
    "end_date",
    "statistical_count_type_code",
    "ar_schedule_code",
    "productivity_type_code",
    "control_type_code",
    "control2_type_code",
    "is_posting_description_required",
    "income_balance_group_code",
    "income_balance_group_description",
    "income_balance_sub_group_code",
    "income_balance_sub_group_description",
    "control_type_pattern",
    "unit_analysis_group_code",
    "unit_analysis_group_description",
    "is_restricted_account",
    "swr_tech_flag",
    "is_lr_profit_loss_account",
    "is_fml_profit_loss_account",
    "department",
    "ih_type",
    "report_group_code",
    "schedule_type_number_ref",
    "cash_in_bank_report_number",
    "sale_chain_id",
  ],
  dependencies: MOCK_CHART_OF_ACCOUNTS_DEPENDENCIES,
  sections: {
    grid_fields: [
      "account_number",
      "account_description",
      "account_type",
      "sub_type",
      "begin_date",
    ],
    general_fields: [
      "account_number",
      "account_description",
      "account_type",
      "sub_type",
      "begin_date",
      "end_date",
      "control_type_code",
      "control2_type_code",
      "productivity_type_code",
      "statistical_count_type_code",
      "is_posting_description_required",
      "department",
      "income_balance_group_code",
      "income_balance_group_description",
      "income_balance_sub_group_code",
      "income_balance_sub_group_description",
      "unit_analysis_group_code",
      "unit_analysis_group_description",
      "report_group_code",
      "control_type_pattern",
      "is_restricted_account",
      "ar_schedule_code",
      "ih_type",
      "swr_tech_flag",
      "is_lr_profit_loss_account",
      "is_fml_profit_loss_account",
      "report_group_codes",
      "sale_chain_reference",
      "cash_in_bank_report",
      "balance_forward_schedule",
      "detail_forward_schedule",
      "productivity_forward_schedule",
      "current_month_schedule",
    ],
    corelation_fields: [],
  },
};

export const MOCK_CHART_OF_ACCOUNTS_ROW_DATA: RowData = {
  id: "d963ed97-c7c4-42e6-9496-645f5adfb7f7",
  tenant_id: "cbcfdfc5-d6f5-4a51-8f40-a2eda90c8c63",
  store_id: "S100119371",
  company_id: null,
  bp_id: null,
  version: null,
  record_type: "Base",
  account_number: "66201",
  account_description: "Cypress Test",
  account_type: "Asset",
  sub_type: "Inter-Company",
  begin_date: "2024-12-03",
  end_date: "2024-12-16",
  statistical_count_type_code: "No count",
  ar_schedule_code: null,
  productivity_type_code: "None",
  control_type_code: "None",
  control2_type_code: "None",
  is_posting_description_required: true,
  income_balance_group_code: null,
  income_balance_group_description: null,
  income_balance_sub_group_code: null,
  income_balance_sub_group_description: null,
  control_type_pattern: null,
  unit_analysis_group_code: null,
  unit_analysis_group_description: null,
  is_restricted_account: false,
  swr_tech_flag: null,
  is_lr_profit_loss_account: true,
  is_fml_profit_loss_account: true,
  department: null,
  ih_type: null,
  report_group_code: null,
  schedule_type_number_ref: null,
  sale_chain_id: null,
  cash_in_bank_report_number: null,
  transaction_id: null,
  serial_no: 206411,
  enterprise_id: "E339440",
  active_status: "active",
  created_by: "sys-user-dms-admin",
  created_at: "2024-12-02T06:57:07.858+00:00",
  updated_by: "sys-user-dms-admin",
  updated_at: "2025-01-09T16:13:16.961+00:00",
};

export const MOCK_ACCOUNTS_RECEIVABLE_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-ar-schema.json",
  title: "AccountsReceivable",
  description: "A schema definition for an Accounts Receivable object",
  type: "object",
  properties: {
    ar_store: {
      title: "AR Store",
      description: "Store for ar_company",
      type: "string",
      isStore: true,
      isEditable: false,
      companyKey: "ar_company",
      dependentFields: ["ar_account"],
    },
    ar_company: {
      title: "AR Company",
      description: "AR Company used for this setup",
      type: "string",
      disabled: true,
    },
    ar_account: {
      title: "AR Account",
      description: "Chart account used for this setup",
      type: "string",
      isEditable: false,
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "account_type",
              operator: "EQUALS",
              value: "Asset",
            },
            {
              field: "sub_type",
              operator: "EQUALS",
              value: null,
            },
          ],
          responseFields: ["account_number", "account_description"],
        },
        storeId: "$ar_store",
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    sub_type: {
      title: "Acct Sub type",
      description: "OB or BF",
      type: "string",
      enum: ["Open-Item Receivable", "Balance-forward Receivable"],
      evalMethod: "getAccountsReceivableScheduleCode",
      isEditable: false,
    },
    schedule_code: {
      title: "Schedule Code",
      description: "Schedule code",
      type: "string",
      pattern: "^[A-Z]$",
      isUnique: true,
      disabled: true,
      evalMethod: "getAccountsReceivableSubType",
    },
    schedule_title: {
      title: "Schedule Title",
      description: "Schedule title",
      type: "string",
      default: "AR PARTS AND SERVICE",
    },
    finance_charge_jrnl_store: {
      title: "FC Journal Company",
      description: "FC journal company",
      type: "string",
      isStore: true,
      companyKey: "finance_charge_jrnl_company",
      dependentFields: ["finance_charge_jrnl"],
    },
    finance_charge_jrnl_company: {
      title: "FC Journal Company",
      description: "FC journal company",
      type: "string",
      disabled: true,
    },
    finance_charge_jrnl: {
      title: "FC Journal",
      description: "FC journal",
      type: "string",
      typeaheadConfig: {
        url: "/v2/search/Journals",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "journal_type",
              operator: "EQUALS",
              value: "Accounts Receivable Finance Charge",
            },
          ],
          responseFields: ["journal_id", "journal_name"],
        },
        storeId: "$finance_charge_jrnl_store",
        valueField: "journal_id",
        labelField: ["journal_id", "journal_name"],
      },
    },
    finance_charge_acct_store: {
      title: "FC Acct Company",
      description: "FC Acct company",
      type: "string",
      isStore: true,
      companyKey: "finance_charge_acct_company",
      dependentFields: ["finance_charge_acct"],
    },
    finance_charge_acct_company: {
      title: "FC Acct Company",
      description: "FC acct company",
      type: "string",
      disabled: true,
    },
    finance_charge_acct: {
      title: "Account",
      description: "FC Account",
      type: "string",
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "account_type",
              operator: "EQUALS",
              value: "Asset",
            },
            {
              field: "control_type_code",
              operator: "IN",
              value: ["Reference", "None"],
            },
          ],
          responseFields: ["account_number", "account_description"],
        },
        storeId: "$finance_charge_acct_store",
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    finance_charge_rate: {
      title: "Finance Charge Interest Rate",
      description: "Monthly interest rate charged",
      type: ["number", "null"],
      default: null,
    },
    finance_charge_limit: {
      title: "Finance Charge Limit",
      description: "Amount up to which interest will be charged",
      type: ["number", "null"],
      default: null,
    },
    ar_description: {
      title: "AR Description",
      description: "Used as AR posting description",
      type: "string",
      default: "FINANCE CHARGE",
    },
    finance_charge_acct_desc: {
      title: "FC Acct Description",
      description: "Account posting description",
      type: "string",
      default: "FINANCE CHARGE",
    },
    zero_or_credit_print_option: {
      title: "Zero or Credit Print option",
      description: "Zero or Credit Print option",
      type: "string",
      enum: [
        "Print all statements",
        "Suppress printing statements for control numbers with zero balance",
        "Suppress printing statements for control numbers with credit balance",
        "Suppress printing statements for control numbers with either credit or zero balance",
      ],
      default: "Print all statements",
    },
    print_zero_balance_references: {
      title: "Print Zero Balance References",
      description: "Print or suppress zero balance references",
      type: "boolean",
      default: true,
    },
    print_credit_memo_detail: {
      title: "Print Credit Memo Detail",
      description: "Print credit memo detail",
      type: "boolean",
      default: true,
    },
    schedule_type: {
      title: "Schedule Type",
      description: "Schedule type",
      type: ["string", "null"],
      enum: ["AR_OPEN", "AR_BAL", null],
      default: null,
    },
    schedule_required_for_close: {
      title: "Schedule Required For Close",
      description: "Schedule required for close",
      type: "boolean",
      default: true,
    },
    sub_total_by_unit: {
      title: "Sub total by unit",
      description: "Sub total configuration",
      type: "boolean",
      default: false,
    },
    print_lease_statements: {
      title: "Print lease statements",
      description: "Print lease statements decision",
      type: "boolean",
      default: false,
    },
    ar_flag: {
      title: "Account Receivable Flag",
      description:
        "False, A/R has not been started, has been reset, or has been completed. True, Final statement or final schedule is in progress.",
      type: "boolean",
      default: false,
    },
    min_finance_charge_amount: {
      title: "Minimum finance charge amount",
      description: "Minimum finance charge amount",
      type: ["number", "null"],
      default: null,
    },
    ar_close_date: {
      title: "Date of last accounts receivable close",
      description: "Date of last accounts receivable close (DDMMMYYYY format).",
      type: ["string", "null"],
      format: "date",
      default: null,
    },
    ar_credit_aging_flag: {
      title: "ARO Credit Aging flag",
      description:
        "False, do not age AR open-item net credit balance invoices. True, age AR open-item net credit balance invoices",
      type: "boolean",
      default: false,
    },
    multiple_finance_charge_flag: {
      title: "Multiple finance charge flag",
      description:
        "False, Using multiple reference numbers when posting finance charges. True, Using single reference when posting finance charges.",
      type: "boolean",
      default: false,
    },
    schedule_field: {
      title: "Schedule Field",
      description: "Additional field to print on schedules",
      type: ["string", "null"],
      default: null,
    },
    aged_trial_balance_field: {
      title: "Aged Trial Balance Field",
      description: "Additional field to print on aged trial balance",
      type: ["string", "null"],
      default: null,
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    store_id: {
      title: "Store",
      description: "Store identifier",
      type: "string",
      minLength: 1,
    },
    tenant_id: {
      title: "Tenant",
      description: "Tenant identifier",
      type: "string",
      minLength: 1,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
    },
    record_type: {
      title: "Record type",
      description: "Identifies the flattened record type",
      type: "string",
      enum: [
        "Base",
        "Interest Control",
        "Schedule Fields",
        "Aged Trial Balance Fields",
      ],
      default: "Base",
    },
    created_by: {
      title: "Created By",
      description: "Party responsible for new record item construction.",
      type: "string",
      minLength: 1,
    },
    created_at: {
      title: "Created Date Time",
      description: "Date and Time of new record construction.",
      type: "string",
      minLength: 1,
    },
    updated_by: {
      title: "Last Updated By",
      description: "Party that performed the last record update. Required.",
      type: ["string", "null"],
      minLength: 1,
      default: null,
    },
    updated_at: {
      title: "Last Updated Date Time",
      description: "Last Date and Time the record was updated. Required.",
      type: ["string", "null"],
      minLength: 1,
      default: null,
    },
    schedule_fields: {
      title: "Schedule Fields",
      description: "Schedule Fields",
      key: "schedule_field",
      type: "array",
      items: {
        type: "string",
      },
      enum: [
        "NAME",
        "TELEPHONE",
        "INT",
        "CREDIT",
        "HOLD-FLAG",
        "TOTAL-90",
        "CNTRL2",
        "GRP",
      ],
    },
    aged_trial_balance_fields: {
      title: "Aged Trial Balance Fields",
      description: "Aged Trial Balance Fields",
      key: "aged_trial_balance_field",
      type: "array",
      items: {
        type: "string",
      },
      enum: [
        "NAME",
        "TELEPHONE",
        "INT",
        "CREDIT",
        "HOLD-FLAG",
        "TOTAL-90",
        "CNTRL2",
        "GRP",
      ],
    },
    interest_control: {
      title: "Interest Control",
      description: "Interest Control",
      maximum: 3,
      type: "array",
      items: {
        type: "object",
        properties: {
          finance_charge_rate: {
            title: "FC Interest Rate",
            type: "number",
          },
          finance_charge_limit: {
            title: "Finance Charge Limit",
            type: "number",
          },
        },
        required: ["finance_charge_rate", "finance_charge_limit"],
      },
    },
    transaction_id: {
      default: null,
      description: "Transaction id from salesforce ",
      minLength: 1,
      title: "Transaction Id",
      type: ["string", "null"],
    },
  },
  required: [
    "enterprise_id",
    "store_id",
    "tenant_id",
    "record_type",
    "ar_company",
    "ar_account",
    "ar_description",
    "finance_charge_acct",
    "finance_charge_acct_company",
    "finance_charge_acct_desc",
    "finance_charge_jrnl_company",
    "finance_charge_jrnl",
    "finance_charge_limit",
    "finance_charge_rate",
    "zero_or_credit_print_option",
    "print_zero_balance_references",
    "print_credit_memo_detail",
    "schedule_code",
    "schedule_title",
    "schedule_type",
    "schedule_required_for_close",
    "sub_total_by_unit",
    "print_lease_statements",
    "schedule_field",
    "aged_trial_balance_field",
    "ar_close_date",
    "ar_flag",
    "min_finance_charge_amount",
    "ar_credit_aging_flag",
    "multiple_finance_charge_flag",
  ],
  sections: {
    grid_fields: [
      "schedule_code",
      "ar_account",
      "ar_store",
      "schedule_title",
      "finance_charge_jrnl",
      "finance_charge_acct",
    ],
    general_fields: [
      "ar_store",
      "ar_company",
      "ar_account",
      "sub_type",
      "schedule_code",
      "schedule_title",
      "finance_charge_jrnl_store",
      "finance_charge_jrnl_company",
      "finance_charge_jrnl",
      "finance_charge_acct_store",
      "finance_charge_acct_company",
      "finance_charge_acct",
      "ar_description",
      "finance_charge_acct_desc",
      "zero_or_credit_print_option",
      "print_zero_balance_references",
      "print_credit_memo_detail",
      "ar_flag",
      "min_finance_charge_amount",
      "ar_close_date",
      "ar_credit_aging_flag",
      "multiple_finance_charge_flag",
      "schedule_type",
      "schedule_required_for_close",
      "sub_total_by_unit",
      "print_lease_statements",
      "schedule_fields",
      "aged_trial_balance_fields",
    ],
    corelation_fields: ["interest_control"],
  },
};

export const MOCK_ACCOUNTS_RECEIVABLE_ROW_DATA: RowData = {
  id: "6e9a3d2a-c9f4-4d20-b44f-36316d68fd11",
  tenant_id: "cbcfdfc5-d6f5-4a51-8f40-a2eda90c8c63",
  finance_charge_acct_company: "5",
  finance_charge_acct_store: "S100119371",
  finance_charge_acct: "27703",
  finance_charge_jrnl_company: "7",
  finance_charge_jrnl_store: "S100119373",
  ar_description: "FINANCE CHARGE",
  finance_charge_jrnl: "23",
  record_type: "Base",
  bp_id: null,
  version: null,
  ar_account: "10250",
  finance_charge_acct_desc: "FINANCE CHARGE",
  finance_charge_rate: null,
  finance_charge_limit: null,
  zero_or_credit_print_option: "Print all statements",
  print_credit_memo_detail: true,
  schedule_code: "C",
  schedule_title: "AR PARTS AND SERVICE",
  schedule_type: "AR_OPEN",
  print_zero_balance_references: true,
  print_lease_statements: false,
  store_id: "S100119371",
  sub_total_by_unit: true,
  schedule_field: null,
  aged_trial_balance_field: null,
  schedule_required_for_close: true,
  ar_company: "7",
  ar_store: "S100119373",
  ar_flag: false,
  min_finance_charge_amount: null,
  ar_close_date: null,
  ar_credit_aging_flag: false,
  multiple_finance_charge_flag: false,
  serial_no: 3010,
  enterprise_id: "E339440",
  active_status: "active",
  created_by: "sys-user-dms-admin",
  created_at: "2024-11-13T16:15:38.333+00:00",
  updated_by: "sys-user-dms-admin",
  updated_at: "2024-11-18T10:04:42.874+00:00",
  interest_control: [
    {
      id: "be90d3b8-d801-4110-a613-ac0c901a91df",
      finance_charge_rate: 10,
      finance_charge_limit: 1000,
    },
    {
      id: "be90d3b8-d801-4110-a613-ac0c901a91dg",
      finance_charge_rate: 11,
      finance_charge_limit: 1100,
    },
    {
      id: "be90d3b8-d801-4110-a613-ac0c901a91dh",
      finance_charge_rate: 12,
      finance_charge_limit: 1200,
    },
  ],
  schedule_fields: [
    {
      id: "9ee7b488-29f2-489a-8a39-9f33716cf969",
      schedule_field: "INT",
    },
    {
      id: "81dbc3e6-2e7b-464f-a52b-05fb50ae26a0",
      schedule_field: "HOLD-FLAG",
    },
  ],
  aged_trial_balance_fields: [
    {
      id: "620726d1-3e97-4906-a133-e6401a2623ae",
      aged_trial_balance_field: "CREDIT",
    },
  ],
  sub_type: "Open-Item Receivable",
};

export const MOCK_ACCOUNTS_RECEIVABLE_ROW_DATA_LIST: RowData[] = [
  {
    id: "f443c18d-9f39-4493-975b-e3c2cbaae439",
    tenant_id: "cbcfdfc5-d6f5-4a51-8f40-a2eda90c8c63",
    finance_charge_acct_company: "7",
    finance_charge_acct_store: "S100119373",
    finance_charge_acct: "11410",
    finance_charge_jrnl_company: "7",
    finance_charge_jrnl_store: "S100119373",
    ar_description: "FINANCE CHARGE",
    finance_charge_jrnl: "45",
    record_type: "Base",
    bp_id: null,
    version: null,
    ar_account: "18000",
    finance_charge_acct_desc: "FINANCE CHARGE",
    finance_charge_rate: null,
    finance_charge_limit: null,
    zero_or_credit_print_option: "Print all statements",
    print_credit_memo_detail: true,
    schedule_code: "Q",
    schedule_title: "AR PARTS AND SERVICE",
    schedule_type: "AR_BAL",
    print_zero_balance_references: true,
    print_lease_statements: false,
    store_id: "S100119371",
    sub_total_by_unit: false,
    schedule_field: null,
    aged_trial_balance_field: null,
    schedule_required_for_close: true,
    ar_company: "7",
    ar_store: "S100119373",
    ar_flag: false,
    min_finance_charge_amount: null,
    ar_close_date: null,
    ar_credit_aging_flag: false,
    multiple_finance_charge_flag: false,
    serial_no: 3008,
    enterprise_id: "E339440",
    active_status: "active",
    created_by: "sys-user-dms-admin",
    created_at: "2024-11-13T16:02:46.036+00:00",
    updated_by: "sys-user-dms-admin",
    updated_at: "2024-11-19T11:59:43.239+00:00",
    interest_control: [
      {
        id: "a12e1350-8335-41dc-8c10-9a52ab283d52",
        finance_charge_rate: 14,
        finance_charge_limit: 18,
      },
    ],
    schedule_fields: [
      {
        id: "638c1fa9-e763-425d-82ed-d8d1fed71dd7",
        schedule_field: "NAME",
      },
      {
        id: "0c861cab-8f4b-42a9-979f-0c59a0dd9058",
        schedule_field: "INT",
      },
    ],
    aged_trial_balance_fields: [
      {
        id: "b171eb81-5677-4463-b77b-f616e1ee626a",
        aged_trial_balance_field: "CREDIT",
      },
      {
        id: "296a3370-7186-4955-be0f-6bcb0ccc9c25",
        aged_trial_balance_field: "TELEPHONE",
      },
    ],
  },
  {
    id: "5e2e9538-fac6-4e1f-8ea6-12fcaa331056",
    tenant_id: "cbcfdfc5-d6f5-4a51-8f40-a2eda90c8c63",
    finance_charge_acct_company: "7",
    finance_charge_acct_store: "S100119373",
    finance_charge_acct: "18310",
    finance_charge_jrnl_company: "7",
    finance_charge_jrnl_store: "S100119373",
    ar_description: "FINANCE CHARGE",
    finance_charge_jrnl: "59",
    record_type: "Base",
    bp_id: null,
    version: null,
    ar_account: "13650",
    finance_charge_acct_desc: "FINANCE CHARGE",
    finance_charge_rate: null,
    finance_charge_limit: null,
    zero_or_credit_print_option: "Print all statements",
    print_credit_memo_detail: true,
    schedule_code: "B",
    schedule_title: "AR PARTS AND SERVICE",
    schedule_type: "AR_BAL",
    print_zero_balance_references: true,
    print_lease_statements: false,
    store_id: "S100119371",
    sub_total_by_unit: false,
    schedule_field: null,
    aged_trial_balance_field: null,
    schedule_required_for_close: true,
    ar_company: "7",
    ar_store: "S100119373",
    ar_flag: false,
    min_finance_charge_amount: null,
    ar_close_date: null,
    ar_credit_aging_flag: false,
    multiple_finance_charge_flag: false,
    serial_no: 2998,
    enterprise_id: "E339440",
    active_status: "active",
    created_by: "sys-user-dms-admin",
    created_at: "2024-11-13T15:00:08.466+00:00",
    updated_by: "sys-user-dms-admin",
    updated_at: "2024-11-18T11:18:20.265+00:00",
    interest_control: [
      {
        id: "ef27cb45-e7af-4d1f-bf19-a16a950d723b",
        finance_charge_rate: 10,
        finance_charge_limit: 15.5,
      },
    ],
    schedule_fields: [
      {
        id: "802c249a-57ca-4c5a-9e2f-9d77f27e0263",
        schedule_field: "TELEPHONE",
      },
      {
        id: "60013be0-dd50-43e3-a9ea-9febe2106a48",
        schedule_field: "HOLD-FLAG",
      },
    ],
    aged_trial_balance_fields: [
      {
        id: "c2253d3d-477d-4ecd-85ca-7e878ecace34",
        aged_trial_balance_field: "HOLD-FLAG",
      },
    ],
  },
];

export const MOCK_CASH_IN_BANK_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-cib-schema.json",
  title: "CashInBank",
  description: "A schema definition for Cash In Bank setups",
  functional_area: "ACCT",
  type: "object",
  properties: {
    report_number: {
      title: "Report Number",
      description: "Report Number",
      type: "integer",
      evalMethod: "getCashInBankReportNumber",
      disabled: true,
    },
    accounts: {
      title: "Accounts",
      description: "Cash In Bank Accounts",
      type: "array",
      items: {
        type: "string",
      },
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
          ],
          responseFields: ["account_number", "account_description"],
        },
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    report_name: {
      title: "Report Name",
      description: "Report Name for CIB report",
      type: "string",
    },
    report_amount_as: {
      title: "Report Amount As",
      description: "Amount Format",
      type: "string",
      enum: ["Amount", "Debits/Credits", "Amount/Credits/Debits"],
      default: "Debits/Credits",
    },
    sort_option_1: {
      title: "Sort Option 1",
      description: "Sort order definition",
      type: ["string", "null"],
      enum: ["Journal", "Reference", "Date", "Control", null],
      default: null,
    },
    sort_option_2: {
      title: "Sort Option 2",
      description: "Sort order definition",
      type: ["string", "null"],
      enum: ["Journal", "Reference", "Date", "Control", null],
      default: null,
    },
    sort_option_3: {
      title: "Sort Option 3",
      description: "Sort order definition",
      type: ["string", "null"],
      enum: ["Journal", "Reference", "Date", "Control", null],
      default: null,
    },
    sort_option_4: {
      title: "Sort Option 4",
      description: "Sort order definition",
      type: ["string", "null"],
      enum: ["Journal", "Reference", "Date", "Control", null],
      default: null,
    },
    break_on_journal: {
      title: "Break on Journal",
      description: "Break on journal flag",
      default: true,
      type: "boolean",
    },
    required_for_closing: {
      title: "Required for Closing",
      description: "Report required flag",
      default: true,
      type: "boolean",
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    store_id: {
      title: "Store",
      description: "Store identifier",
      type: "string",
      minLength: 1,
    },
    tenant_id: {
      title: "Tenant",
      description: "Tenant identifier",
      type: "string",
      minLength: 1,
    },
    company_id: {
      title: "Company",
      description: "Company identifier",
      type: ["string", "null"],
      pattern: "^([A-Z0-9]{1,3}|null)$",
      minLength: 1,
      default: null,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
      default: "inactive",
    },
    bp_id: {
      title: "Best Practice Template",
      description:
        "Identifies the best practice template used to instantiate the object values",
      type: ["string", "null"],
      default: null,
    },
    version: {
      title: "Version",
      description: "Identifies the schema version",
      type: "string",
      minLength: 1,
      default: "1",
    },
  },
  required: [
    "created_by",
    "created_at",
    "updated_by",
    "updated_at",
    "enterprise_id",
    "store_id",
    "tenant_id",
    "company_id",
    "active_status",
    "bp_id",
    "version",
    "report_number",
    "report_name",
    "accounts",
    "report_amount_as",
    "sort_option_1",
    "sort_option_2",
    "sort_option_3",
    "sort_option_4",
    "break_on_journal",
    "required_for_closing",
  ],
  sections: {
    grid_fields: [
      "report_number",
      "report_name",
      "break_on_journal",
      "required_for_closing",
    ],
    general_fields: [
      "report_number",
      "report_name",
      "accounts",
      "report_amount_as",
      "sort_option_1",
      "sort_option_2",
      "sort_option_3",
      "sort_option_4",
      "break_on_journal",
      "required_for_closing",
    ],
  },
};

export const MOCK_CASH_IN_BANK_ROW_DATA: RowData = {
  id: "fc012171-57b4-4b2e-a517-a7e9ff5c682e",
  tenant_id: "cbcfdfc5-d6f5-4a51-8f40-a2eda90c8c63",
  company_id: null,
  bp_id: null,
  version: null,
  break_on_journal: true,
  sort_option_4: null,
  sort_option_3: null,
  required_for_closing: true,
  store_id: "S100119371",
  sort_option_2: null,
  sort_option_1: null,
  report_name: "TESTING",
  report_amount_as: "Debits/Credits",
  report_number: 1,
  accounts: ["72202", "8702", "1236"],
  serial_no: 2659,
  enterprise_id: "E339440",
  active_status: "active",
  created_by: "sys-user-dms-admin",
  created_at: "2024-11-15T17:08:17.069+00:00",
  updated_by: "sys-user-dms-admin",
  updated_at: "2024-11-19T13:52:30.939+00:00",
};

export const MOCK_CASH_IN_BANK_ROW_DATA_LIST: RowData[] = [
  {
    id: "fc012171-57b4-4b2e-a517-a7e9ff5c682e",
    tenant_id: "cbcfdfc5-d6f5-4a51-8f40-a2eda90c8c63",
    company_id: null,
    bp_id: null,
    version: null,
    break_on_journal: true,
    sort_option_4: null,
    sort_option_3: null,
    required_for_closing: true,
    store_id: "S100119371",
    sort_option_2: null,
    sort_option_1: null,
    report_name: "TESTING",
    report_amount_as: "Debits/Credits",
    report_number: 1,
    accounts: ["72202", "8702", "1236"],
    serial_no: 2659,
    enterprise_id: "E339440",
    active_status: "active",
    created_by: "sys-user-dms-admin",
    created_at: "2024-11-15T17:08:17.069+00:00",
    updated_by: "sys-user-dms-admin",
    updated_at: "2024-11-19T13:52:30.939+00:00",
  },
  {
    id: "ed2e17a6-7aaf-4dc2-bf4d-b6b3f4219fa6",
    tenant_id: "cbcfdfc5-d6f5-4a51-8f40-a2eda90c8c63",
    company_id: null,
    bp_id: null,
    version: null,
    break_on_journal: false,
    sort_option_4: null,
    sort_option_3: null,
    required_for_closing: false,
    store_id: "S100119371",
    sort_option_2: null,
    sort_option_1: null,
    report_name: "TESTING",
    report_amount_as: "Amount",
    report_number: 2,
    accounts: ["72202"],
    serial_no: 2660,
    enterprise_id: "E339440",
    active_status: "active",
    created_by: "sys-user-dms-admin",
    created_at: "2024-11-15T17:08:36.219+00:00",
    updated_by: "sys-user-dms-admin",
    updated_at: "2024-11-15T17:08:47.108+00:00",
  },
];

export const MOCK_CASH_RECEIPT_PAYMENT_TYPES_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-setup-payment-types-schema.json",
  title: "CashReceiptPymtTypes",
  description: "A schema definition for cash receipt payment types",
  functional_area: "ACCT",
  type: "object",
  properties: {
    payment_types: {
      title: "Payment Types",
      description: "Cash Receipt Payment Type Identifier",
      type: "array",
      items: {
        type: "string",
      },
      key: "payment_type",
    },
    payment_type: {
      title: "Cash Receipt Payment Type",
      description: "Cash Receipt Payment Type Identifier",
      type: "string",
      minLength: 1,
      maxLength: 7,
    },
    created_by: {
      title: "Created By",
      description: "Party responsible for new record item construction.",
      type: "string",
      minLength: 1,
    },
    created_at: {
      title: "Created Date Time",
      description: "Date and Time of new record construction.",
      type: "string",
      minLength: 1,
    },
    updated_by: {
      title: "Last Updated By",
      description: "Party that performed the last record update. Required.",
      type: ["string", "null"],
      minLength: 1,
      default: null,
    },
    updated_at: {
      title: "Last Updated Date Time",
      description: "Last Date and Time the record was updated. Required.",
      type: ["string", "null"],
      minLength: 1,
      default: null,
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    store_id: {
      title: "Store",
      description: "Store identifier",
      type: "string",
      minLength: 1,
    },
    tenant_id: {
      title: "Tenant",
      description: "Tenant identifier",
      type: "string",
      minLength: 1,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
      default: "active",
    },
  },
  required: ["enterprise_id", "store_id", "tenant_id", "payment_type"],
  sections: {
    grid_fields: ["payment_types"],
    general_fields: ["payment_types"],
    corelation_fields: [],
  },
};

export const MOCK_CASH_RECEIPT_PAYMENT_TYPES_ROW_DATA: RowData = {
  id: "1af1c924-19b9-4a42-9a5c-25232ebf16d1",
  tenant_id: "cbcfdfc5-d6f5-4a51-8f40-a2eda90c8c63",
  bp_id: null,
  version: "V1",
  store_id: "S100119371",
  transaction_id: null,
  serial_no: 2728,
  enterprise_id: "E339440",
  active_status: "active",
  created_by: "sys-user-dms-admin",
  created_at: "2024-12-16T15:27:49.464+00:00",
  updated_by: "OM@E339440.com",
  updated_at: "2025-02-28T16:34:14.087+00:00",
  payment_types: [
    {
      payment_type: "CASH",
      id: "1af1c924-19b9-4a42-9a5c-25232ebf16d1",
    },
    {
      payment_type: "CREDIT",
      id: "7a6e9f59-8312-49aa-b88c-b5a16b1ca317",
    },
    {
      payment_type: "OVERDRAFT",
      id: "be2f91d7-aacf-45dc-a0e1-dd6106293691",
    },
    {
      payment_type: "DD",
      id: "333fbe15-6881-4ed1-80aa-73c2486899de",
    },
  ],
};

export const MOCK_CASH_RECEIPT_PAYMENT_TYPES_COL_DEFS: ColDef[] = [
  {
    field: "payment_types",
    headerName: "Payment Types",
  },
];

export const MOCK_INTERCO_TRANSFER_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-interco-schema.json",
  title: "IntercoTransfer",
  description: "A schema definition for Interco Transfer setups",
  type: "object",
  properties: {
    store_a_id: {
      title: "Company A Store",
      description: "Store for Company A",
      type: "string",
      companyKey: "company_a_id",
      dependentFields: ["company_a_clearing_account"],
      typeaheadConfig: {
        url: "/v2/search/CNumCompanyMapping",
        minChars: 2,
        body: {
          filters: [
            {
              field: "source_cnumber",
              operator: "EQUALS",
              value: "#getCNumberFromStore",
            },
          ],
          responseFields: ["company_store_id", "company_id"],
        },
        evalMethods: ["getCNumberFromStore"],
        valueField: "company_store_id",
        labelField: ["company_store_id", "company_id"],
        defaultIdentifier: "defaultStores",
      },
    },
    company_a_id: {
      title: "Company A ID",
      description: "Company A Identifier",
      type: "string",
      minLength: 1,
      disabled: true,
    },
    company_a_clearing_account: {
      title: "Company A Clearing Account",
      description: "Company A clearing account number",
      type: "string",
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "account_type",
              operator: "IN",
              value: ["Asset", "Laibility"],
            },
            {
              field: "sub_type",
              operator: "EQUALS",
              value: "Inter-Company",
            },
            {
              field: "control_type_code",
              operator: "EQUALS",
              value: "Company",
            },
            {
              field: "control2_type_code",
              operator: "EQUALS",
              value: "None",
            },
          ],
          responseFields: ["account_number", "account_description"],
        },
        storeId: "$store_a_id",
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    company_a_target_journal: {
      title: "Company A Target Journal",
      description: "Company A Target journal id",
      type: "string",
      typeaheadConfig: {
        url: "/v2/search/Journals",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "journal_type",
              operator: "EQUALS",
              value: "Intercompany Transfer",
            },
          ],
          responseFields: ["journal_id", "journal_name"],
        },
        valueField: "journal_id",
        labelField: ["journal_id", "journal_name"],
      },
    },
    store_b_id: {
      title: "Company B Store",
      description: "Store for Company B",
      type: "string",
      companyKey: "company_b_id",
      dependentFields: ["company_b_clearing_account"],
      typeaheadConfig: {
        url: "/v2/search/CNumCompanyMapping",
        minChars: 2,
        body: {
          filters: [
            {
              field: "target_cnumber",
              operator: "EQUALS",
              value: "#getCNumberFromStore",
            },
          ],
          responseFields: ["company_store_id", "company_id"],
        },
        evalMethods: ["getCNumberFromStore"],
        valueField: "company_store_id",
        labelField: ["company_store_id", "company_id"],
        defaultIdentifier: "defaultStores",
      },
    },
    company_b_id: {
      title: "Company B ID",
      description: "Company B Identifier",
      type: "string",
      minLength: 1,
      disabled: true,
    },
    company_b_clearing_account: {
      title: "Company B Clearing Account",
      description: "Company B clearing account number",
      type: "string",
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "account_type",
              operator: "IN",
              value: ["Asset", "Laibility"],
            },
            {
              field: "sub_type",
              operator: "EQUALS",
              value: "Inter-Company",
            },
            {
              field: "control_type_code",
              operator: "EQUALS",
              value: "Company",
            },
            {
              field: "control2_type_code",
              operator: "EQUALS",
              value: "None",
            },
          ],
          responseFields: ["account_number", "account_description"],
        },
        storeId: "$store_b_id",
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    company_b_target_journal: {
      title: "Company B Target Journal",
      description: "Company B Target journal id",
      type: "string",
      typeaheadConfig: {
        url: "/v2/search/Journals",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "journal_type",
              operator: "EQUALS",
              value: "Intercompany Transfer",
            },
          ],
          responseFields: ["journal_id", "journal_name"],
        },
        valueField: "journal_id",
        labelField: ["journal_id", "journal_name"],
      },
    },
    cnumber: {
      title: "C number",
      description: "C number",
      type: ["string", "null"],
      default: null,
    },
    created_by: {
      title: "Created By",
      description: "Party responsible for new record item construction.",
      type: "string",
      minLength: 1,
    },
    created_datetime: {
      title: "Created Date Time",
      description: "Date and Time of new record construction.",
      type: "string",
      minLength: 1,
    },
    lastupdated_by: {
      title: "Last Updated By",
      description: "Party that performed the last record update. Required.",
      type: ["string", "null"],
      minLength: 1,
      default: null,
    },
    lastupdated_datetime: {
      title: "Last Updated Date Time",
      description: "Last Date and Time the record was updated. Required.",
      type: ["string", "null"],
      minLength: 1,
      default: null,
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    tenant_id: {
      title: "Tenant",
      description: "Tenant identifier",
      type: ["string", "null"],
      default: null,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
      default: "inactive",
    },
    bp_id: {
      title: "Best Practice Template",
      description:
        "Identifies the best practice template used to instantiate the object values",
      type: ["string", "null"],
      default: null,
    },
    version: {
      title: "Version",
      description: "Identifies the schema version",
      type: "string",
      minLength: 1,
      default: "1",
    },
  },
  required: [
    "created_by",
    "created_datetime",
    "lastupdated_by",
    "lastupdated_datetime",
    "enterprise_id",
    "active_status",
    "bp_id",
    "version",
    "company_a_id",
    "company_b_id",
    "company_a_clearing_account",
    "company_a_target_journal",
    "company_b_clearing_account",
    "company_b_target_journal",
  ],
  sections: {
    grid_fields: [
      "store_a_id",
      "company_a_id",
      "company_a_clearing_account",
      "store_b_id",
      "company_b_id",
      "company_b_clearing_account",
    ],
    general_fields: [
      "store_a_id",
      "company_a_id",
      "company_a_clearing_account",
      "company_a_target_journal",
      "store_b_id",
      "company_b_id",
      "company_b_clearing_account",
      "company_b_target_journal",
    ],
  },
};

export const MOCK_INTERCO_TRANSFERS_ROW_DATA: RowData = {
  id: "3cb01498-0ef7-421c-94ba-283f669a29bc",
  company_b_target_journal: "IC",
  company_b_clearing_account: "99003",
  company_a_clearing_account: "0807",
  company_b_id: "3",
  company_a_id: "1",
  company_a_target_journal: "IC",
  bp_id: null,
  version: "V1",
  store_a_id: "S100119367",
  cnumber: "C300745",
  store_b_id: "S100119369",
  serial_no: 3385,
  enterprise_id: "E339440",
  active_status: "active",
  created_by: "sys-user-dms-admin",
  created_at: "2025-01-20T14:30:23.197+00:00",
  updated_by: "sys-user-dms-admin",
  updated_at: "2025-01-23T05:10:22.103+00:00",
};

export const MOCK_EXPENSE_ALLOCATION_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-expenseallocations-schema.json",
  title: "ExpenseAllocations",
  description:
    "A schema definition for an accounting expense allocation setup item",
  functional_area: "ACCT",
  type: "object",
  properties: {
    allocation_company: {
      title: "Allocation Company",
      description:
        "GL company used as the source of the posting distribution by percent",
      type: "string",
      minLength: 1,
      disabled: true,
    },
    allocation_account: {
      title: "Allocation Account",
      description:
        "GL account used as the source of the posting distribution by percent",
      type: "string",
      isEditable: false,
      isUnique: true,
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "account_type",
              operator: "EQUALS",
              value: "Expense Allocation",
            },
          ],
          responseFields: ["account_description", "account_number"],
        },
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    distribution_store: {
      title: "Distribution Store",
      description: "Distribution Store that posted value is distributed to",
      type: "string",
      isStore: true,
      companyKey: "distribution_company",
      dependentFields: ["distribution_account", "distribution_percentage"],
    },
    distribution_company: {
      title: "Distribution Company",
      description: "Distribution Company that posted value is distributed to",
      type: "string",
      disabled: true,
    },
    distribution_account: {
      title: "Distribution Account",
      description: "Distribution Account that posted value is distributed to",
      type: "string",
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "account_type",
              operator: "IN",
              value: [
                "Expense Allocation",
                "Operating Expense",
                "Non-operating Income",
              ],
            },
          ],
          responseFields: ["account_description", "account_number"],
        },
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    distribution_percentage: {
      title: "Distribution Percentage",
      description:
        "Percentage of the posted amount to post to the distribution account",
      type: "number",
      maximum: 100,
    },
    distribution: {
      title: "Distribution Accounts",
      description: "Distribution of the Allocation Account",
      minimum: 1,
      type: "array",
      items: {
        type: "object",
        properties: {
          distribution_store: {
            title: "Distribution Store",
            type: "string",
            isStore: true,
            companyKey: "distribution_company",
            dependentFields: [
              "distribution_account",
              "distribution_percentage",
            ],
          },
          distribution_company: {
            title: "Distribution Company",
            type: "string",
            disabled: true,
          },
          distribution_account: {
            title: "Distribution Account",
            type: "string",
            typeaheadConfig: {
              url: "/v2/search/COA",
              minChars: 2,
              body: {
                filters: [
                  {
                    field: "record_type",
                    operator: "EQUALS",
                    value: "Base",
                  },
                  {
                    field: "account_type",
                    operator: "IN",
                    value: [
                      "Expense Allocation",
                      "Operating Expense",
                      "Non-operating Income",
                    ],
                  },
                ],
                responseFields: ["account_description", "account_number"],
              },
              valueField: "account_number",
              labelField: ["account_number", "account_description"],
            },
          },
          distribution_percentage: {
            title: "Distribution Percentage",
            type: "number",
            maximum: 100,
            evalMethod: "checkExpenseAllocationTotalDistributionPercentage",
          },
        },
        required: [
          "distribution_store",
          "distribution_account",
          "distribution_company",
          "distribution_percentage",
        ],
      },
    },

    created_by: {
      title: "Created By",
      description: "Party responsible for new record item construction.",
      type: "string",
      minLength: 1,
    },
    created_datetime: {
      title: "Created Date Time",
      description: "Date and Time of new record construction.",
      type: "string",
      minLength: 1,
    },
    lastupdated_by: {
      title: "Last Updated By",
      description: "Party that performed the last record update. Required.",
      type: ["string", "null"],
      minLength: 1,
      default: null,
    },
    lastupdated_datetime: {
      title: "Last Updated Date Time",
      description: "Last Date and Time the record was updated. Required.",
      type: ["string", "null"],
      minLength: 1,
      default: null,
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    store_id: {
      title: "Store",
      description: "Store identifier",
      type: "string",
      minLength: 1,
    },
    tenant_id: {
      title: "Tenant",
      description: "Tenant identifier",
      type: "string",
      minLength: 1,
    },
    company_id: {
      title: "Company",
      description: "Company identifier",
      type: ["string", "null"],
      default: null,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
      default: "inactive",
    },
  },
  required: [
    "created_by",
    "created_datetime",
    "lastupdated_by",
    "lastupdated_datetime",
    "enterprise_id",
    "store_id",
    "tenant_id",
    "company_id",
    "active_status",
    "bp_id",
    "version",
    "allocation_company",
    "allocation_account",
    "distribution_company",
    "distribution_account",
    "distribution_percentage",
    "distribution_store",
  ],
  sections: {
    grid_fields: ["allocation_company", "allocation_account"],
    general_fields: ["allocation_company", "allocation_account"],
    corelation_fields: ["distribution"],
  },
};

export const MOCK_EXPENSE_ALLOCATIONS_ROWDATA: RowData = {
  active_status: "active",
  allocation_account: "2400",
  allocation_company: "5",
  bp_id: null,
  company_id: "5",
  created_at: "2024-04-03T11:09:17.783+00:00",
  created_by: "sys-user-dms-admin",
  distribution: [
    {
      id: "424ae78f-0bec-4f6f-b4aa-7deae4db9e25",
      distribution_account: "38010",
      distribution_company: "4",
      distribution_percentage: 7,
      distribution_store: "S100119370",
    },
  ],
  enterprise_id: "E339440",
  id: "cd558cef-27cf-46ea-9e16-b2341886ecc6",
  serial_no: 6697,
  store_id: "S100119371",
  tenant_id: "cbcfdfc5-d6f5-4a51-8f40-a2eda90c8c63",
  updated_at: "2024-04-03T11:09:17.783+00:00",
  updated_by: "sys-user-dms-admin",
  version: "V1",
};

export const MOCK_EXPENSE_ALLOCATION_COLUMNDEFS: ColDef[] = [
  { field: "allocation_company", headerName: "Allocation Company" },
  { field: "allocation_account", headerName: "Allocation Account" },
  { field: "distribution", headerName: "Distribution Accounts" },
];

export const MOCK_SALES_CHAIN_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-salechains-schema.json",
  title: "SaleChains",
  description:
    "A schema definition for COA related accounting sale chains setups",
  type: "object",
  properties: {
    store_id: {
      title: "Store",
      description: "Store identifier",
      type: "string",
      isStore: true,
      isEditable: false,
      companyKey: "company_id",
      dependentFields: ["account_number"],
    },
    company_id: {
      title: "Company",
      description: "Company identifier",
      type: "string",
      minLength: 1,
    },
    account_number: {
      title: "Sale Account Number",
      description: "Base account number (type = S).",
      isEditable: false,
      type: "string",
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "account_type",
              operator: "EQUALS",
              value: "Sale",
            },
          ],
          responseFields: ["account_description", "account_number"],
        },
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    over_allowance_sale_account: {
      title: "Over Allowance Sale Account",
      description:
        "Over allowance sale account number (type = S) and Sub type (Vehicle Sale). Not required.",
      isEditable: false,
      type: "string",
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "account_type",
              operator: "EQUALS",
              value: "Sale",
            },
            {
              field: "sub_type",
              operator: "EQUALS",
              value: "Vehicle Sale",
            },
          ],
          responseFields: ["account_description", "account_number"],
        },
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    cost_account_number: {
      title: "Cost Account Number",
      description: "Cost account number (type = C). Not required.",
      isEditable: false,
      type: "string",
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "account_type",
              operator: "EQUALS",
              value: "Cost Of Sale",
            },
          ],
          responseFields: ["account_description", "account_number"],
        },
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    pct_assigned_to_cost_account: {
      title: "Cost Account Percent Assigned",
      description:
        "Percentage of sale amount assigned to cost account. Up to 100% allowed.",
      type: "number",
      default: 0,
      maximum: 100,
    },
    reconditioning_account: {
      title: "Reconditioning Account Number",
      description: "Reconditioning account number (type = C). Not required.",
      isEditable: false,
      type: "string",
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "account_type",
              operator: "EQUALS",
              value: "Cost Of Sale",
            },
          ],
          responseFields: ["account_description", "account_number"],
        },
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    offset_company: {
      title: "Cost Offset Company",
      description: "Company identifier. Not required.",
      type: "string",
      minLength: 1,
    },
    offset_account: {
      title: "Cost Offset Account",
      description:
        "Offset account number (asset or liability type only, usually inventory). Not required.",
      isEditable: false,
      type: "string",
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "account_type",
              operator: "IN",
              value: ["Asset", "Liability"],
            },
          ],
          responseFields: ["account_description", "account_number"],
        },
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    created_by: {
      title: "Created By",
      description: "Party responsible for new record item construction.",
      type: "string",
      minLength: 1,
    },
    created_datetime: {
      title: "Created Date Time",
      description: "Date and Time of new record construction.",
      type: "string",
      minLength: 1,
    },
    lastupdated_by: {
      title: "Last Updated By",
      description: "Party that performed the last record update. Required.",
      type: ["string", "null"],
      minLength: 1,
      default: null,
    },
    lastupdated_datetime: {
      title: "Last Updated Date Time",
      description: "Last Date and Time the record was updated. Required.",
      type: ["string", "null"],
      minLength: 1,
      default: null,
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    tenant_id: {
      title: "Tenant",
      description: "Tenant identifier",
      type: "string",
      minLength: 1,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
      default: "inactive",
    },
    bp_id: {
      title: "Best Practice Template",
      description:
        "Identifies the best practice template used to instantiate the object values",
      type: ["string", "null"],
      default: null,
    },
    version: {
      title: "Version",
      description: "Identifies the schema version",
      type: "string",
      minLength: 1,
    },
  },
  required: [
    "created_by",
    "created_datetime",
    "lastupdated_by",
    "lastupdated_datetime",
    "enterprise_id",
    "store_id",
    "tenant_id",
    "company_id",
    "active_status",
    "bp_id",
    "version",
    "account_number",
    "over_allowance_sale_account",
    "cost_account_number",
    "pct_assigned_to_cost_account",
    "reconditioning_account",
    "offset_company",
    "offset_account",
  ],
  sections: {
    grid_fields: [
      "company_id",
      "account_number",
      "cost_account_number",
      "pct_assigned_to_cost_account",
      "offset_company",
      "offset_account",
    ],
    general_fields: [
      "company_id",
      "account_number",
      "over_allowance_sale_account",
      "cost_account_number",
      "pct_assigned_to_cost_account",
      "reconditioning_account",
      "offset_company",
      "offset_account",
    ],
  },
};

export const MOCK_SALES_CHAIN_ROWDATA: RowData = {
  id: "3495b670-6ee7-47a4-92f4-d3760a4c8a90",
  tenant_id: "cbcfdfc5-d6f5-4a51-8f40-a2eda90c8c63",
  store_id: "S100119371",
  reconditioning_account: "24500",
  pct_assigned_to_cost_account: 0,
  over_allowance_sale_account: "24500",
  offset_company: "5",
  offset_account: "24500",
  cost_account_number: "67900",
  company_id: "5",
  bp_id: null,
  account_number: "47900",
  version: "V1",
  transaction_id: null,
  serial_no: 320,
  enterprise_id: "E339440",
  active_status: "active",
  created_by: "sys-user-dms-admin",
  created_at: "2024-04-03T11:09:26.081+00:00",
  updated_by: "sys-user-dms-admin",
  updated_at: "2024-05-28T13:23:46.851+00:00",
};

export const MOCK_SALES_CHAIN_COLUMNDEFS: ColDef[] = [
  { field: "account_number", headerName: "Sale Account Number" },
  { field: "company_id", headerName: "Company" },
  { field: "cost_account_number", headerName: "Cost Account Number" },
  { field: "offset_account", headerName: "Cost Offset Account" },
  {
    field: "over_allowance_sale_account",
    headerName: "Over Allowance Sale Account",
  },
  {
    field: "pct_assigned_to_cost_account",
    headerName: "Cost Account Percent Assigned",
  },
  {
    field: "reconditioning_account",
    headerName: "Reconditioning Account Number",
  },
];

export const MOCK_RECCUREING_JOURNAL_ENTRIES_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-recurringje-schema.json",
  title: "RecurringJrnlEntries",
  description:
    "Set up configuration for Standard or Recurring Journal Entry Template",
  functional_area: "ACCT",
  type: "object",
  properties: {
    journal_id: {
      title: "Journal",
      description:
        "Select the journal associated with this recurring journal entry template.",
      type: "string",
      uniqueCombination: ["journal_id", "recurring_je_reference_number"],
      isEditable: false,
      typeaheadConfig: {
        url: "/v2/search/Journals",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
          ],
          responseFields: ["journal_id", "journal_name"],
        },
        valueField: "journal_id",
        labelField: ["journal_id", "journal_name"],
      },
    },
    recurring_je_reference_number: {
      title: "Reference",
      description:
        "Enter a unique reference number for the recurring journal entry template.",
      type: "string",
      minLength: 1,
      maxLength: 10,
      pattern: "^[A-Z0-9-]+$",
      uniqueCombination: ["journal_id", "recurring_je_reference_number"],
      isEditable: false,
    },
    je_description: {
      title: "Journal Entry Description",
      description:
        "Enter a description that identifies the recurring journal entry.",
      minLength: 1,
      maxLength: 132,
      type: "string",
    },
    begin_date: {
      title: "Begin Date",
      description:
        "Enter the date on which this recurring journal entry becomes effective.",
      type: "string",
      format: "date",
    },
    end_date: {
      title: "End Date",
      description:
        "Enter the last date on which this recurring journal entry remains valid.",
      type: "string",
      format: "date",
    },
    reversal_anniversary_day: {
      title: "Reversal Day",
      description:
        "Enter the day of the following month on which the recurring journal entry should be automatically reversed. Leave blank if no automatic reversal is required.",
      type: ["string", "null"],
      minLength: 1,
      maxLength: 28,
      default: null,
    },
    last_post_date: {
      title: "Last Post",
      description:
        "Displays the date on which this recurring journal entry was last posted. This field is system-generated and cannot be edited.",
      type: ["string", "null"],
      format: "date",
      default: null,
      disabled: true,
    },
    source_company_id: {
      title: "Source Company ID",
      description: "Source Company identifier",
      type: ["string", "null"],
      pattern: "^([A-Z0-9]{1,3}|null)$",
      default: null,
    },
    user_id: {
      title: "User ID",
      description: "User ID",
      type: ["string", "null"],
      default: null,
    },
    add_date: {
      title: "Add Date",
      description: "System Date when record was created",
      type: ["string", "null"],
      default: null,
    },
    update_date: {
      title: "Update Date",
      description: "System Date when record was updated",
      type: ["string", "null"],
      default: null,
    },
    recurring_entry_reference: {
      title: "Recurring Entry Reference",
      description: "Recurring Entry Reference information",
      type: "array",
      items: {
        type: "object",
        properties: {
          target_company_group_id: {
            title: "GL Company",
            description:
              "Select the GL company where this recurring journal entry line will be posted.",
            type: ["string", "null"],
            default: null,
            isGroupId: true,
            storeKey: "target_store",
            dependentFields: ["account_number"],
          },
          target_store: {
            title: "Target Store",
            description: "Target Store Identifier",
            type: ["string", "null"],
            default: null,
            isStore: true,
            companyKey: "target_company_id",
            disabled: true,
            isHidden: true,
          },
          target_company_id: {
            title: "Target Company ID",
            description: "Target Company Identifier.",
            type: ["string", "null"],
            pattern: "^([A-Z0-9]{1,3}|null)$",
            disabled: true,
            storeKey: "target_store",
            default: null,
            isHidden: true,
          },
          account_number: {
            title: "Account",
            description:
              "Select the account to which the recurring journal entry will be posted. You can select a complete account or enter a partial account ending with an asterisk (*), if supported.",
            type: "string",
            typeaheadConfig: {
              url: "/v2/search/COA",
              minChars: 2,
              body: {
                filters: [
                  {
                    field: "record_type",
                    operator: "EQUALS",
                    value: "Base",
                  },
                ],
                responseFields: ["account_description", "account_number"],
              },
              storeId: "$target_store",
              groupId: "$target_company_group_id",
              valueField: "account_number",
              labelField: ["account_number", "account_description"],
            },
          },
          posting_amount: {
            title: "Posting Amount",
            description:
              "Enter the fixed amount to post when Value is selected as the calculation option.",
            type: ["number", "null"],
            pattern: "^([0-9]{1,11}|null)$",
            default: null,
          },
          control_1_number: {
            title: "Control",
            description:
              "Enter the Control 1 value associated with the recurring journal entry line, if applicable.",
            type: ["string", "null"],
            minLength: 1,
            maxLength: 17,
            default: null,
          },
          control_2_number: {
            title: "Control2",
            description:
              "Enter the Control 2 value associated with the recurring journal entry line, if applicable.",
            type: ["string", "null"],
            minLength: 1,
            maxLength: 17,
            default: null,
          },
          statistical_count: {
            title: "Count",
            description:
              "Enter the statistical count associated with this recurring journal entry line, if applicable.",
            type: ["number", "null"],
            pattern: "^([0-9]{1,4}|null)$",
            default: null,
          },
          posting_description: {
            title: "Description",
            description:
              "Enter the posting description that will appear on the journal entry created from this recurring template.",
            type: ["string", "null"],
            minLength: 1,
            maxLength: 132,
            default: null,
          },
          post_formula_calc_option: {
            title: "Post Formula Calc Option",
            description:
              "Select whether to post a fixed value or calculate the posting amount using a formula.",
            type: "string",
            enum: ["value", "formula"],
            default: "value",
          },
          post_formula_percent: {
            title: "Post Formula Percent",
            description:
              "Enter the percentage of the source account balance to calculate the posting amount when Formula is selected.",
            type: ["number", "null"],
            default: null,
          },
          post_formula_company_group_id: {
            title: "Post Formula Company",
            description:
              "Select the GL company group to use for the formula-based posting. Required if Post Formula Store is populated.",
            type: ["string", "null"],
            isGroupId: true,
            storeKey: "post_formula_store",
            dependentFields: ["post_formula_account"],
            default: null,
          },
          post_formula_store: {
            title: "Post Formula Store",
            description: "Post Formula Store Identifier",
            type: ["string", "null"],
            isStore: true,
            companyKey: "post_formula_company",
            disabled: true,
            default: null,
            isHidden: true,
          },
          post_formula_company: {
            title: "Post Formula Company",
            description:
              "Select the GL company containing the account used in the posting formula.",
            type: ["string", "null"],
            disabled: true,
            pattern: "^([A-Z0-9]{1,3}|null)$",
            storeKey: "post_formula_store",
            default: null,
            isHidden: true,
          },
          post_formula_account: {
            title: "Post Formula Account",
            description:
              "Select the account whose balance will be used to calculate the posting amount.",
            type: ["string", "null"],
            typeaheadConfig: {
              url: "/v2/search/COA",
              minChars: 2,
              body: {
                filters: [
                  {
                    field: "record_type",
                    operator: "EQUALS",
                    value: "Base",
                  },
                ],
                responseFields: ["account_description", "account_number"],
              },
              storeId: "$post_formula_store",
              groupId: "$post_formula_company_group_id",
              valueField: "account_number",
              labelField: ["account_number", "account_description"],
            },
            pattern: "^([A-Z0-9]{1,7}|null)$",
            default: null,
          },
          post_formula_balance: {
            title: "Post Formula Balance",
            description:
              "Select whether the posting formula uses the Month-to-Date (MTD) or Year-to-Date (YTD) account balance.",
            type: ["string", "null"],
            enum: ["MTD", "YTD", null],
            default: null,
          },
          productivity_number: {
            title: "Productivity Number",
            description:
              "Enter the productivity identifier associated with this recurring journal entry line, if applicable.",
            type: ["string", "null"],
            minLength: 1,
            maxLength: 10,
            default: null,
          },
          productivity_employee_ids: {
            title: "Productivity Employee Ids",
            description: "Productivity number. 2 fields delimited by a ^.",
            type: ["array", "null"],
            maxItems: 2,
            items: {
              type: "string",
            },
            default: null,
          },
        },
        required: ["account_number"],
      },
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    store_id: {
      title: "Store",
      description: "Store identifier",
      type: "string",
      minLength: 1,
    },
    tenant_id: {
      title: "Tenant",
      description: "Tenant identifier",
      type: "string",
      minLength: 1,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
      default: "inactive",
    },
    transaction_id: {
      title: "Transaction Id",
      description: "Transaction id from salesforce ",
      type: ["string", "null"],
      minLength: 1,
      default: null,
    },
  },
  required: [
    "journal_id",
    "recurring_je_reference_number",
    "je_description",
    "begin_date",
    "end_date",
    "enterprise_id",
    "store_id",
  ],
  sections: {
    grid_fields: [
      "journal_id",
      "recurring_je_reference_number",
      "je_description",
      "begin_date",
      "end_date",
      "reversal_anniversary_day",
      "last_post_date",
    ],
    general_fields: [
      "journal_id",
      "recurring_je_reference_number",
      "je_description",
      "begin_date",
      "end_date",
      "reversal_anniversary_day",
      "last_post_date",
    ],
    corelation_fields: ["recurring_entry_reference"],
  },
  dependencies: MOCK_RECURRING_JOURNAL_ENTRIES_DEPENDENCIES,
  sectionsInfo: {
    general_fields:
      "Define the recurring journal entry template by specifying the journal, reference number, description, effective dates, and optional automatic reversal settings.",
    recurring_entry_reference:
      "Configure one or more recurring journal entry lines by specifying the target GL company, account, posting method, amount or formula, controls, statistical count, and posting description.",
  },
};

export const MOCK_RECCUREING_JOURNAL_ENTRIES_ROWDATA: RowData = {
  id: "e5e7c94b-107c-4a4d-b566-2d380c790c48",
  tenant_id: "cbcfdfc5-d6f5-4a51-8f40-a2eda90c8c63",
  store_id: "S100119371",
  source_company_id: "7",
  journal_id: "10",
  recurring_je_reference_number: "3",
  begin_date: "2024-09-11",
  end_date: "2024-09-12",
  reversal_anniversary_day: "3",
  last_post_date: null,
  je_description: "Test 3",
  user_id: null,
  recurring_entry_reference: [
    {
      target_company_id: "1",
      account_number: "0904",
      post_formula_calc_option: "value",
      posting_amount: null,
      post_formula_percent: null,
      post_formula_company: null,
      post_formula_account: null,
      post_formula_balance: null,
      control_1_number: "",
      productivity_number: "",
      control_2_number: "",
      statistical_count: null,
      posting_description: "",
    },
  ],
  add_date: "2024-09-11",
  update_date: "2024-09-11",
  serial_no: 86,
  enterprise_id: "E339440",
  active_status: "active",
  created_by: "sys-user-dms-admin",
  created_at: "2024-10-09T08:10:35.345+00:00",
  updated_by: "sys-user-dms-admin",
  updated_at: "2024-09-11T11:57:10.496+00:00",
};

export const MOCK_RECCUREING_JOURNAL_ENTRIES_AUDIT_FILTERED_ROWDATA: RowData = {
  __existingRecordId: "e5e7c94b-107c-4a4d-b566-2d380c790c48",
  __isClonedRecord: true,
  store_id: "S100119371",
  source_company_id: "7",
  journal_id: "10",
  recurring_je_reference_number: "3",
  begin_date: "2024-09-11",
  end_date: "2024-09-12",
  reversal_anniversary_day: "3",
  last_post_date: null,
  je_description: "Test 3",
  user_id: null,
  recurring_entry_reference: [
    {
      target_company_id: "1",
      account_number: "0904",
      post_formula_calc_option: "value",
      posting_amount: null,
      post_formula_percent: null,
      post_formula_company: null,
      post_formula_account: null,
      post_formula_balance: null,
      control_1_number: "",
      productivity_number: "",
      control_2_number: "",
      statistical_count: null,
      posting_description: "",
    },
  ],
  add_date: "2024-09-11",
  update_date: "2024-09-11",
};

export const MOCK_GROUP_CODES_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-setup-group-codes-schema.json",
  title: "ReportGroupCodes",
  description:
    "A schema definition for accounting report group codes setup item",
  functional_area: "ACCT",
  type: "object",
  properties: {
    group_code_type: {
      title: "Group Code Type",
      description: "Group Code Type",
      type: "string",
      isEditable: false,
      uniqueCombination: ["group_code_type", "group_code_id"],
      enum: [
        "Income/Balance Report Group",
        "Income/Balance Report Subgroup",
        "User Defined Report Group",
        "Unit Analysis Report Group",
      ],
    },
    group_code_id: {
      title: "Group Code ID",
      description: "Group Code identifier",
      type: "string",
      isEditable: false,
      uniqueCombination: ["group_code_type", "group_code_id"],
      pattern: "^([A-Za-z0-9]{1,3})$",
    },
    group_code_description: {
      title: "Group Code Description",
      description: "Group Code description",
      type: ["string", "null"],
      default: null,
    },
    store_id: {
      title: "Store",
      description: "Store identifier",
      type: "string",
      minLength: 1,
    },
    company_id: {
      title: "Company",
      description: "Company identifier",
      type: "string",
      minLength: 1,
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    tenant_id: {
      title: "Tenant",
      description: "Tenant identifier",
      type: "string",
      minLength: 1,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
      default: "inactive",
    },
    created_by: {
      title: "Created By",
      description: "Party responsible for new record item construction.",
      type: "string",
      minLength: 1,
    },
    created_at: {
      title: "Created Date Time",
      description: "Date and Time of new record construction.",
      type: "string",
      minLength: 1,
    },
    updated_by: {
      title: "Last Updated By",
      description: "Party that performed the last record update. Required.",
      type: ["string", "null"],
      minLength: 1,
      default: null,
    },
    updated_at: {
      title: "Last Updated Date Time",
      description: "Last Date and Time the record was updated. Required.",
      type: ["string", "null"],
      minLength: 1,
      default: null,
    },
    transaction_id: {
      title: "Transaction Id",
      description: "Transaction id from salesforce ",
      type: ["string", "null"],
      minLength: 1,
      default: null,
    },
  },
  required: [
    "enterprise_id",
    "store_id",
    "tenant_id",
    "company_id",
    "active_status",
    "group_code_type",
    "group_code_id",
  ],
  sections: {
    grid_fields: ["group_code_type", "group_code_id", "group_code_description"],
    general_fields: [
      "group_code_type",
      "group_code_id",
      "group_code_description",
    ],
  },
};

export const MOCK_GROUP_CODES_ROWDATA: RowData = {
  group_code_type: "Income/Balance Report Group",
  group_code_id: "NA",
  group_code_description: "Not Applicable",
};

export const MOCK_GROUP_CODES_COULUMNS: ColDef[] = [
  {
    field: "group_code_type",
    headerName: "Group Code Type",
  },
  {
    field: "group_code_id",
    headerName: "Group Code ID",
  },
  {
    field: "group_code_description",
    headerName: "Group Code Description",
  },
];

export const MOCK_LASER_FORM_TABLE_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-laser-form-table-schema.json",
  title: "LaserFormTable",
  description: "A schema definition for a Laser Form Table object",
  type: "object",
  properties: {
    cash_company_store_id: {
      title: "Cash Store",
      description: "Cash Company specific store id",
      type: "string",
      isStore: true,
      companyKey: "cash_company",
      dependentFields: ["account_no"],
    },
    cash_company: {
      title: "Cash Company",
      description: "Cash Company",
      type: "number",
      minLength: 1,
      disabled: true,
    },
    account_no: {
      title: "Cash Account",
      description: "Chart account used for this setup",
      type: "string",
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "sub_type",
              operator: "EQUALS",
              value: "Cash",
            },
          ],
          responseFields: ["account_description", "account_number"],
        },
        storeId: "$cash_company_store_id",
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    pck_laser_printer_no: {
      title: "AP checks printer number",
      description: "AP printer number",
      type: "number",
    },
    chk_laser_printer_no: {
      title: "OnDemand Checks printer number",
      description: "OnDemand Checks printer number",
      type: "array",
      items: {
        type: "string",
      },
      default: null,
    },
    is_micr: {
      title: "MICR Flag",
      description: "MICR Flag.",
      type: "boolean",
      default: false,
    },
    micr_routing_no: {
      title: "Micr Routing Number",
      description: "Micr Routing Number",
      type: ["string", "null"],
      default: null,
    },
    micr_bank_account_no: {
      title: "Micr Bank account Number",
      description: "Micr Bank account Number",
      type: ["string", "null"],
      default: null,
    },
    micr_check_length: {
      title: "Micr Check Length",
      description: "Micr check length",
      type: ["number", "null"],
      default: null,
    },
    store_id: {
      title: "Store",
      description: "Store identifier",
      type: "string",
      minLength: 1,
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    tenant_id: {
      title: "Tenant",
      description: "Tenant identifier",
      type: "string",
      minLength: 1,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
    },
    is_slf: {
      title: "SLF Flag",
      description:
        "Multi-valued flag that indicates whether the SLF record can be read. All correlative values in attributes 2 and 3 must be true for the correlative flag to be set to true.",
      type: "boolean",
      default: false,
    },
    created_by: {
      title: "Created By",
      description: "Party responsible for new record item construction.",
      type: "string",
      minLength: 1,
    },
    created_at: {
      title: "Created Date Time",
      description: "Date and Time of new record construction.",
      type: "string",
      minLength: 1,
    },
    updated_by: {
      title: "Last Updated By",
      description: "Party that performed the last record update. Required.",
      type: ["string", "null"],
      minLength: 1,
      default: null,
    },
    updated_at: {
      title: "Last Updated Date Time",
      description: "Last Date and Time the record was updated. Required.",
      type: ["string", "null"],
      minLength: 1,
      default: null,
    },
    transaction_id: {
      title: "Transaction Id",
      description: "Transaction id from salesforce ",
      type: ["string", "null"],
      minLength: 1,
      default: null,
    },
  },
  required: [
    "enterprise_id",
    "store_id",
    "tenant_id",
    "active_status",
    "account_no",
    "pck_laser_printer_no",
    "chk_laser_printer_no",
    "cash_company_store_id",
    "cash_company",
    "is_slf",
    "is_micr",
    "micr_routing_no",
    "micr_bank_account_no",
    "micr_check_length",
  ],
  sections: {
    grid_fields: [
      "cash_company_store_id",
      "cash_company",
      "account_no",
      "pck_laser_printer_no",
      "chk_laser_printer_no",
      "is_micr",
    ],
    general_fields: [
      "cash_company_store_id",
      "cash_company",
      "account_no",
      "pck_laser_printer_no",
      "chk_laser_printer_no",
      "is_micr",
      "micr_routing_no",
      "micr_bank_account_no",
      "micr_check_length",
    ],
  },
  dependencies: MOCK_LASER_FORM_TABLE_DEPENDENCIES,
};

export const MOCK_LASER_FORM_TABLE_ROWDATA: RowData = {
  tenant_id: "cbcfdfc5-d6f5-4a51-8f40-a2eda90c8c63",
  id: "ddfbc2cc-7c0f-4479-a852-dc9292ffad54",
  record_type: "Base",
  version: "V1",
  bp_id: null,
  store_id: "S100119371",
  transaction_id: null,
  serial_no: 3184,
  enterprise_id: "E339440",
  active_status: "active",
  created_by: "sys-user-dms-admin",
  created_at: "2024-12-02T16:07:11.560+00:00",
  updated_by: "sys-user-dms-admin",
  updated_at: "2025-02-14T11:53:27.963+00:00",
  cash_company_store_id: "S100119373",
  cash_company: "7",
  account_no: "10101",
  pck_laser_printer_no: 100,
  chk_laser_printer_no: ["11", "12"],
  is_micr: true,
  micr_routing_no: "9389",
  micr_bank_account_no: "1234",
  micr_check_length: 5,
};

export const MOCK_GLFiscalYearCalendar_Schema: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-gl-fiscal-year-calendar-schema.json",
  title: "GLFiscalYearCalendar",
  description:
    "A schema definition for merged GL Calendar & Fiscal Year End setups",
  type: "object",
  properties: {
    fy_start_date: {
      title: "Fiscal Year Start Date",
      description: "Start date of the Fiscal Year",
      type: "string",
      format: "date",
      disabled: true,
    },
    fy_end_date: {
      title: "Fiscal Year End date",
      description: "Last date of the Fiscal Year",
      type: "string",
      format: "date",
      evalMethod: "GLFiscalCurrentFYYearEnabled",
    },
    prev_fy_end_date: {
      title: "Previous Fiscal Year End date",
      description: "Last date of the Previous Fiscal Year",
      type: "string",
      format: "date",
      disabled: true,
    },
    posting_cutoff_datetime: {
      title: "Posting Cutoff DateTime",
      description: "Posting Cutoff DateTime",
      type: ["string", "null"],
      format: "dateTime",
      default: null,
    },
    current_month: {
      title: "Current month",
      description: "Current month",
      type: "string",
      disabled: true,
    },
    post_ahead_month: {
      title: "Post Ahead month",
      description: "Post Ahead month",
      type: "string",
      disabled: true,
    },
    gl_calendar: {
      title: "GL Calendar Data",
      description: "GL Calendar Data",
      type: "array",
      isEditable: false,
      minimum: 12,
      maximum: 12,
      items: {
        type: "object",
        properties: {
          posting_month: {
            title: "Posting Month",
            description: "Posting Month",
            type: "string",
            evalMethod: "getGLFiscalFormattedMonth",
            disabled: true,
          },
          is_posting_month_active: {
            title: "Is Posting Month",
            description: "Is Posting Month",
            type: "boolean",
            evalMethod: "enableActiveMonthPostingCutoffDateTime",
            disabled: true,
          },
          posting_cutoff_datetime: {
            title: "Posting Cutoff DateTime",
            description: "Posting Cutoff DateTime",
            type: ["string", "null"],
            format: "dateTime",
            disabled: true,
            evalMethod: "GLFiscalnextActiveMonthEnabled",
          },
        },
        required: [],
      },
    },
  },
  required: [],
  sections: {
    grid_fields: [
      "fy_end_date",
      "fy_start_date",
      "posting_cutoff_datetime",
      "current_month",
      "post_ahead_month",
    ],
    general_fields: ["fy_start_date", "fy_end_date", "current_month"],
    corelation_fields: ["gl_calendar"],
  },
};

export const MOCK_GLFiscalYearCalendar_ROWDATA: RowData = {
  id: "e4713535-895d-41af-8407-d9dcf2909426",
  tenant_id: "cbcfdfc5-d6f5-4a51-8f40-a2eda90c8c63",
  company_id: "5",
  store_id: "S100119371",
  bp_id: null,
  version: "V1",
  fy_end_date: "2025-12-31",
  fy_start_date: "2025-01-1",
  current_month: "March",
  transaction_id: null,
  serial_no: 3777,
  enterprise_id: "E339440",
  active_status: "active",
  created_by: "sys-user-dms-admin",
  created_at: "2025-02-28T10:32:51.784+00:00",
  updated_by: "sys-user-dms-admin",
  updated_at: "2025-02-28T10:32:51.784+00:00",
  gl_calendar: [
    {
      id: "aea3ee08-935f-422f-bcf9-d7331e8f5d85",
      tenant_id: "cbcfdfc5-d6f5-4a51-8f40-a2eda90c8c63",
      posting_cutoff_datetime: null,
      month_close_datetime: null,
      posting_year: "2023",
      is_posting_month_active: false,
      version: "V1",
      bp_id: null,
      company_id: "5",
      store_id: "S100119371",
      transaction_id: null,
      serial_no: 9997,
      enterprise_id: "E339440",
      active_status: "active",
      created_by: "sys-user-dms-admin",
      created_at: "2024-04-03T11:09:24.413+00:00",
      updated_by: "sys-user-dms-admin",
      updated_at: "2025-02-28T10:32:48.654+00:00",
    },
    {
      id: "29c9a110-7e22-4c0f-9ab9-3e0ede5177af",
      tenant_id: "cbcfdfc5-d6f5-4a51-8f40-a2eda90c8c63",
      posting_cutoff_datetime: "2025-03-31 16:36:05",
      month_close_datetime: null,
      is_posting_month_active: true,
      posting_month: "March",
      version: "V1",
      bp_id: null,
      company_id: "5",
      store_id: "S100119371",
      transaction_id: null,
      serial_no: 9984,
      enterprise_id: "E339440",
      active_status: "active",
      created_by: "sys-user-dms-admin",
      created_at: "2024-04-03T11:09:24.413+00:00",
      updated_by: "sys-user-dms-admin",
      updated_at: "2025-02-28T10:32:48.549+00:00",
    },
    {
      id: "29c9a110-7e22-4c0f-9ab9-3e0ede5177af",
      tenant_id: "cbcfdfc5-d6f5-4a51-8f40-a2eda90c8c63",
      posting_cutoff_datetime: "2025-02-31 16:36:05",
      month_close_datetime: null,
      is_posting_month_active: true,
      posting_month: "February",
      version: "V1",
      bp_id: null,
      company_id: "5",
      store_id: "S100119371",
      transaction_id: null,
      serial_no: 9984,
      enterprise_id: "E339440",
      active_status: "active",
      created_by: "sys-user-dms-admin",
      created_at: "2024-04-03T11:09:24.413+00:00",
      updated_by: "sys-user-dms-admin",
      updated_at: "2025-02-28T10:32:48.549+00:00",
    },
    {
      id: "29c9a110-7e22-4c0f-9ab9-3e0ede5177af",
      tenant_id: "cbcfdfc5-d6f5-4a51-8f40-a2eda90c8c63",
      posting_cutoff_datetime: "2025-04-31 16:36:05",
      month_close_datetime: null,
      is_posting_month_active: false,
      version: "V1",
      bp_id: null,
      company_id: "5",
      store_id: "S100119371",
      transaction_id: null,
      serial_no: 9984,
      enterprise_id: "E339440",
      active_status: "active",
      created_by: "sys-user-dms-admin",
      created_at: "2024-04-03T11:09:24.413+00:00",
      updated_by: "sys-user-dms-admin",
      updated_at: "2025-02-28T10:32:48.549+00:00",
    },
  ],
};

export const MOCK_GLFiscalYearCalendar_UPDATED_ROWDATA: RowData = {
  id: "e4713535-895d-41af-8407-d9dcf2909426",
  tenant_id: "cbcfdfc5-d6f5-4a51-8f40-a2eda90c8c63",
  company_id: "5",
  store_id: "S100119371",
  bp_id: null,
  version: "V1",
  fy_end_date: "2025-12-31",
  fy_start_date: "2025-01-1",
  current_month: "March",
  transaction_id: null,
  serial_no: 3777,
  enterprise_id: "E339440",
  active_status: "active",
  created_by: "sys-user-dms-admin",
  created_at: "2025-02-28T10:32:51.784+00:00",
  updated_by: "sys-user-dms-admin",
  updated_at: "2025-02-28T10:32:51.784+00:00",
  gl_calendar: [
    {
      id: "29c9a110-7e22-4c0f-9ab9-3e0ede5177af",
      tenant_id: "cbcfdfc5-d6f5-4a51-8f40-a2eda90c8c63",
      posting_cutoff_datetime: "2025-02-31 16:36:05",
      month_close_datetime: null,
      is_posting_month_active: true,
      posting_month: "February",
      version: "V1",
      bp_id: null,
      company_id: "5",
      store_id: "S100119371",
      transaction_id: null,
      serial_no: 9984,
      enterprise_id: "E339440",
      active_status: "active",
      created_by: "sys-user-dms-admin",
      created_at: "2024-04-03T11:09:24.413+00:00",
      updated_by: "sys-user-dms-admin",
      updated_at: "2025-02-28T10:32:48.549+00:00",
    },
  ],
};

export const MOCK_GLFiscalYearCalendar_NON_ACTIVE_ROWDATA: RowData = {
  id: "e4713535-895d-41af-8407-d9dcf2909426",
  tenant_id: "cbcfdfc5-d6f5-4a51-8f40-a2eda90c8c63",
  company_id: "5",
  store_id: "S100119371",
  bp_id: null,
  version: "V1",
  fy_end_date: "2025-12-31",
  fy_start_date: "2025-01-1",
  current_month: "March",
  transaction_id: null,
  serial_no: 3777,
  enterprise_id: "E339440",
  active_status: "active",
  created_by: "sys-user-dms-admin",
  created_at: "2025-02-28T10:32:51.784+00:00",
  updated_by: "sys-user-dms-admin",
  updated_at: "2025-02-28T10:32:51.784+00:00",
  gl_calendar: [
    {
      id: "29c9a110-7e22-4c0f-9ab9-3e0ede5177af",
      tenant_id: "cbcfdfc5-d6f5-4a51-8f40-a2eda90c8c63",
      posting_cutoff_datetime: "2025-02-31 16:36:05",
      month_close_datetime: null,
      is_posting_month_active: false,
      posting_month: "February",
      version: "V1",
      bp_id: null,
      company_id: "5",
      store_id: "S100119371",
      transaction_id: null,
      serial_no: 9984,
      enterprise_id: "E339440",
      active_status: "active",
      created_by: "sys-user-dms-admin",
      created_at: "2024-04-03T11:09:24.413+00:00",
      updated_by: "sys-user-dms-admin",
      updated_at: "2025-02-28T10:32:48.549+00:00",
    },
  ],
};

export const MOCK_GLFiscalYearCalendar_Coldefs: ColDef[] = [
  { field: "fy_end_date", headerName: "Fiscal Year End date" },
  { field: "fy_start_date", headerName: "Fiscal Year Start Date" },
  { field: "posting_cutoff_datetime", headerName: "Posting Cutoff DateTime" },
  { field: "current_month", headerName: "Current month" },
  { field: "post_ahead_month", headerName: "Post Ahead month" },
  { field: "gl_calendar", headerName: "GL Calendar Data" },
];

export const MOCK_WRITE_OFFS_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-writeoffs-schema.json",
  title: "WriteOffs",
  description: "A schema definition for accounting Write-Offs setup item",
  type: "object",
  properties: {
    company_id: {
      title: "Company",
      description: "Company identifier",
      type: ["string", "null"],
      default: null,
    },
    scheduled_acct: {
      title: "Scheduled Acct",
      description: "Account number (must be scheduled)",
      type: "string",
      isUnique: true,
      typeaheadConfig: {
        url: "/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "sub_type",
              operator: "NOT_IN",
              value: ["Open-Item Payable", "Balance Forward Payable"],
            },
            {
              field: "account_number",
              operator: "IN",
              value: "#getWriteOffCOAScheduledAccounts",
            },
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
          ],
          responseFields: ["account_number", "account_description"],
        },
        evalMethods: ["getWriteOffCOAScheduledAccounts"],
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    max_debit: {
      title: "Max Debit",
      description: "Maximum debit write-off amount",
      type: "number",
      minimum: 0,
      maximum: 99999999.99,
      default: 0,
      evalMethod: "validateWriteOffMaxDebitandMaxCredit",
    },
    max_credit: {
      title: "Max Credit",
      description: "Maximum credit write-off amount",
      type: "number",
      minimum: 0,
      maximum: 99999999.99,
      default: 0,
      evalMethod: "validateWriteOffMaxDebitandMaxCredit",
    },
    journal: {
      title: "W/O Journal",
      description: "Journal identifier",
      type: "string",
      isEditable: false,
      isUnique: true,
      typeaheadConfig: {
        url: "/v2/search/Journals",
        minChars: 2,
        body: {
          filters: [
            {
              field: "journal_type",
              operator: "IN",
              value: [
                "Accounts Receivable Finance Charge",
                "Generic",
                "Install Account Balances",
                "Sales",
                "Schedule Changes",
                "Set Up History",
                "Set Up Schedule Balances",
              ],
            },
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
          ],
          responseFields: ["journal_id", "journal_name"],
        },
        valueField: "journal_id",
        labelField: ["journal_id", "journal_name"],
      },
    },
    reference: {
      title: "W/O Reference",
      description: "Default reference",
      type: "string",
      maxLength: 10,
    },
    description: {
      title: "W/O Description",
      description:
        "Posting and/or journal entry description for writeoff offset account, journal or account written off",
      type: ["string", "null"],
      default: null,
    },
    account: {
      title: "W/O Acct",
      description: "Write-off offset account number",
      type: "string",
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "account_type",
              operator: "NOT_IN",
              value: ["Memo", "Expense Allocation"],
            },
            {
              field: "sub_type",
              operator: "NOT_IN",
              value: [
                "Profit",
                "Retained Earnings",
                "Open-Item Payable",
                "Open-Item Receivable",
                "Inter-Company",
              ],
            },
          ],
          responseFields: ["account_number", "account_description"],
        },
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    control: {
      title: "W/O Control",
      description: "Control for write-off offset account",
      type: "string",
      default: null,
    },
    control2: {
      title: "W/O Control2",
      description: "Control2 for write-off offset account",
      type: ["string", "null"],
      default: null,
    },
    created_by: {
      title: "Created By",
      description: "Party responsible for new record item construction.",
      type: "string",
      minLength: 1,
    },
    created_at: {
      title: "Created Date Time",
      description: "Date and Time of new record construction.",
      type: "string",
      minLength: 1,
    },
    updated_by: {
      title: "Last Updated By",
      description: "Party that performed the last record update. Required.",
      type: ["string", "null"],
      minLength: 1,
      default: null,
    },
    updated_at: {
      title: "Last Updated Date Time",
      description: "Last Date and Time the record was updated. Required.",
      type: ["string", "null"],
      minLength: 1,
      default: null,
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    store_id: {
      title: "Store",
      description: "Store identifier",
      type: "string",
      minLength: 1,
    },
    tenant_id: {
      title: "Tenant",
      description: "Tenant identifier",
      type: "string",
      minLength: 1,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
      default: "inactive",
    },
  },
  required: [
    "enterprise_id",
    "store_id",
    "tenant_id",
    "company_id",
    "active_status",
    "scheduled_acct",
    "max_debit",
    "max_credit",
    "journal",
    "reference",
    "description",
    "account",
    "control",
    "control2",
  ],
  sections: {
    grid_fields: [
      "scheduled_acct",
      "max_debit",
      "max_credit",
      "journal",
      "reference",
      "description",
      "account",
    ],
    general_fields: [
      "scheduled_acct",
      "max_debit",
      "max_credit",
      "journal",
      "reference",
      "description",
      "account",
      "control",
      "control2",
    ],
  },
};

export const MOCK_WRITE_OFFS_ROWDATA: RowData = {
  id: "e69b3f26-a106-41dc-a4b5-3515b05cae83",
  tenant_id: "cbcfdfc5-d6f5-4a51-8f40-a2eda90c8c63",
  store_id: "S100119371",
  description: "Write-off scheduled account 26100 (10/16/08)",
  control2: null,
  reference: "REBATE_CLN",
  journal: "80",
  account: "32250",
  max_debit: 0,
  max_credit: 0,
  control: "9999",
  company_id: "5",
  scheduled_acct: "26100",
  serial_no: 179,
  enterprise_id: "E339440",
  active_status: "active",
  created_by: "OM@E339440.com",
  created_at: "2025-04-10T14:50:09.247+00:00",
  updated_by: "OM@E339440.com",
  updated_at: "2025-04-10T14:50:09.247+00:00",
};

export const MOCK_PO_CONFIGURATION_GROUP_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-pogroup-schema.json",
  title: "POConfigurationGroup",
  description: "A schema definition for Purchase Order Group setups",
  type: "object",
  properties: {
    po_group_cd: {
      title: "PO Group Code",
      description:
        "Code defined for the PO group that is unique across accounting for this client",
      type: "string",
      minLength: 1,
      maxLength: 20,
      isUnique: true,
      isEditable: false,
    },
    po_group_desc: {
      title: "PO Group Description",
      description: "Description of the PO Group",
      type: "string",
      minLength: 1,
      maxLength: 20,
    },
    acc_name: {
      title: "Account Application Account",
      description: "Account Code identifies a logon",
      type: "string",
      minLength: 1,
      disabled: true,
    },
    po_nbr_prefix_cd: {
      title: "PO Number Prefix",
      description: "PO Prefix used for this client account",
      type: "string",
      default: null,
    },
    po_start_nbr: {
      title: "PO Start Number",
      description: "The minimum start number for the PO range in this group.",
      type: "string",
    },
    po_next_nbr: {
      title: "PO Next Number",
      description: "The next value used for generating a PO in this group.",
      type: "string",
    },
    po_end_nbr: {
      title: "PO End Number",
      description: "The maximum number for the PO range for this group.",
      type: "string",
      default: null,
    },
    require_requestor_sw: {
      title: "Require Requestor",
      description:
        "Flag indicates if requestor is required with this PO group.",
      type: "boolean",
      default: false,
    },
    require_ship_via_sw: {
      title: "Require Ship Via",
      description: "Flag indicates if PO group requires ship via for a PO.",
      type: "boolean",
      default: false,
    },
    require_header_comment_sw: {
      title: "Header Comment",
      description:
        "Flag indicates if PO group requires a header comment for a PO.",
      type: "boolean",
      default: false,
    },
    require_detail_comment_sw: {
      title: "Line Memo",
      description:
        "Flag indicates if PO group requires line level comments for a PO.",
      type: "boolean",
      default: false,
    },
    edit_approved_po_sw: {
      title: "Edit Approved",
      description: "Flag indicates PO marked as Aproved can still be edited.",
      type: "boolean",
      default: false,
    },
    require_modification_reason_sw: {
      title: "Require Modification Reason",
      description:
        "Flag indicates if modification reason is required for this PO group.",
      type: "boolean",
      default: false,
    },
    variance_amt: {
      title: "Variance Amount",
      description: "The variance amount",
      type: "number",
      default: 0,
    },
    history_retention_months_qty: {
      title: "History Retention Months",
      description: "Number of months POs will remain in archive.",
      type: "integer",
      default: null,
    },
    auto_archive_sw: {
      title: "Auto Archive",
      description:
        "Flag indicates automatic archive should occur for POs that are inactive, closed, or voided more than auto_archive_months.",
      type: "boolean",
      default: false,
    },
    auto_archive_months_qty: {
      title: "Auto Archive Months",
      description:
        "Number of months before PO qualifies for automatic archive if feature is auto_archive is on",
      type: "integer",
      default: null,
    },
    set_inactive_pos_sw: {
      title: "Set Inactive Switch",
      description:
        "Flag to allow automatic status update to inactive when inactive weeks criteria is met.",
      type: "boolean",
      default: false,
    },
    inactive_weeks_qty: {
      title: "Inactive Weeks",
      description:
        "Number of inactive weeks before PO qualifies for inactive status",
      type: "integer",
      default: null,
    },
    standard_form_sw: {
      title: "Use Standard Form",
      description:
        "Flag indicates if the PO group uses the standard form for a PO.",
      type: "boolean",
      default: true,
    },
    language_cd: {
      title: "Language Cd",
      description: "Language Code",
      enum: ["ENG", "ESP", "FRA"],
      type: "string",
      default: "ENG",
    },
    use_receiving_sw: {
      title: "Use PO Receiving Feature",
      description:
        "Flag to Indicates if PO group uses receiving functionality.",
      type: "boolean",
      default: false,
    },
    use_preinvoicing_sw: {
      title: "Use Preinvoicing",
      description: "Flag to indicate PO uses the preinvoing option.",
      type: "boolean",
      default: false,
    },
    allow_po_nbr_assignment_sw: {
      title: "Allow PO number assignment",
      description:
        "Flag to repeat the previously entered account. Indicates if journal uses the repeat option.",
      type: "boolean",
      default: false,
      isHidden: true,
    },
    include_alternate_shipping_sw: {
      title: "Include Alternate Shipping Address",
      description:
        "Flag indicates if alternate shipping addresses will be used with this PO group.",
      type: "boolean",
      default: false,
      isHidden: true,
    },
    max_po_nbr_length_qty: {
      title: "Maximum Length of the PO Number used for validation",
      description:
        "The maximum length of a PO number for the PO range in this group.",
      type: ["integer", "null"],
      default: null,
      isHidden: true,
    },
    default_dealer_address_id: {
      title: "Default Dealer Address Id",
      description: "The default Dealer Address ID for this PO Group.",
      type: ["string", "null"],
      minLength: 1,
      default: null,
      isHidden: true,
    },
    description: {
      title: "Description",
      description: "The Description",
      type: "boolean",
      default: false,
      isHidden: true,
    },
    temp_vendor_address: {
      title: "Temp Vendor Address",
      description: "Temporary Vendor Address",
      type: "boolean",
      default: false,
      isHidden: true,
    },
    active_sw: {
      title: "Temp Vendor Sw",
      description: "Switch defining whether the PO group is active for use",
      type: "boolean",
      default: true,
      isHidden: true,
    },
    dealer_nm: {
      title: "Dealer Nm",
      description: "Dealer Nm",
      type: ["string", "null"],
      default: null,
      isHidden: true,
    },
    converted_sw: {
      title: "Converted Sw",
      description: "Converted Sw",
      type: "boolean",
      default: false,
      isHidden: true,
    },
    group_addresses: {
      title: "Address(es)",
      description: "Shipping addresses",
      type: "array",
      items: {
        type: "object",
        properties: {
          addr_nm: {
            title: "Address name",
            description: "Address name",
            type: "string",
            isUnique: true,
          },
          addr_line1: {
            title: "Address 1",
            description: "Address Line 1",
            type: "string",
          },
          addr_line2: {
            title: "Address 2",
            description: "Address Line 2",
            type: ["string", "null"],
            default: null,
          },
          city_nm: {
            title: "City name",
            description: "City name",
            type: "string",
          },
          county_nm: {
            title: "County Nm",
            description: "County Nm",
            type: ["string", "null"],
            minLength: 1,
            default: null,
          },
          state_cd: {
            title: "State code",
            description: "State code",
            type: "string",
            enum: [
              "AL",
              "AK",
              "AS",
              "AZ",
              "AR",
              "CA",
              "CO",
              "CT",
              "DE",
              "DC",
              "FM",
              "FL",
              "GA",
              "GU",
              "HI",
              "ID",
              "IL",
              "IN",
              "IA",
              "KS",
              "KY",
              "LA",
              "ME",
              "MH",
              "MD",
              "MA",
              "MI",
              "MN",
              "MS",
              "MO",
              "MT",
              "NE",
              "NV",
              "NH",
              "NJ",
              "NM",
              "NY",
              "NC",
              "ND",
              "MP",
              "OH",
              "OK",
              "OR",
              "PI",
              "PW",
              "PA",
              "PR",
              "RI",
              "SC",
              "SD",
              "TN",
              "TX",
              "UT",
              "VT",
              "VI",
              "VA",
              "WA",
              "WV",
              "WI",
              "WY",
              "AB",
              "BC",
              "LB",
              "MB",
              "NB",
              "NL",
              "NT",
              "NS",
              "ON",
              "PE",
              "PQ",
              "SK",
              "YT",
              "AW",
              "JM",
              "TR",
              "TO",
            ],
          },
          country_cd: {
            title: "Country code",
            description: "Country code",
            type: "string",
            enum: ["US", "CA", "AW", "JM", "TT"],
          },
          postal_cd: {
            title: "Postal code",
            description: "Postal code",
            type: "string",
          },
          addr_type: {
            title: "Address type",
            description: "Address type",
            type: "string",
            enum: ["BO", "PO"],
          },
          is_default_address: {
            title: "Set as Default",
            description: "set as default address",
            type: "boolean",
            default: false,
            evalMethod: "handlePOConfigurationGroupShippingInfoDefaultAddress",
          },
          area_cd: {
            title: "Area code",
            description: "Area code",
            type: ["string", "null"],
            minLength: 1,
            default: null,
          },
          phone_nbr: {
            title: "Phone Number",
            description: "Phone Number",
            type: "string",
            minLength: 1,
          },
          phone_ext_nbr: {
            title: "Phone ext number",
            description: "Phone ext number",
            type: ["string", "null"],
            minLength: 1,
            default: null,
          },
          phone_country_cd: {
            title: "Phone Country code",
            description: "Phone Country code",
            type: "string",
            enum: ["US", "CA", "AW", "JM", "TT"],
          },
          phone_type: {
            title: "Phone Type",
            description: "Phone Type",
            type: "string",
            enum: ["BOPhone", "BOFax", "POPhone", "POFax"],
          },
        },
        required: [
          "addr_nm",
          "addr_line1",
          "city_nm",
          "state_cd",
          "postal_cd",
          "country_cd",
          "phone_nbr",
          "area_cd",
          "phone_ext_nbr",
          "phone_type",
          "phone_country_cd",
        ],
      },
    },
    shipVias: {
      title: "Ship Via Codes",
      description: "Ship via codes",
      type: "array",
      items: {
        type: "object",
        properties: {
          ship_via_cd: {
            title: "Ship Via Code",
            description: "Defines the ship via code for the record.",
            type: "string",
            minLength: 1,
            isUnique: true,
          },
          ship_via_desc: {
            title: "Ship Via Description",
            description: "Describes the ship via record.",
            type: "string",
            minLength: 1,
          },
        },
        required: ["ship_via_cd", "ship_via_desc"],
      },
    },
    poTypes: {
      title: "PO Types",
      description: "PO types",
      type: "array",
      items: {
        type: "object",
        properties: {
          po_type_cd: {
            title: "PO Type Code",
            description:
              "Code defined for the PO type that is unique by PO group",
            type: "string",
            minLength: 1,
            isUnique: true,
          },
          po_type_desc: {
            title: "PO Type Description",
            description: "Description of the PO type",
            type: "string",
            minLength: 1,
          },
          po_nbr_on_create_sw: {
            title: "PO Number on Creation",
            description:
              "Flag to set automatic assignment of PO number on creation",
            type: "boolean",
            default: false,
          },
          validate_item_cat_sw: {
            title: "validate Item Category Option",
            description:
              "Switch defining whether item catalog items will be validated for this type",
            type: "boolean",
            default: false,
          },
          doc_nbr_required_id: {
            title: "Document number required Id",
            description: "Documednt number required Id",
            type: ["integer", "null"],
            default: null,
          },
          po_type_category: {
            title: "PO Type Category",
            description: "The base category for this custom category type",
            type: "string",
            enum: [
              "Miscellaneous",
              "Sublet",
              "Part Invoice",
              "Replenishment",
              "Vehicle",
            ],
            default: "Miscellaneous",
          },
          base_type_sw: {
            title: "Base Type",
            description: "Switch defining whether this type is a base type",
            type: "boolean",
            default: false,
          },
          temp_vendor_sw: {
            title: "Use Temp Vendor Option",
            description:
              "Switch defining whether the temp vendor option is active for this type",
            type: "boolean",
            default: false,
          },
          gl_coa_account: {
            title: "GL Account",
            description: "The GL Account used for posting",
            type: ["string", "null"],
            default: null,
          },
          dms_po_type_id: {
            title: "PO Type Id Number",
            description: "Unique PO Type Identifier",
            type: ["string", "null"],
            isHidden: true,
            default: null,
          },
          last_modified_po_user_id: {
            title: "Last Modified PO User Id",
            description: "PO User Identifier uniquely identifies a PO user",
            type: ["string", "null"],
            isHidden: true,
            default: null,
          },
          active_sw: {
            title: "Temp Vendor Sw",
            description:
              "Switch defining whether the PO group is active for use",
            type: "boolean",
            isHidden: true,
            default: true,
          },
          last_modified_dt: {
            title: "Last Modified Date",
            description:
              "Identifies the last date and time that this record was modified",
            type: ["string", "null"],
            isHidden: true,
            default: null,
          },
          use_receiving_sw: {
            title: "Use PO Receiving Feature",
            description:
              "Flag to Indicates if PO group uses receiving functionality.",
            type: "boolean",
            isHidden: true,
            default: false,
          },
          use_preinvoicing_sw: {
            title: "Use Preinvoicing",
            description: "Flag to indicate PO uses the preinvoing option.",
            type: "boolean",
            isHidden: true,
            default: false,
          },
        },
        required: ["po_type_cd", "po_type_desc"],
      },
    },
    group_stores: {
      title: "Assign Companies",
      description: "Assign Companies",
      evalMethod:
        "handlePOConfigurationGroupAccountsGLStoreOptionsOnStoresChange",
      type: "array",
      items: {
        type: "object",
        properties: {
          store_id: {
            title: "Store ID",
            type: "string",
            isStore: true,
            companyKey: "company_id",
            isUnique: true,
          },
          company_id: {
            title: "Company ID",
            type: "string",
            disabled: true,
          },
        },
        required: ["store_id"],
      },
    },
    group_accounts: {
      title: "Assign Group Accounts",
      description: "Assign Group Accounts",
      isUnique: true,
      key: "acc_name",
      type: "array",
      items: {
        type: "string",
      },
    },
    ref_store: {
      title: "Ref Store",
      description: "GL Store",
      type: "string",
      isStore: true,
      companyKey: "ref_company",
      dependentFields: ["ref_account"],
    },
    ref_company: {
      title: "Ref Company",
      description: "GL Company",
      type: "string",
      disabled: true,
    },
    ref_account: {
      title: "Ref Account",
      description: "GL Account",
      type: "string",
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
          ],
          responseFields: ["account_number", "account_description"],
        },
        valueField: "account_number",
        storeId: "$ref_store",
        labelField: ["account_number", "account_description"],
      },
    },
  },
  required: [],
  sections: {
    grid_fields: ["po_group_cd", "po_group_desc"],
    poGroupTab: {
      setup_group_fields: [
        "po_group_cd",
        "po_group_desc",
        "acc_name",
        "converted_sw",
        "max_po_nbr_length_qty",
        "default_dealer_address_id",
        "description",
        "dealer_nm",
        "include_alternate_shipping_sw",
        "allow_po_nbr_assignment_sw",
        "temp_vendor_address",
        "active_sw",
      ],
      assign_po_numbers_fields: [
        "po_nbr_prefix_cd",
        "po_start_nbr",
        "po_next_nbr",
        "po_end_nbr",
      ],
      designate_required_fields: [
        "require_requestor_sw",
        "require_ship_via_sw",
        "require_header_comment_sw",
        "require_detail_comment_sw",
      ],
      workflow_default_fields: [
        "edit_approved_po_sw",
        "require_modification_reason_sw",
        "variance_amt",
        "use_receiving_sw",
        "use_preinvoicing_sw",
      ],
      archive_history_fields: [
        "history_retention_months_qty",
        "auto_archive_sw",
        "auto_archive_months_qty",
        "set_inactive_pos_sw",
        "inactive_weeks_qty",
      ],
      printing_fields: ["standard_form_sw", "language_cd"],
    },
    poAccountsTab: {
      accounts: ["group_accounts"],
      companies: {
        corelation_fields: ["group_stores"],
      },
      gl_account: ["ref_store", "ref_company", "ref_account"],
    },
    poAddressTab: {
      corelation_fields: ["group_addresses"],
    },
    shipViasTab: {
      corelation_fields: ["shipVias"],
    },
    poTypesTab: {
      corelation_fields: ["poTypes"],
    },
  },
};

export const MOCK_PO_CONFIGURATION_GROUP_ROW_DATA: RowData = {
  poGroupTab: {
    id: "52e77489-8d6f-4ef0-8930-6fd1f839cce7",
    last_modified_dt: null,
    converted_sw: false,
    cnumber: "C300745",
    dealer_nm: null,
    active_sw: true,
    last_modified_po_user_id: null,
    language_cd: "ENGLISH",
    default_dealer_address_id: null,
    description: true,
    variance_amt: null,
    standard_form_sw: false,
    max_po_nbr_length_qty: null,
    temp_vendor_address: false,
    po_start_nbr: null,
    po_end_nbr: null,
    require_detail_comment_sw: false,
    require_header_comment_sw: false,
    require_ship_via_sw: false,
    require_requestor_sw: false,
    po_next_nbr: null,
    auto_archive_months_qty: null,
    require_modification_reason_sw: false,
    auto_archive_sw: false,
    set_inactive_pos_sw: false,
    inactive_weeks_qty: null,
    edit_approved_po_sw: false,
    history_retention_months_qty: null,
    include_alternate_shipping_sw: false,
    use_receiving_sw: false,
    allow_po_nbr_assignment_sw: false,
    po_nbr_prefix_cd: null,
    po_group_cd: "PLF-A_default",
    po_group_desc: "PLF-A PO Group",
    dms_po_group_id: null,
    version: "V1",
    use_preinvoicing_sw: true,
    acc_name: "PLF-A",
    serial_no: 84,
    enterprise_id: "E339440",
    active_status: "active",
    created_by: "sys-user-dms-admin",
    created_at: "2024-02-19T06:40:17.033+00:00",
    updated_by: "sys-user-dms-admin",
    updated_at: "2024-02-19T10:58:21.996+00:00",
  },
  poAccountsTab: {
    group_stores: [
      {
        store_id: "S100119371",
        company_id: "5",
      },
      {
        store_id: "S100119370",
        company_id: "4",
      },
    ],
    group_accounts: [
      {
        acc_name: "PLF-A",
      },
      {
        acc_name: "BDC-A",
      },
    ],
    ref_store: "S100119373",
    ref_company: "7",
    ref_account: "47101",
  },
  poAddressTab: {
    group_addresses: [
      {
        addr_nm: "Main Office",
        addr_line1: "123 Elm Street, Building A",
        addr_line2: "Suite 100, 1st Floor",
        city_nm: "Springfield",
        county_nm: "Greene",
        state_cd: "MO",
        country_cd: "US",
        postal_cd: "65804",
        addr_type: "BO",
        is_default_address: false,
        area_cd: "417",
        phone_nbr: "5551234567",
        phone_ext_nbr: "101",
        phone_country_cd: "US",
        phone_type: "BOPhone",
      },
      {
        addr_nm: "Warehouse 1",
        addr_line1: "456 Oak Avenue, North Dock",
        addr_line2: "Receiving Area",
        city_nm: "Chicago",
        county_nm: null,
        state_cd: "IL",
        country_cd: "US",
        postal_cd: "60601",
        addr_type: "PO",
        is_default_address: false,
        area_cd: "312",
        phone_nbr: "5559876543",
        phone_ext_nbr: null,
        phone_country_cd: "US",
        phone_type: "POPhone",
      },
      {
        addr_nm: "Toronto Branch",
        addr_line1: "789 Maple Road, Unit 5",
        addr_line2: "Unit B, North Wing",
        city_nm: "Toronto",
        county_nm: null,
        state_cd: "ON",
        country_cd: "CA",
        postal_cd: "M5V 2T6",
        addr_type: "BO",
        is_default_address: false,
        area_cd: "416",
        phone_nbr: "4165557788",
        phone_ext_nbr: null,
        phone_country_cd: "CA",
        phone_type: "BOPhone",
      },
      {
        addr_nm: "New York HQ",
        addr_line1: "100 5th Avenue, Corporate Tower",
        addr_line2: "Floor 20, Suite 2001",
        city_nm: "New York",
        county_nm: "New York",
        state_cd: "NY",
        country_cd: "US",
        postal_cd: "10011",
        addr_type: "BO",
        is_default_address: true,
        area_cd: "212",
        phone_nbr: "5553334444",
        phone_ext_nbr: "301",
        phone_country_cd: "US",
        phone_type: "BOFax",
      },
      {
        addr_nm: "Customer Support",
        addr_line1: "88 Tech Park, Building 3",
        addr_line2: "Block C, Suite 12",
        city_nm: "San Jose",
        county_nm: null,
        state_cd: "CA",
        country_cd: "US",
        postal_cd: "95134",
        addr_type: "PO",
        is_default_address: false,
        area_cd: "408",
        phone_nbr: "4082221234",
        phone_ext_nbr: null,
        phone_country_cd: "US",
        phone_type: "POFax",
      },
      {
        addr_nm: "Remote Office",
        addr_line1: "777 Remote Lane, West Wing",
        addr_line2: "N/A", // placeholder for 2nd line
        city_nm: "Boise",
        county_nm: "Ada",
        state_cd: "ID",
        country_cd: "US",
        postal_cd: "83701",
        addr_type: "BO",
        is_default_address: false,
        area_cd: "208",
        phone_nbr: "2089998888",
        phone_ext_nbr: "102",
        phone_country_cd: "US",
        phone_type: "BOPhone",
      },
      {
        addr_nm: "Caribbean Office",
        addr_line1: "12 Palm Beach, Oceanfront",
        addr_line2: "Suite 3, Building 7",
        city_nm: "Oranjestad",
        county_nm: null,
        state_cd: "AW",
        country_cd: "AW",
        postal_cd: "29700",
        addr_type: "PO",
        is_default_address: false,
        area_cd: "297",
        phone_nbr: "2971234567",
        phone_ext_nbr: null,
        phone_country_cd: "AW",
        phone_type: "POPhone",
      },
      {
        addr_nm: "Jamaica Hub",
        addr_line1: "34 Kingston Road",
        addr_line2: "N/A", // placeholder for 2nd line
        city_nm: "Kingston",
        county_nm: null,
        state_cd: "JM",
        country_cd: "JM",
        postal_cd: "00001",
        addr_type: "BO",
        is_default_address: false,
        area_cd: "876",
        phone_nbr: "8765551234",
        phone_ext_nbr: null,
        phone_country_cd: "JM",
        phone_type: "BOPhone",
      },
      {
        addr_nm: "Support Center",
        addr_line1: "200 Tech Boulevard, Building A",
        addr_line2: "Room 5, 3rd Floor",
        city_nm: "Austin",
        county_nm: "Travis",
        state_cd: "TX",
        country_cd: "US",
        postal_cd: "73301",
        addr_type: "BO",
        is_default_address: false,
        area_cd: "512",
        phone_nbr: "5125556677",
        phone_ext_nbr: null,
        phone_country_cd: "US",
        phone_type: "BOPhone",
      },
      {
        addr_nm: "Montreal Branch",
        addr_line1: "321 St Laurent Boulevard",
        addr_line2: "N/A", // placeholder for 2nd line
        city_nm: "Montreal",
        county_nm: null,
        state_cd: "QC",
        country_cd: "CA",
        postal_cd: "H2Y 2Y5",
        addr_type: "PO",
        is_default_address: false,
        area_cd: "514",
        phone_nbr: "5145559988",
        phone_ext_nbr: null,
        phone_country_cd: "CA",
        phone_type: "POFax",
      },
    ],
  },
  shipViasTab: {
    shipVias: [
      {
        id: "ed0f6116-a016-4310-bc0f-8f15ccf6290f",
        ship_via_desc: "Testing",
        ship_via_cd: "TEST",
        ship_via_id: null,
        cnumber: "C300745",
        serial_no: 217,
        enterprise_id: "E339440",
        active_status: "active",
        created_by: "OM@E339440.com",
        created_at: "2024-02-19T06:40:17.033+00:00",
        updated_by: "OM@E339440.com",
        updated_at: "2025-06-12T05:12:36.327+00:00",
      },
      {
        id: "41055610-ec77-47de-9c1d-3e2fc2ca622d",
        ship_via_desc: "Final",
        ship_via_cd: "FINAL",
        ship_via_id: null,
        cnumber: "C300745",
        serial_no: 222,
        enterprise_id: "E339440",
        active_status: "active",
        created_by: "OM@E339440.com",
        created_at: "2025-05-28T08:39:54.806+00:00",
        updated_by: "OM@E339440.com",
        updated_at: "2025-06-12T05:12:36.949+00:00",
      },
    ],
  },
  poTypesTab: {
    poTypes: [
      {
        id: "0a0d2d27-3951-42cc-a250-4608a49bbaed",
        active_sw: true,
        temp_vendor_sw: true,
        use_preinvoicing_sw: true,
        use_receiving_sw: false,
        validate_item_cat_sw: false,
        po_nbr_on_create_sw: false,
        po_type_desc: "Miscellaneous",
        po_type_cd: "Misc",
        doc_nbr_required_id: null,
        gl_coa_account: "2100",
        base_type_sw: false,
        dms_po_type_id: null,
        last_modified_po_user_id: null,
        last_modified_dt: null,
        cnumber: "C300745",
        po_type_category: "Miscellaneous",
        serial_no: 264,
        enterprise_id: "E339440",
        active_status: "active",
        created_by: "sys-user-dms-admin",
        created_at: "2024-02-19T06:40:17.357+00:00",
        updated_by: "sys-user-dms-admin",
        updated_at: "2024-02-19T11:09:10.478+00:00",
      },
      {
        id: "6b72abc9-1744-4a8d-a234-6bffc62dca7f",
        active_sw: true,
        temp_vendor_sw: true,
        use_preinvoicing_sw: true,
        use_receiving_sw: false,
        validate_item_cat_sw: false,
        po_nbr_on_create_sw: false,
        po_type_desc: "Sublet",
        po_type_cd: "Sublet",
        doc_nbr_required_id: null,
        gl_coa_account: "7705",
        base_type_sw: false,
        dms_po_type_id: null,
        last_modified_po_user_id: null,
        last_modified_dt: null,
        cnumber: "C300745",
        po_type_category: "Sublet",
        serial_no: 265,
        enterprise_id: "E339440",
        active_status: "active",
        created_by: "sys-user-dms-admin",
        created_at: "2024-02-19T06:40:17.385+00:00",
        updated_by: "sys-user-dms-admin",
        updated_at: "2024-02-19T06:40:17.385+00:00",
      },
      {
        id: "7611282c-0c77-4d3d-ae6e-e7c32f5f4111",
        active_sw: true,
        temp_vendor_sw: true,
        use_preinvoicing_sw: true,
        use_receiving_sw: false,
        validate_item_cat_sw: false,
        po_nbr_on_create_sw: false,
        po_type_desc: "Part Invoice",
        po_type_cd: "Parts",
        doc_nbr_required_id: null,
        gl_coa_account: "14000",
        base_type_sw: false,
        dms_po_type_id: null,
        last_modified_po_user_id: null,
        last_modified_dt: null,
        cnumber: "C300745",
        po_type_category: "Part Invoice",
        serial_no: 266,
        enterprise_id: "E339440",
        active_status: "active",
        created_by: "sys-user-dms-admin",
        created_at: "2024-02-19T06:40:17.407+00:00",
        updated_by: "sys-user-dms-admin",
        updated_at: "2024-02-19T06:40:17.406+00:00",
      },
      {
        id: "b9c91488-43c1-4e14-93ea-bf94802ddafb",
        active_sw: true,
        temp_vendor_sw: true,
        use_preinvoicing_sw: true,
        use_receiving_sw: false,
        validate_item_cat_sw: false,
        po_nbr_on_create_sw: false,
        po_type_desc: "Vehicle",
        po_type_cd: "Vehicle",
        doc_nbr_required_id: null,
        gl_coa_account: null,
        base_type_sw: false,
        dms_po_type_id: null,
        last_modified_po_user_id: null,
        last_modified_dt: null,
        cnumber: "C300745",
        po_type_category: "Vehicle",
        serial_no: 267,
        enterprise_id: "E339440",
        active_status: "active",
        created_by: "sys-user-dms-admin",
        created_at: "2024-02-19T06:40:17.429+00:00",
        updated_by: "sys-user-dms-admin",
        updated_at: "2024-02-19T06:40:17.429+00:00",
      },
    ],
  },
  __existingRecordId: "52e77489-8d6f-4ef0-8930-6fd1f839cce7",
  __existingRecordCreatedBy: "sys-user-cdcm",
};

export const MOCK_PO_CONFIGURATION_GROUP_ROW_DATA_LIST: RowData[] = [
  {
    dms_po_group_id: null,
    id: "ce22a4fe-46d3-4620-95c1-f23af76d28ad",
    po_group_cd: "TEST",
    po_group_desc: "Testing",
    acc_name: "PLF-A",
    enterprise_id: "E339440",
    created_by: "sys-user-cdcm",
  },
  {
    dms_po_group_id: null,
    id: "8395bdf1-7e84-4121-bbf3-b80c5c2708db",
    po_group_cd: "TEST_2",
    po_group_desc: "Testing 2",
    acc_name: "PLF-A",
    enterprise_id: "E339440",
    created_by: "sys-user-cdcm",
  },
  {
    dms_po_group_id: null,
    id: "9d33f7e1-7a60-44fd-8674-5e3129d22383",
    po_group_cd: "TEST_1",
    po_group_desc: "Testing 1",
    acc_name: "PLF-A",
    enterprise_id: "E339440",
    created_by: "sys-user-cdcm",
  },
  {
    dms_po_group_id: null,
    id: "3bc34c55-a51f-4e0e-98ae-0e4244112527",
    po_group_cd: "TEST_3",
    po_group_desc: "Testing 3",
    acc_name: "PLF-A",
    enterprise_id: "E339440",
    created_by: "sys-user-cdcm",
  },
  {
    dms_po_group_id: null,
    id: "52e77489-8d6f-4ef0-8930-6fd1f839cce7",
    po_group_cd: "PLF-A_default",
    po_group_desc: "PLF-A PO Group",
    acc_name: "PLF-A",
    enterprise_id: "E339440",
    created_by: "sys-user-cdcm",
  },
];

export const MOCK_PO_UNIT_OF_MEASURE_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-setup-pounits-of-measure-schema.json",
  title: "POUnitsOfMeasure",
  description: "A schema definition for Purchase Order Units of Measure",
  type: "object",
  properties: {
    uom_desc: {
      title: "Unit of Measure Description",
      description: "Describes the Unit of Measure",
      type: "string",
      enum: [
        "Each",
        "Pack of 4",
        "Pack of 6",
        "Case",
        "Dozen",
        "Ream",
        "Inch",
        "Foot",
        "Yard",
        "Ounce",
        "Pound",
        "Pint",
        "Quart",
        "Liters",
        "Gallon",
        "Barrel",
        "Centimeter",
        "Meter",
        "Gram",
        "Kilogram",
      ],
      default: "Each",
      isEditable: false,
      evalMethod: "updateUOMCode",
    },
    uom_cd: {
      title: "Unit of measure Code",
      description:
        "Defines the code used for this unit of measure record that must be unique by Accounting application account",
      type: "string",
      isUnique: true,
      isEditable: false,
    },
    bus_unit_id: {
      title: "Business Unit ID",
      description: "Business Unit ID uniquely identifies a business unit",
      type: "string",
    },
    uom_id: {
      title: "Unit of measure ID",
      description: "Uniquely identifies a unit of measure record",
      type: ["string", "null"],
      default: null,
    },
    active_sw: {
      title: "Active Switch",
      description: "Active Switch true means the unit of measure is active",
      type: "boolean",
      default: true,
    },
    last_modified_po_user_id: {
      title: "Last Modified PO User ID",
      description: "PO User Identifier uniquely identifies a PO user",
      type: "string",
    },
    last_modified_dt: {
      title: "Last Modified Date",
      description:
        "Identifies the last date and time that this record was modified",
      type: ["string", "null"],
      default: null,
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    store_id: {
      title: "Store",
      description: "Store identifier",
      type: "string",
      minLength: 1,
    },
    active_status: {
      title: "Status",
      description: "Determines whether the object is in active use.",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
      default: "inactive",
    },
  },
  required: [
    "enterprise_id",
    "store_id",
    "active_status",
    "uom_cd",
    "uom_desc",
  ],
  sections: {
    grid_fields: ["uom_cd", "uom_desc"],
    general_fields: ["uom_desc", "uom_cd"],
  },
};

export const MOCK_PO_UNITS_OF_MEASURE_COLDEFS: ColDef[] = [
  {
    field: "uom_cd",
    headerName: "Unit of measure Code",
  },
  {
    field: "uom_desc",
    headerName: "Unit of Measure Description",
  },
];

export const MOCK_PO_UNITS_OF_MEASURE_ROWDATA: RowData = {
  uom_cd: "EA",
  uom_desc: "Each",
  active_sw: true,
  bus_unit_id: "e8cc3522-f9a7-42f3-be59-d707a2a60872",
  last_modified_po_user_id: "192127000000000001",
  last_modified_dt: "2025-06-20 04:34:22.682056",
  store_id: "S100119371",
};

export const MOCK_JOURNAL_TEMPLATE_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-journaltemplates-schema.json",
  title: "JournalTemplates",
  description: "Stores optional journal entry posting templates data",
  functional_area: "ACCT",
  type: "object",
  properties: {
    template_id: {
      title: "Journal Template ID",
      description:
        "User defined identifier for a journal entry posting template",
      type: "string",
      minLength: 1,
      maxLength: 10,
      pattern: "^[A-Z0-9]+$",
      isUnique: true,
      isEditable: false,
    },
    template_description: {
      title: "Journal Template Description",
      description: "Journal entry template description.",
      type: "string",
      minLength: 1,
      maxLength: 30,
    },
    productivity_number: {
      title: "Productivity Number",
      description:
        "Productivity number. 2 fields delimited by a ^. Attributes 2-9 are correlated.",
      type: ["string", "null"],
      minLength: 1,
      maxLength: 10,
      pattern: "^([A-Z0-9]+|null)$",
      default: null,
    },
    default_amount: {
      title: "Default Amount",
      description: "Default amount. Supports Debit or Credit signage",
      type: ["number", "null"],
      minimum: -9999999999,
      maximum: 99999999999,
      default: null,
    },
    source_company_id: {
      title: "Source Company ID",
      description: "Source Company identifier",
      type: "string",
      minLength: 1,
      maxLength: 3,
      pattern: "^[A-Z0-9]+$",
    },
    control_1_number: {
      title: "Control Number 1",
      description: "Control number 1",
      type: ["string", "null"],
      minLength: 1,
      maxLength: 17,
      pattern: "^([A-Z0-9- ]+|[*]|null)$",
      default: null,
    },
    control_2_number: {
      title: "Control 2 Number",
      description: "Control 2 number. Attributes 2-9 are correlated.",
      type: ["string", "null"],
      minLength: 1,
      maxLength: 17,
      pattern: "^([A-Z0-9-]+|[*]|null)$",
      default: null,
    },
    statistical_count: {
      title: "Statistical Count",
      description: "Statistical Count. Attributes 2-9 are correlated.",
      type: ["number", "null"],
      minimum: 1,
      maximum: 9999,
      pattern: "^([0-9]+|null)$",
      default: null,
    },
    post_description: {
      title: "Posting Description",
      description: "Posting description. Attributes 2-9 are correlated.",
      type: ["string", "null"],
      minLength: 1,
      maxLength: 132,
      default: null,
    },
    account_number: {
      title: "Account Number",
      description:
        "Account number. The account number is either a full Base Account or a partial that ends in an asterisk",
      type: ["string", "null"],
      minLength: 1,
      maxLength: 7,
      pattern: "^[A-Z0-9*]+$",
      default: null,
    },
    default_amount_val: {
      title: "Default Amount",
      description: "Default amount. Supports Debit or Credit signage",
      type: ["string", "null"],
      minLength: 1,
      maxLength: 11,
      pattern: "^([0-9.()+-]+|null)$",
      default: null,
    },
    target_company_id: {
      title: "Target Company ID",
      description: "Target Company Identifier, Attributes 2-9 are correlated.",
      type: ["string", "null"],
      minLength: 1,
      maxLength: 3,
      pattern: "^[A-Z0-9]+$",
      default: null,
    },
    record_type: {
      title: "Record type",
      description:
        "Identifies the de-normalized record types associated with the schema",
      type: "string",
      enum: ["Base", "Journal Template Entry Reference"],
      default: "Base",
    },
    journal_template_entry_reference: {
      title: "Journal Template Entry Reference",
      description: "A list of journal template entry references",
      type: "array",
      items: {
        type: "object",
        properties: {
          account_number: {
            title: "Account Number",
            description:
              "Account number. The account number is either a full Base Account or a partial that ends in an asterisk",
            type: "string",
            typeaheadConfig: {
              url: "/v2/search/COA",
              minChars: 2,
              body: {
                filters: [
                  {
                    field: "record_type",
                    operator: "EQUALS",
                    value: "Base",
                  },
                  {
                    field: "account_type",
                    operator: "IN",
                    value: [
                      "Asset",
                      "Cost of Sale",
                      "Operating Expense",
                      "Non-Operating Income",
                      "Liability",
                      "Memo",
                    ],
                  },
                ],
                responseFields: ["account_description", "account_number"],
              },
              valueField: "account_number",
              labelField: ["account_number", "account_description"],
            },
          },
          default_amount: {
            title: "Default Amount",
            description: "Default amount. Supports Debit or Credit signage",
            type: "number",
          },
          control_1_number: {
            title: "Control Number 1",
            description: "Control number 1",
            type: "string",
          },
          control_2_number: {
            title: "Control 2 Number",
            description: "Control 2 number. Attributes 2-9 are correlated.",
            type: "string",
          },
          statistical_count: {
            title: "Statistical Count",
            description: "Statistical Count. Attributes 2-9 are correlated.",
            type: "number",
          },
          post_description: {
            title: "Posting Description",
            description: "Posting description. Attributes 2-9 are correlated.",
            type: "string",
          },
        },
        required: ["account_number"],
      },
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    store_id: {
      title: "Store",
      description: "Store identifier",
      type: "string",
      minLength: 1,
    },
    tenant_id: {
      title: "Tenant",
      description: "Tenant identifier",
      type: "string",
      minLength: 1,
    },
    company_id: {
      title: "Company",
      description: "Company identifier",
      type: ["string", "null"],
      default: null,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
      default: "inactive",
    },
    transaction_id: {
      title: "Transaction Id",
      description: "Transaction id from salesforce ",
      type: ["string", "null"],
      minLength: 1,
      default: null,
    },
  },
  required: [
    "source_company_id",
    "template_id",
    "template_description",
    "enterprise_id",
    "store_id",
  ],
  sections: {
    grid_fields: ["template_id", "template_description"],
    general_fields: ["template_id", "template_description"],
    corelation_fields: ["journal_template_entry_reference"],
  },
};

export const MOCK_REMITTANCE_FORM_MAPPING_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-rfm-schema.json",
  title: "RemittanceFormMapping",
  description: "A schema definition for a Remittance Form Mapping object",
  functional_area: "ACCT",
  type: "object",
  properties: {
    cash_store_id: {
      title: "Cash Store",
      description: "Store identifier",
      type: "string",
      minLength: 1,
      isStore: true,
      uniqueCombination: ["cash_store_id", "cash_account"],
      companyKey: "cash_company_id",
      isEditable: false,
      dependentFields: ["cash_account", "form_id"],
    },
    cash_company_id: {
      title: "Cash Company ",
      description: "Cash Company ID",
      type: "string",
      disabled: true,
    },
    cash_account: {
      title: "Cash Account",
      description: "Cash account from Laser Form Table",
      type: "string",
      isEditable: false,
      uniqueCombination: ["cash_store_id", "cash_account"],
      typeaheadConfig: {
        url: "/v2/search/LaserFormTable",
        minChars: 2,
        body: {
          filters: [
            {
              field: "cash_company_id",
              operator: "EQUALS",
              value: "$cash_company_id",
            },
          ],
          responseFields: ["account_no"],
        },
        storeId: "$cash_store_id",
        valueField: "account_no",
        labelField: ["account_no"],
      },
    },
    forms: {
      title: "Forms",
      description: "List of forms associated with the cash account",
      type: "array",
      items: {
        type: "object",
        properties: {
          form_id: {
            title: "Form ID",
            description: "eForm ID",
            type: ["string", "null"],
            default: null,
            evalMethod: "addRemittanceFormMappingEmptyEnumForFormId",
            dependentFields: ["provision_id"],
          },
          provision_id: {
            title: "Provision ID",
            description: "eForm Provision ID",
            type: ["string", "null"],
            evalMethod: "addRemittanceFormMappingEmptyEnumForProvisionId",
            default: null,
          },
        },
      },
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    store_id: {
      title: "Store",
      description: "Store identifier",
      type: "string",
      minLength: 1,
    },
    tenant_id: {
      title: "Tenant",
      description: "Tenant identifier",
      type: "string",
      minLength: 1,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
      default: "inactive",
    },
  },
  required: [
    "cash_store_id",
    "cash_company_id",
    "cash_account",
    "enterprise_id",
    "store_id",
  ],
  sections: {
    grid_fields: ["cash_store_id", "cash_company_id", "cash_account"],
    general_fields: ["cash_store_id", "cash_company_id", "cash_account"],
    corelation_fields: ["forms"],
  },
};

export const MOCK_VENDOR_CONFIGURATION_GROUP_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-vendor-company-type-schema.json",
  title: "VendorConfigurationGroup",
  description: "A schema definition for vendor company types",
  functional_area: "ACCT",
  type: "object",
  properties: {
    company_type: {
      title: "Company Type",
      description: "Vendor Company Type",
      type: "array",
      items: {
        type: "string",
        pattern: "^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-_*.]{0,23}[a-zA-Z0-9])$",
      },
    },
    category_description: {
      title: "Category Description",
      description: "Vendor category record identifier",
      type: "array",
      items: {
        type: "string",
        pattern: "^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-_*.]{0,23}[a-zA-Z0-9])$",
      },
    },
    payment_type: {
      title: "Payment Type",
      description: "Payment type identifier",
      type: "string",
      pattern: "^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-_*.]*[a-zA-Z0-9])$",
      isUnique: true,
      isEditable: false,
    },
    payment_description: {
      title: "Payment Description",
      description: "Description of vendor payment type",
      type: ["string", "null"],
      default: null,
    },
    payment_category_type: {
      title: "Payment Category Type",
      description: "Vendor Payment category type",
      type: "string",
      enum: ["Epayable", "Check", "ACH", "Credit Card"],
    },
    routing_required: {
      title: "Routing or Account Number Required",
      description: "Indicates if a routing or account number is required",
      type: "boolean",
      default: false,
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    store_id: {
      title: "Store",
      description: "Store identifier",
      type: "string",
      minLength: 1,
    },
    tenant_id: {
      title: "Tenant",
      description: "Tenant identifier",
      type: "string",
      minLength: 1,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
      default: "inactive",
    },
  },
  required: [
    "enterprise_id",
    "store_id",
    "company_type",
    "category_description",
    "payment_type",
    "routing_required",
  ],
  sections: {
    vendorCompanyTypeTab: {
      vendor_company_fields: ["company_type"],
    },
    vendorCategoryTab: {
      vendor_category_fields: ["category_description"],
    },
    vendorPaymentTypesTab: {
      grid_fields: [
        "payment_type",
        "payment_description",
        "payment_category_type",
        "routing_required",
      ],
      vendor_payment_fields: [
        "payment_type",
        "payment_description",
        "payment_category_type",
        "routing_required",
      ],
    },
  },
};

export const VENDOR_SETUPS_CONFIGURATION_ROWDATA: RowData = {
  vendorCompanyTypeTab: {
    company_type: [],
  },
  vendorCategoryTab: {
    category_description: [],
  },
  vendorPaymentTypesTab: {
    payment_type: "",
    payment_description: null,
    payment_category_type: "",
    routing_required: false,
  },
};

export const VENDOR_SETUPS_CONFIGURATION_ROWDATALIST: RowData[] = [
  {
    vendorCompanyTypeTab: [],
  },
  {
    vendorCategoryTab: [],
  },
  {
    vendorPaymentTypesTab: [
      {
        id: "a429c83a-bc88-4112-8fa9-12cb36bdb9ac",
        tenant_id: "cbcfdfc5-d6f5-4a51-8f40-a2eda90c8c63",
        store_id: "S100119371",
        payment_type: "cheque",
        payment_description: "Cheque deposit2",
        posting_company: null,
        posting_account: null,
        routing_required: true,
        payment_category_type: "Epayable",
        group_id: "G000008454",
        transaction_id: null,
        serial_no: 4399,
        enterprise_id: "E339440",
        active_status: "active",
        created_by: "OM@E339440.com",
        created_at: "2025-11-19T07:50:15.398+00:00",
        updated_by: "OM@E339440.com",
        updated_at: "2025-12-22T10:31:23.603+00:00",
      },
      {
        id: "9f643928-10c9-4d86-ac8f-5485121ca739",
        tenant_id: "cbcfdfc5-d6f5-4a51-8f40-a2eda90c8c63",
        store_id: "S100119371",
        payment_type: "cash",
        payment_description: "Cash Payment1",
        posting_company: null,
        posting_account: null,
        routing_required: true,
        payment_category_type: "ACH",
        group_id: "G000008454",
        transaction_id: null,
        serial_no: 4743,
        enterprise_id: "E339440",
        active_status: "active",
        created_by: "OM@E339440.com",
        created_at: "2025-12-22T10:11:36.376+00:00",
        updated_by: "OM@E339440.com",
        updated_at: "2025-12-22T10:27:22.772+00:00",
      },
    ],
  },
];

export const MOCK_LABOR_CODE_TYPE_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-setup-service-labor-types-schema.json",
  title: "LaborTypes",
  description: "A schema definition for service Labor Types",
  functional_area: "SVC",
  type: "object",
  properties: {
    labor_type: {
      title: "Labor Type Code",
      description: "Labor Type code",
      type: "string",
      pattern: "^[ICW][a-zA-Z0-9]{0,4}$",
      minLength: 1,
    },
    description: {
      title: "Description",
      description: "Labor Type Description",
      type: "string",
      minLength: 1,
    },
    journal_source_co: {
      title: "Source Company",
      description: "Source company",
      type: "string",
      minLength: 1,
    },
    journal_source: {
      title: "Journal",
      description: "Journal Source",
      type: "string",
      minLength: 1,
    },
    debit_acct_target_co: {
      title: "Debit Account Target Company",
      description: "Debit acct - target company",
      type: ["string", "null"],
      default: null,
    },
    debit_acct: {
      title: "Debit Account",
      description: "Debit account for all warranty",
      type: ["string", "null"],
      default: null,
      isEditable: false,
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "account_type",
              operator: "EQUALS",
              value: "Sale",
            },
          ],
          responseFields: ["account_description", "account_number", "sub_type"],
        },
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    labor_sale_acct: {
      title: "LaborSaleAcct",
      description: "Labor sale acct number",
      type: ["string", "null"],
      default: null,
      isEditable: false,
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "account_type",
              operator: "EQUALS",
              value: "Sale",
            },
          ],
          responseFields: ["account_description", "account_number", "sub_type"],
        },
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },

    lube_sale_acct: {
      title: "LubeSaleAcct",
      description: "Lube sale acct number",
      type: ["string", "null"],
      default: null,
      isEditable: false,
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "account_type",
              operator: "EQUALS",
              value: "Sale",
            },
          ],
          responseFields: ["account_description", "account_number", "sub_type"],
        },
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },

    misc_sale_acct: {
      title: "MiscSaleAcct",
      description: "Misc sale account number",
      type: ["string", "null"],
      default: null,
      isEditable: false,
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "account_type",
              operator: "EQUALS",
              value: "Sale",
            },
          ],
          responseFields: ["account_description", "account_number", "sub_type"],
        },
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    parts_sale_acct: {
      title: "PartsSaleAcct",
      description: "Part sale acct number",
      type: ["string", "null"],
      default: null,
      isEditable: false,
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "account_type",
              operator: "EQUALS",
              value: "Sale",
            },
          ],
          responseFields: ["account_description", "account_number", "sub_type"],
        },
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
      minLength: 1,
    },
    sublet_sale_acct: {
      title: "SubletSaleAcct",
      description: "Sublet sale account number",
      type: ["string", "null"],
      default: null,
      isEditable: false,
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "account_type",
              operator: "EQUALS",
              value: "Sale",
            },
          ],
          responseFields: ["account_description", "account_number", "sub_type"],
        },
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    sublet_labor_sale_acct: {
      title: "SubletLaborSaleAcct",
      description: "Sublet labor sale acct number",
      type: ["string", "null"],
      default: null,
      isEditable: false,
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "account_type",
              operator: "EQUALS",
              value: "Sale",
            },
          ],
          responseFields: ["account_description", "account_number", "sub_type"],
        },
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    sublet_parts_sale_acct: {
      title: "SubletPartsSaleAcct",
      description: "Sublet parts sale acct number",
      type: ["string", "null"],
      default: null,
      isEditable: false,
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "account_type",
              operator: "EQUALS",
              value: "Sale",
            },
          ],
          responseFields: ["account_description", "account_number", "sub_type"],
        },
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    grid_accounting_name: {
      title: "GridAccountingName",
      description: "Grid ID",
      type: ["string", "null"],
      default: null,
      isEditable: false,
      typeaheadConfig: {
        url: "/ROSetups",
        httpMethod: "GET",
        body: {
          filters: [],
          responseFields: [],
        },
        valueField: "grid_accounting_setup",
        labelField: ["grid_accounting_setup"],
      },
    },
    labor_pricing_by_labor_type_flag: {
      title: "LaborPricingByLaborTypeFlag",
      description: "Labor pricing by Labor Type only",
      type: "boolean",
      default: false,
    },
    grid_accounting_flag: {
      title: "GridAccountingFlag",
      description: "Use Grid Accounting",
      type: "boolean",
      default: false,
    },
    labor_pricing_code: {
      title: "LaborPricingCode",
      description: "Labor sale pricing code",
      type: "number",
      minimum: 1,
      maximum: 5,
    },
    labor_pricing_percent: {
      title: "LaborPricingPercent",
      description: "Labor sale pricing percent",
      type: "number",
      minimum: 0,
      maximum: 100,
    },
    labor_rate: {
      title: "LaborRate",
      description: "Labor rate",
      type: "number",
      minimum: 0,
      maximum: 9999.99,
      default: 0,
    },
    labor_pricing_grid_id: {
      title: "LaborPricingGridID",
      description: "Labor pricing grid",
      type: ["string", "null"],
      default: null,
      isEditable: false,
      typeaheadConfig: {
        url: "/search/LaborPricingGrids",
        minChars: 1,
        body: {
          filters: [
            {
              field: "active_status",
              operator: "EQUALS",
              value: "active",
            },
          ],
          responseFields: ["grid_id"],
        },
        valueField: "grid_id",
        labelField: ["grid_id"],
      },
    },
    calculate_shop_charges_flag: {
      title: "CalculateShopChargesFlag",
      description: "Calculate shop charge flag",
      type: "boolean",
      default: false,
    },
    parts_pricing_by_labor_type_flag: {
      title: "PartsPricingByLaborTypeFlag",
      description: "Parts pricing by labor type flag",
      type: "boolean",
      default: false,
    },
    part_pricing_code: {
      title: "PartPricingCode",
      description: "Parts pricing code",
      type: "string",
      pattern: "^((STD)|[1-9][0-9]{0,2})$",
      minLength: 1,
    },
    debit_accounting_from_inventory_flag: {
      title: "Use Debit account from inventory flag",
      description:
        "Indicates if labor type should use debit account from inventory",
      type: "boolean",
      default: false,
    },
    debit_acct_prompt: {
      title: "Prompt for Debit account",
      description: "Indicates if labor type should prompt for debit account",
      type: "boolean",
      default: false,
    },
    labor_sale_acct_display: {
      title: "Prompt for Labor Sale account",
      description: "Indicates if labor type should prompt for debit account",
      type: "boolean",
      default: false,
    },
    misc_sale_acct_prompt: {
      title: "Prompt for Misc Sale account",
      description:
        "Indicates if labor type should prompt for misc sale account",
      type: "boolean",
      default: false,
    },
    sublet_sale_acct_prompt: {
      title: "Prompt for Sublet Sale account",
      description:
        "Indicates if labor type should prompt for sublet sale account",
      type: "boolean",
      default: false,
    },
    journal_source_prompt: {
      title: "Prompt for Journal Source account",
      description: "Indicates if labor type should prompt for journal Source",
      type: "boolean",
      default: false,
    },
    debit_ctrl_prompt: {
      title: "Prompt for Debit Control",
      description: "Indicates if labor type should prompt for debit control",
      type: "boolean",
      default: false,
    },
    parts_sale_acct_prompt: {
      title: "Display Parts Sale Account",
      description:
        "Indicates if labor type should prompt for parts sale account",
      type: "boolean",
      default: false,
    },
    lube_sale_acct_prompt: {
      title: "Prompt for Lube Sale Account",
      description:
        "Indicates if labor type should prompt for lube sale account",
      type: "boolean",
      default: false,
    },
    labor_tax_code: {
      title: "LaborTaxCode",
      description: "Labor tax code",
      type: ["number", "null"],
      minimum: 1,
      maximum: 9999,
      default: null,
      typeaheadConfig: {
        url: "/search/TaxCodes",
        minChars: 1,
        body: {
          filters: [
            {
              field: "active_status",
              operator: "EQUALS",
              value: "active",
            },
          ],
          responseFields: ["tax_code"],
        },
        valueField: "tax_code",
        labelField: ["tax_code"],
      },
    },
    labor_debit_tax_acct_state: {
      title: "State Tax Account",
      description: "Debit tax acct for labor - State agency",
      type: ["string", "null"],
      default: null,
    },
    labor_debit_tax_acct_target_co_state: {
      title: "State Tax Company",
      description: "Labor debit tax acct target company - State agency",
      type: ["string", "null"],
      default: null,
    },
    labor_debit_tax_acct_supp: {
      title: "Supp1 Tax Account",
      description: "Debit tax acct for labor - Supplemental agency",
      type: ["string", "null"],
      default: null,
    },
    labor_debit_tax_acct_target_co_supp: {
      title: "Supp1 Tax Company",
      description: "Labor debit tax acct target company - Supplemental agency",
      type: ["string", "null"],
      default: null,
    },
    labor_debit_tax_acct_supp2: {
      title: "Supp2 Tax Account",
      description: "Debit tax acct for labor - Supplemental 2 agency",
      type: ["string", "null"],
      default: null,
    },
    labor_debit_tax_acct_target_co_supp2: {
      title: "Supp2 Tax Company",
      description:
        "Labor debit tax acct target company - Supplemental 2 agency",
      type: ["string", "null"],
      default: null,
    },
    labor_debit_tax_acct_supp3: {
      title: "Supp3 Tax Account",
      description: "Debit tax acct for labor - Supplemental 3 agency",
      type: ["string", "null"],
      default: null,
    },
    labor_debit_tax_acct_target_co_supp3: {
      title: "Supp3 Tax Company",
      description:
        "Labor debit tax acct target company - Supplemental 3 agency",
      type: ["string", "null"],
      default: null,
    },
    labor_debit_tax_acct_supp4: {
      title: "Supp4 Tax Account",
      description: "Debit tax acct for labor - Supplemental 4 agency",
      type: ["string", "null"],
      default: null,
    },
    labor_debit_tax_acct_target_co_supp4: {
      title: "Supp4 Tax Company",
      description:
        "Labor debit tax acct target company - Supplemental 4 agency",
      type: ["string", "null"],
      default: null,
    },
    parts_tax_code: {
      title: "PartsTaxCode",
      description: "Part tax code",
      type: ["number", "null"],
      minimum: 1,
      maximum: 9999,
      default: null,
      typeaheadConfig: {
        url: "/search/TaxCodes",
        minChars: 1,
        body: {
          filters: [
            {
              field: "active_status",
              operator: "EQUALS",
              value: "active",
            },
          ],
          responseFields: ["tax_code"],
        },
        valueField: "tax_code",
        labelField: ["tax_code"],
      },
    },
    parts_debit_tax_acct_state: {
      title: "State Tax Account",
      description: "Debit tax acct for part - State agency",
      type: ["string", "null"],
      default: null,
    },
    parts_debit_tax_acct_target_co_state: {
      title: "State Tax Company",
      description: "Parts debit tax acct target company - State agency",
      type: ["string", "null"],
      default: null,
    },
    parts_debit_tax_acct_supp: {
      title: "Supp1 Tax Account",
      description: "Debit tax acct for part - Supplemental agency",
      type: ["string", "null"],
      default: null,
    },
    parts_debit_tax_acct_target_co_supp: {
      title: "Supp1 Tax Company",
      description: "Parts debit tax acct target company - Supplemental agency",
      type: ["string", "null"],
      default: null,
    },
    parts_debit_tax_acct_supp2: {
      title: "Supp2 Tax Account",
      description: "Debit tax acct for part - Supplemental 2 agency",
      type: ["string", "null"],
      default: null,
    },
    parts_debit_tax_acct_target_co_supp2: {
      title: "Supp2 Tax Company",
      description:
        "Parts debit tax acct target company - Supplemental 2 agency",
      type: ["string", "null"],
      default: null,
    },
    parts_debit_tax_acct_supp3: {
      title: "Supp3 Tax Account",
      description: "Debit tax acct for part - Supplemental 3 agency",
      type: ["string", "null"],
      default: null,
    },
    parts_debit_tax_acct_target_co_supp3: {
      title: "Supp3 Tax Company",
      description:
        "Parts debit tax acct target company - Supplemental 3 agency",
      type: ["string", "null"],
      default: null,
    },
    parts_debit_tax_acct_supp4: {
      title: "Supp4 Tax Account",
      description: "Debit tax acct for part - Supplemental 4 agency",
      type: ["string", "null"],
      default: null,
    },
    parts_debit_tax_acct_target_co_supp4: {
      title: "Supp4 Tax Company",
      description:
        "Parts debit tax acct target company - Supplemental 4 agency",
      type: ["string", "null"],
      default: null,
    },

    sublet_labor_taxable_flag: {
      title: "SubletLaborTaxableFlag",
      description: "Sublet labor sale tax flag",
      type: "boolean",
      default: false,
    },
    sublet_parts_taxable_flag: {
      title: "SubletPartsTaxableFlag",
      description: "Sublet parts sale tax flag",
      type: "boolean",
      default: false,
    },
    department_id: {
      title: "Department id",
      description: "Department id",
      type: ["string", "null"],
      default: null,
    },
    department_name: {
      title: "Department name",
      description: "Department name",
      type: ["string", "null"],
      default: null,
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    store_id: {
      title: "Store",
      description: "Store identifier",
      type: "string",
      minLength: 1,
    },
    tenant_id: {
      title: "Tenant",
      description: "Tenant identifier",
      type: "string",
      minLength: 1,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
      default: "inactive",
    },
  },
  required: [
    "enterprise_id",
    "store_id",
    "tenant_id",
    "active_status",
    "labor_type",
    "description",
    "debit_acct",
    "debit_acct_prompt",
    "debit_ctrl_prompt",
    "labor_pricing_code",
    "labor_pricing_percent",
    "labor_rate",
    "labor_tax_code",
    "part_pricing_code",
    "labor_debit_tax_acct_state",
    "labor_debit_tax_acct_supp",
    "labor_debit_tax_acct_supp2",
    "labor_debit_tax_acct_supp3",
    "labor_debit_tax_acct_supp4",
    "journal_source",
    "journal_source_prompt",
    "labor_sale_acct",
    "labor_sale_acct_display",
    "parts_sale_acct",
    "parts_sale_acct_prompt",
    "misc_sale_acct",
    "misc_sale_acct_prompt",
    "lube_sale_acct",
    "lube_sale_acct_prompt",
    "sublet_sale_acct",
    "sublet_sale_acct_prompt",
    "parts_debit_tax_acct_state",
    "parts_debit_tax_acct_supp",
    "parts_debit_tax_acct_supp2",
    "parts_debit_tax_acct_supp3",
    "parts_debit_tax_acct_supp4",
    "parts_tax_code",
    "parts_pricing_by_labor_type_flag",
    "calculate_shop_charges_flag",
    "debit_acct_target_co",
    "labor_debit_tax_acct_target_co_state",
    "labor_debit_tax_acct_target_co_supp",
    "labor_debit_tax_acct_target_co_supp2",
    "labor_debit_tax_acct_target_co_supp3",
    "labor_debit_tax_acct_target_co_supp4",
    "journal_source_co",
    "parts_debit_tax_acct_target_co_state",
    "parts_debit_tax_acct_target_co_supp",
    "parts_debit_tax_acct_target_co_supp2",
    "parts_debit_tax_acct_target_co_supp3",
    "parts_debit_tax_acct_target_co_supp4",
    "labor_pricing_by_labor_type_flag",
    "labor_pricing_grid_id",
    "sublet_labor_sale_acct",
    "sublet_labor_taxable_flag",
    "sublet_parts_sale_acct",
    "sublet_parts_taxable_flag",
    "debit_accounting_from_inventory_flag",
    "grid_accounting_flag",
    "grid_accounting_name",
    "department_id",
    "department_name",
  ],
  sections: {
    grid_fields: [
      "labor_type",
      "description",
      "debit_acct",
      "labor_pricing_code",
      "part_pricing_code",
    ],
    general_fields: [
      "labor_type",
      "description",
      "sublet_labor_taxable_flag",
      "sublet_parts_taxable_flag",
      "grid_accounting_flag",
      "grid_accounting_name",
      "department_id",
      "department_name",
    ],
    accounts: [
      "journal_source",
      "debit_acct_target_co",
      "journal_source_co",
      "debit_acct",
      "labor_sale_acct",
      "parts_sale_acct",
      "misc_sale_acct",
      "lube_sale_acct",
      "sublet_sale_acct",
      "sublet_labor_sale_acct",
      "sublet_parts_sale_acct",
    ],
    pricing: [
      "labor_pricing_by_labor_type_flag",
      "labor_pricing_code",
      "labor_pricing_percent",
      "labor_rate",
      "labor_pricing_grid_id",
      "calculate_shop_charges_flag",
      "parts_pricing_by_labor_type_flag",
      "part_pricing_code",
    ],
    prompt: [
      "debit_accounting_from_inventory_flag",
      "journal_source_prompt",
      "labor_sale_acct_display",
      "parts_sale_acct_prompt",
      "misc_sale_acct_prompt",
      "lube_sale_acct_prompt",
      "sublet_sale_acct_prompt",
      "debit_acct_prompt",
      "debit_ctrl_prompt",
    ],
    labor_debit_tax_account: [
      "labor_tax_code",
      "labor_debit_tax_acct_state",
      "labor_debit_tax_acct_supp",
      "labor_debit_tax_acct_supp2",
      "labor_debit_tax_acct_supp3",
      "labor_debit_tax_acct_supp4",
      "labor_debit_tax_acct_target_co_state",
      "labor_debit_tax_acct_target_co_supp",
      "labor_debit_tax_acct_target_co_supp2",
      "labor_debit_tax_acct_target_co_supp3",
      "labor_debit_tax_acct_target_co_supp4",
    ],
    parts_debit_tax_account: [
      "parts_tax_code",
      "parts_debit_tax_acct_state",
      "parts_debit_tax_acct_supp",
      "parts_debit_tax_acct_supp2",
      "parts_debit_tax_acct_supp3",
      "parts_debit_tax_acct_supp4",
      "parts_debit_tax_acct_target_co_state",
      "parts_debit_tax_acct_target_co_supp",
      "parts_debit_tax_acct_target_co_supp2",
      "parts_debit_tax_acct_target_co_supp3",
      "parts_debit_tax_acct_target_co_supp4",
    ],
  },
};

export const MOCK_ETC_TARDY_CODES_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-etc-tardy-codes-schema.json",
  title: "EtcTardyCodes",
  description: "A schema definition for an Electronic Time Clock Tardy codes",
  type: "object",
  properties: {
    code: {
      title: "Tardy Code",
      description: "Tardy Code",
      type: "string",
      isUnique: true,
      isEditable: false,
    },
    description: {
      title: "Tardy Description",
      description:
        "Long text description of the tardy reason. Used for all Tardy and Override reports. Up to 30 characters, user-defined.",
      type: "string",
      minLength: 1,
      maxLength: 30,
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    store_id: {
      title: "Store",
      description: "Store identifier",
      type: "string",
      minLength: 1,
    },
    tenant_id: {
      title: "Tenant",
      description: "Tenant identifier",
      type: "string",
      minLength: 1,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
      default: "inactive",
    },
  },
  required: ["code", "description", "enterprise_id", "store_id"],
  sections: {
    grid_fields: ["code", "description"],
    general_fields: ["code", "description"],
  },
};

export const MOCK_PAYMENT_TYPES_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-payment-types-schema.json",
  title: "PaymentTypes",
  description: "A schema definition for Payment Types setups",
  functional_area: "SVC",
  type: "object",
  properties: {
    payment_type_id: {
      title: "Payment Type",
      description:
        "Method of payment type that is set up as a controlled accounts receivable account",
      type: "string",
      minLength: 1,
    },
    description: {
      title: "Description",
      description: "A full description of the method of payment",
      type: "string",
      minLength: 1,
      maxLength: 250,
    },
    debit_account_number: {
      title: "Debit Account Number",
      description:
        "Debit account number to which sales are posted for this customer pay or insurance type",
      type: "string",
      minLength: 1,
      maxLength: 7,
    },
    is_insurance_carrier: {
      title: "Insurance Flag",
      description: "This is an insurance carrier.",
      type: "boolean",
      default: false,
    },
    is_prompt_for_debit_control: {
      title: "Prompt For Debit Control Flag",
      description: "Prompt for debit control number flag",
      type: "boolean",
      default: false,
    },
    debit_control_number: {
      title: "Debit Control Number",
      description:
        "Default debit control number. A preset control number for this method of payment",
      type: ["string", "null"],
      default: null,
    },
    debit_account_target_company: {
      title: "Debit Account Target Company",
      description:
        "Target company for the debit account number to which sales are posted for customer pay or insurance type",
      type: ["string", "null"],
      maxLength: 3,
      default: null,
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    store_id: {
      title: "Store",
      description: "Store identifier",
      type: "string",
      minLength: 1,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
      default: "inactive",
    },
    department_id: {
      title: "Department ID",
      description: "Identifier of the department.",
      type: "string",
      minLength: 1,
    },
    department_name: {
      title: "Department name",
      description: "Department name",
      type: ["string", "null"],
      default: null,
    },
  },
  required: [
    "payment_type_id",
    "description",
    "debit_account_number",
    "is_insurance_carrier",
    "is_prompt_for_debit_control",
  ],
  sections: {
    grid_fields: [
      "payment_type_id",
      "description",
      "debit_account_number",
      "is_insurance_carrier",
      "is_prompt_for_debit_control",
    ],
    general_fields: [
      "payment_type_id",
      "description",
      "debit_account_number",
      "is_insurance_carrier",
      "is_prompt_for_debit_control",
      "department_id",
      "department_name",
    ],
  },
};

export const MOCK_DISCOUNTS_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-setup-service-discounts-schema.json",
  title: "Discounts",
  description: "A schema definition for service discounts",
  functional_area: "SVC",
  type: "object",
  properties: {
    discount_code: {
      title: "Discount Code",
      description: "Discount Code",
      type: "string",
      minLength: 1,
      pattern: "^([A-Za-z0-9 ]{1,10})$",
    },
    description: {
      title: "Description",
      description: "The description of the discount printed on the invoice.",
      type: "string",
      minLength: 1,
      pattern: "^(.{1,140})$",
    },
    begin_date: {
      title: "Begin Date",
      description: "The first day the discount is effective.",
      type: ["string", "null"],
      format: "date",
      default: null,
    },
    end_date: {
      title: "End Date",
      description: "The last day the discount is effective.",
      type: ["string", "null"],
      format: "date",
      default: null,
    },
    method: {
      title: "Discount Method",
      description: "A flag that identifies how the discount is calculated.",
      type: "string",
      minLength: 1,
      enum: ["Fixed price", "Percentage of sales", "Target price"],
      default: "Fixed price",
    },
    fixed_price: {
      title: "Fixed Price",
      description: " Fixed discount amount.",
      type: ["number", "null"],
      minimum: 0,
      maximum: 9999999.99,
      default: null,
    },
    percentage: {
      title: "Percentage%",
      description: "The percentage of sales to be used to calculate discount",
      type: ["number", "null"],
      minimum: 0,
      maximum: 999.999,
      default: null,
      disabled: true,
    },
    target_price: {
      title: "Target Price",
      description: "The target price used to calculate discount.",
      type: ["number", "null"],
      minimum: 0,
      maximum: 9999999.99,
      default: null,
      disabled: true,
    },
    max_discount: {
      title: "Maximum Discount",
      description: "The maximum calculated discount amount allowed.",
      type: ["number", "null"],
      minimum: 0.01,
      maximum: 9999999.99,
      default: null,
      disabled: true,
    },
    applies_to: {
      title: "Applies To",
      description: "A flag that indicates what the discount applies to.",
      type: "string",
      minLength: 1,
      enum: ["Labor", "Parts", "Both labor and parts"],
    },
    allow_override: {
      title: "Allow Override",
      description:
        "A flag that indicates if a calculated discount amount can be manually overridden by users.",
      type: "boolean",
      default: false,
    },
    max_override: {
      title: "Maximum Override",
      description: "The maximum total discount amount allowed for an override.",
      type: ["number", "null"],
      minimum: 0.01,
      maximum: 9999999.99,
      default: null,
    },
    allow_discount_multiple_times_on_ro: {
      title: "Allow Discount to be added to Same RO More Than Once",
      description:
        "A flag that indicates if a calculated discount can be added more than once in Repair Orders",
      type: "boolean",
      default: false,
    },
    labor_class_cp: {
      title: "Allow Discount for Customer Pay",
      description:
        "Flag that indicates if this discount applies to the customer pay labor class.",
      type: "boolean",
      default: false,
    },
    labor_type_cp: {
      title: "Labor Type",
      description:
        "The labor type used to determine if the customer pay discount is included in tax and shop charge calculations, other accounting data.",
      type: ["string", "null"],
      pattern: "^([A-Za-z0-9 ]{1,5}|null)$",
      default: null,
      typeaheadConfig: {
        url: "/search/LaborTypes",
        minChars: 2,
        body: {
          filters: [
            {
              field: "active_status",
              operator: "EQUALS",
              value: "active",
            },
          ],
          responseFields: [
            "labor_type",
            "labor_tax_code",
            "parts_tax_code",
            "labor_sale_acct",
            "parts_sale_acct",
            "store_id",
            "journal_source_co",
          ],
        },
        valueField: "labor_type",
        labelField: ["labor_type"],
      },
    },
    split_by_cp: {
      title: "Discount Allocation",
      description:
        "A flag that indicates how the customer pay discount is split between labor and parts.",
      type: ["string", "null"],
      enum: ["Sale Amount", "Gross Profit", null],
      default: null,
      disabled: true,
    },
    labor_tax_code_cp: {
      title: "Labor Tax Code",
      description: "Labor Tax Code number. DMS file record item-ID",
      type: "integer",
      minimum: 1,
      maximum: 9999,
      disabled: true,
    },
    parts_tax_code_cp: {
      title: "Parts Tax Code",
      description: "Parts Tax Code number. DMS file record item-ID",
      type: "integer",
      minimum: 1,
      maximum: 9999,
      disabled: true,
    },
    include_shop_charges_cp: {
      title: "Include Shop charges",
      description:
        "Flag that indicates if this discount applies to the customer pay labor class.",
      type: "boolean",
      default: false,
    },
    warn_min_profitability_cp: {
      title: "Warn for Minimum Profitability",
      description:
        "Flag that indicates if this discount applies to the customer pay labor class.",
      type: "boolean",
      default: false,
    },
    warn_by_cp: {
      title: "Warn by",
      description: "Warn by Amount or Percentage",
      type: ["string", "null"],
      enum: ["Amount", "Percent", null],
      default: null,
      disabled: true,
    },
    min_profit_amount_cp: {
      title: "Min Profit Amount CP",
      description:
        "The minimum profit amount of labor and parts sales with the customer pay discount applied before a warning message is displayed in PFC.",
      type: ["number", "null"],
      minimum: 0,
      maximum: 9999999.99,
      default: null,
      disabled: true,
    },
    min_profit_percent_cp: {
      title: "Min Profit Percent CP",
      description:
        "The minimum profit percentage of labor and parts sales with the customer pay discount applied before a warning message is displayed in PFC.",
      type: ["number", "null"],
      minimum: 0,
      maximum: 999.99,
      default: null,
      disabled: true,
    },
    use_labor_type_accounts_cp: {
      title: "Use labor and parts sale account from Labor Type",
      description:
        "A flag that indicates where to get accounting target companies and account numbers for the customer pay discount.",
      type: "boolean",
      default: false,
      disabled: true,
    },
    labor_accounts_cp: {
      title: "Assign Labor accounts",
      description: "Assign Labor accounts",
      type: "array",
      items: {
        type: "object",
        properties: {
          labor_store_cp: {
            title: "Labor Store",
            description: "Labor Store",
            type: "string",
            isStore: true,
            companyKey: "labor_company_cp",
            dependentFields: ["labor_account_cp"],
          },
          labor_company_cp: {
            title: "Labor Company",
            description: "Labor Company",
            type: "string",
            disabled: true,
          },
          labor_account_cp: {
            title: "Labor Account",
            description: "Labor Account",
            type: "string",
            typeaheadConfig: {
              url: "/v2/search/COA",
              minChars: 2,
              body: {
                filters: [
                  {
                    field: "record_type",
                    operator: "EQUALS",
                    value: "Base",
                  },
                ],
                responseFields: ["account_number", "account_description"],
              },
              storeId: "$ref_store",
              valueField: "account_number",
              labelField: ["account_number", "account_description"],
            },
          },
          labor_percentage_cp: {
            title: "Labor Percentage",
            description: "Labor Percentage",
            type: "number",
            maximum: 100,
          },
        },
        required: [
          "labor_store_cp",
          "labor_company_cp",
          "labor_account_cp",
          "labor_percentage_cp",
        ],
      },
    },
    parts_accounts_cp: {
      title: "Assign Parts accounts",
      description: "Assign Parts accounts",
      type: "array",
      items: {
        type: "object",
        properties: {
          parts_store_cp: {
            title: "Parts Store",
            description: "Parts Store",
            type: "string",
            isStore: true,
            companyKey: "parts_company_cp",
            dependentFields: ["parts_account_cp"],
          },
          parts_company_cp: {
            title: "Parts Company",
            description: "Parts Company",
            type: "string",
            disabled: true,
          },
          parts_account_cp: {
            title: "Parts Account",
            description: "Parts Account",
            type: "string",
            typeaheadConfig: {
              url: "/v2/search/COA",
              minChars: 2,
              body: {
                filters: [
                  {
                    field: "record_type",
                    operator: "EQUALS",
                    value: "Base",
                  },
                ],
                responseFields: ["account_number", "account_description"],
              },
              storeId: "$ref_store",
              valueField: "account_number",
              labelField: ["account_number", "account_description"],
            },
          },
          parts_percentage_cp: {
            title: "Parts Percentage",
            description: "Parts Percentage",
            type: "number",
            maximum: 100,
          },
        },
        required: [
          "parts_store_cp",
          "parts_company_cp",
          "parts_account_cp",
          "parts_percentage_cp",
        ],
      },
    },
    labor_class_ip: {
      title: "Allow Discount for Internal Pay",
      description:
        "Flag that indicates if this discount applies to the internal pay labor class.",
      type: "boolean",
      default: false,
    },
    labor_type_ip: {
      title: "Labor Type",
      description:
        "The labor type used to determine if the internal pay discount is included in tax and shop charge calculations, other accounting data.",
      type: ["string", "null"],
      pattern: "^([A-Za-z0-9]{1,5}|null)$",
      default: null,
      typeaheadConfig: {
        url: "/search/LaborTypes",
        minChars: 2,
        body: {
          filters: [
            {
              field: "active_status",
              operator: "EQUALS",
              value: "active",
            },
          ],
          responseFields: [
            "labor_type",
            "labor_tax_code",
            "parts_tax_code",
            "labor_sale_acct",
            "parts_sale_acct",
            "store_id",
            "journal_source_co",
          ],
        },
        valueField: "labor_type",
        labelField: ["labor_type"],
      },
    },
    split_by_ip: {
      title: "Discount Allocation",
      description:
        "A flag that indicates how the internal pay discount is split between labor and parts.",
      type: ["string", "null"],
      enum: ["Sale Amount", "Gross Profit", null],
      default: null,
      disabled: true,
    },
    min_profit_percent_ip: {
      title: "Min Profit Percent IP",
      description:
        "The minimum profit percentage of labor and parts sales with the internal pay discount applied before a warning message is displayed in PFC.",
      type: ["number", "null"],
      minimum: 0,
      maximum: 999.99,
      default: null,
    },
    min_profit_amount_ip: {
      title: "Min Profit Amount IP",
      description:
        "The minimum profit amount of labor and parts sales with the internal pay discount applied before a warning message is displayed in PFC.",
      type: ["number", "null"],
      minimum: 0,
      maximum: 9999999.99,
      default: null,
    },
    use_labor_type_accounts_ip: {
      title: "Use labor and parts sale account from Labor Type",
      description:
        "A flag that indicates where to get accounting target companies and account numbers for the warranty pay discount.",
      type: "boolean",
      default: false,
      disabled: true,
    },
    labor_tax_code_ip: {
      title: "Labor Tax Code",
      description: "Labor Tax Code number. DMS file record item-ID",
      type: "integer",
      minimum: 1,
      maximum: 9999,
      disabled: true,
    },
    parts_tax_code_ip: {
      title: "Parts Tax Code",
      description: "Parts Tax Code number. DMS file record item-ID",
      type: "integer",
      minimum: 1,
      maximum: 9999,
      disabled: true,
    },
    include_shop_charges_ip: {
      title: "Include Shop charges",
      description:
        "Flag that indicates if this discount applies to the customer pay labor class.",
      type: "boolean",
      default: false,
    },
    warn_min_profitability_ip: {
      title: "Warn for Minimum Profitability",
      description:
        "Flag that indicates if this discount applies to the customer pay labor class.",
      type: "boolean",
      default: false,
    },
    warn_by_ip: {
      title: "Warn by",
      description: "Warn by Amount or Percentage",
      type: ["string", "null"],
      enum: ["Amount", "Percent", null],
      default: null,
    },
    labor_accounts_ip: {
      title: "Assign Labor accounts",
      description: "Assign Labor accounts for Internal Pay",
      type: "array",
      items: {
        type: "object",
        properties: {
          labor_store_ip: {
            title: "Labor Store",
            description: "Labor Store",
            type: "string",
            isStore: true,
            companyKey: "labor_company_ip",
            dependentFields: ["labor_account_ip"],
          },
          labor_company_ip: {
            title: "Labor Company",
            description: "Labor Company",
            type: "string",
            disabled: true,
          },
          labor_account_ip: {
            title: "Labor Account",
            description: "Labor Account",
            type: "string",
            typeaheadConfig: {
              url: "/v2/search/COA",
              minChars: 2,
              body: {
                filters: [
                  {
                    field: "record_type",
                    operator: "EQUALS",
                    value: "Base",
                  },
                ],
                responseFields: ["account_number", "account_description"],
              },
              storeId: "$ref_store",
              valueField: "account_number",
              labelField: ["account_number", "account_description"],
            },
          },
          labor_percentage_ip: {
            title: "Labor Percentage",
            description: "Labor Percentage",
            type: "number",
            maximum: 100,
          },
        },
        required: [
          "labor_store_ip",
          "labor_company_ip",
          "labor_account_ip",
          "labor_percentage_ip",
        ],
      },
    },
    parts_accounts_ip: {
      title: "Assign Parts accounts",
      description: "Assign Parts accounts for Internal Pay",
      type: "array",
      items: {
        type: "object",
        properties: {
          parts_store_ip: {
            title: "Parts Store",
            description: "Parts Store",
            type: "string",
            isStore: true,
            companyKey: "parts_company_ip",
            dependentFields: ["parts_account_ip"],
          },
          parts_company_ip: {
            title: "Parts Company",
            description: "Parts Company",
            type: "string",
            disabled: true,
          },
          parts_account_ip: {
            title: "Parts Account",
            description: "Parts Account",
            type: "string",
            typeaheadConfig: {
              url: "/v2/search/COA",
              minChars: 2,
              body: {
                filters: [
                  {
                    field: "record_type",
                    operator: "EQUALS",
                    value: "Base",
                  },
                ],
                responseFields: ["account_number", "account_description"],
              },
              storeId: "$ref_store",
              valueField: "account_number",
              labelField: ["account_number", "account_description"],
            },
          },
          parts_percentage_ip: {
            title: "Parts Percentage",
            description: "Parts Percentage",
            type: "number",
            maximum: 100,
          },
        },
        required: [
          "parts_store_ip",
          "parts_company_ip",
          "parts_account_ip",
          "parts_percentage_ip",
        ],
      },
    },
    labor_class_wp: {
      title: "Allow Discount for Warranty Pay",
      description:
        "Flag that indicates if this discount applies to the warranty pay labor class.",
      type: "boolean",
      default: false,
    },
    labor_type_wp: {
      title: "Labor Type",
      description:
        "The labor type used to determine if the warranty pay discount is included in tax and shop charge calculations, other accounting data.",
      type: ["string", "null"],
      pattern: "^([A-Za-z0-9]{1,5}|null)$",
      default: null,
      typeaheadConfig: {
        url: "/search/LaborTypes",
        minChars: 2,
        body: {
          filters: [
            {
              field: "active_status",
              operator: "EQUALS",
              value: "active",
            },
          ],
          responseFields: [
            "labor_type",
            "labor_tax_code",
            "parts_tax_code",
            "labor_sale_acct",
            "parts_sale_acct",
            "store_id",
            "journal_source_co",
          ],
        },
        valueField: "labor_type",
        labelField: ["labor_type"],
      },
    },
    split_by_wp: {
      title: "Discount Allocation",
      description:
        "A flag that indicates how the warranty pay discount is split between labor and parts.",
      type: ["string", "null"],
      enum: ["Sale Amount", "Gross Profit", null],
      default: null,
      disabled: true,
    },
    min_profit_percent_wp: {
      title: "Min Profit Percent WP",
      description:
        "The minimum profit percentage of labor and parts sales with the warranty pay discount applied before a warning message is displayed in PFC.",
      type: ["number", "null"],
      minimum: 0,
      maximum: 999.99,
      default: null,
    },
    min_profit_amount_wp: {
      title: "Min Profit Amount WP",
      description:
        "The minimum profit amount of labor and parts sales with the warranty pay discount applied before a warning message is displayed in PFC.",
      type: ["number", "null"],
      minimum: 0,
      maximum: 9999999.99,
      default: null,
    },
    use_labor_type_accounts_wp: {
      title: "Use labor and parts sale account from Labor Type",
      description:
        "A flag that indicates where to get accounting target companies and account numbers for the warranty pay discount.",
      type: "boolean",
      default: false,
      disabled: true,
    },
    labor_tax_code_wp: {
      title: "Labor Tax Code",
      description: "Labor Tax Code number. DMS file record item-ID",
      type: "integer",
      minimum: 1,
      maximum: 9999,
      disabled: true,
    },
    parts_tax_code_wp: {
      title: "Parts Tax Code",
      description: "Parts Tax Code number. DMS file record item-ID",
      type: "integer",
      minimum: 1,
      maximum: 9999,
      disabled: true,
    },
    include_shop_charges_wp: {
      title: "Include Shop charges",
      description:
        "Flag that indicates if this discount applies to the customer pay labor class.",
      type: "boolean",
      default: false,
    },
    warn_min_profitability_wp: {
      title: "Warn for Minimum Profitability",
      description:
        "Flag that indicates if this discount applies to the customer pay labor class.",
      type: "boolean",
      default: false,
    },
    warn_by_wp: {
      title: "Warn by",
      description: "Warn by Amount or Percentage",
      type: ["string", "null"],
      enum: ["Amount", "Percent", null],
      default: null,
    },
    labor_accounts_wp: {
      title: "Assign Labor accounts",
      description: "Assign Labor accounts for Warranty Pay",
      type: "array",
      items: {
        type: "object",
        properties: {
          labor_store_wp: {
            title: "Labor Store",
            description: "Labor Store",
            type: "string",
            isStore: true,
            companyKey: "labor_company_wp",
            dependentFields: ["labor_account_wp"],
          },
          labor_company_wp: {
            title: "Labor Company",
            description: "Labor Company",
            type: "string",
            disabled: true,
          },
          labor_account_wp: {
            title: "Labor Account",
            description: "Labor Account",
            type: "string",
            typeaheadConfig: {
              url: "/v2/search/COA",
              minChars: 2,
              body: {
                filters: [
                  {
                    field: "record_type",
                    operator: "EQUALS",
                    value: "Base",
                  },
                ],
                responseFields: ["account_number", "account_description"],
              },
              storeId: "$ref_store",
              valueField: "account_number",
              labelField: ["account_number", "account_description"],
            },
          },
          labor_percentage_wp: {
            title: "Labor Percentage",
            description: "Labor Percentage",
            type: "number",
            maximum: 100,
          },
        },
        required: [
          "labor_store_wp",
          "labor_company_wp",
          "labor_account_wp",
          "labor_percentage_wp",
        ],
      },
    },
    parts_accounts_wp: {
      title: "Assign Parts accounts",
      description: "Assign Parts accounts for warranty Pay",
      type: "array",
      items: {
        type: "object",
        properties: {
          parts_store_wp: {
            title: "Parts Store",
            description: "Parts Store",
            type: "string",
            isStore: true,
            companyKey: "parts_company_wp",
            dependentFields: ["parts_account_wp"],
          },
          parts_company_wp: {
            title: "Parts Company",
            description: "Parts Company",
            type: "string",
            disabled: true,
          },
          parts_account_wp: {
            title: "Parts Account",
            description: "Parts Account",
            type: "string",
            typeaheadConfig: {
              url: "/v2/search/COA",
              minChars: 2,
              body: {
                filters: [
                  {
                    field: "record_type",
                    operator: "EQUALS",
                    value: "Base",
                  },
                ],
                responseFields: ["account_number", "account_description"],
              },
              storeId: "$ref_store",
              valueField: "account_number",
              labelField: ["account_number", "account_description"],
            },
          },
          parts_percentage_wp: {
            title: "Parts Percentage",
            description: "Parts Percentage",
            type: "number",
            maximum: 100,
          },
        },
        required: [
          "parts_store_wp",
          "parts_company_wp",
          "parts_account_wp",
          "parts_percentage_wp",
        ],
      },
    },
    labor_labor_class: {
      title: "Labor Labor Class",
      description:
        "Labor class for labor target companies, account numbers, and percentages.",
      type: ["string", "null"],
      minLength: 1,
      enum: ["Customer pay", "Warranty pay", "Internal pay", null],
      default: null,
    },
    labor_target_co: {
      title: "Labor Target Co",
      description: "The target companies for labor discounts.",
      type: ["string", "null"],
      pattern: "^([A-Za-z0-9]{1,3}|null)$",
      default: null,
    },
    labor_account_no: {
      title: "Labor Account No",
      description: "The GL account numbers for labor discounts.",
      type: ["string", "null"],
      pattern: "^([A-Za-z0-9]{1,7}|null)$",
      default: null,
    },
    labor_percent: {
      title: "Labor Percent",
      description:
        "The percent of the labor discount to be posted to the GL account number.",
      type: ["number", "null"],
      minimum: 1,
      maximum: 100,
      default: null,
    },
    parts_labor_class: {
      title: "Parts Labor Class",
      description:
        "Labor class for parts target companies, account numbers, and percentages.",
      type: ["string", "null"],
      minLength: 1,
      enum: ["Customer pay", "Warranty pay", "Internal pay", null],
      default: null,
    },
    parts_target_co: {
      title: "Parts Target Co",
      description: "The target companies for parts discounts.",
      type: ["string", "null"],
      pattern: "^([A-Za-z0-9]{1,3}|null)$",
      default: null,
    },
    parts_account_no: {
      title: "Parts Account No",
      description: "The GL account numbers for parts discounts.",
      type: ["string", "null"],
      pattern: "^([A-Za-z0-9]{1,7}|null)$",
      default: null,
    },
    parts_percent: {
      title: "Parts Percent",
      description:
        "The percent of the parts discount to be posted to the GL account number.",
      type: ["number", "null"],
      minimum: 1,
      maximum: 100,
      default: null,
    },
    allow_duplicate: {
      title: "Allow Duplicate",
      description:
        "Flag that indicates whether this discount can be added more than once to an RO.",
      type: "boolean",
      default: false,
    },
    record_type: {
      title: "Record type",
      description:
        "Identifies the de-normalized record types associated with the schema",
      type: "string",
      minLength: 1,
      enum: ["Base", "Labor parent class", "Parts parent class"],
      default: "Base",
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    store_id: {
      title: "Store",
      description: "Store identifier",
      type: "string",
      minLength: 1,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
      default: "inactive",
    },
    department_id: {
      title: "Department ID",
      description: "Identifier of the department.",
      type: "string",
      minLength: 1,
    },
    department_name: {
      title: "Department name",
      description: "Department name",
      type: ["string", "null"],
      default: null,
    },
    target_price_from: {
      title: "Target Price From",
      description:
        "A flag that indicates where to get the target price for the discount.",
      type: ["string", "null"],
      enum: ["Discount setup", "Opcode", null],
      default: null,
    },
    restricted: {
      title: "Restricted",
      description:
        "A flag that indicates if use of a discount code is restricted to selected users.",
      type: "boolean",
      default: false,
    },
  },
  required: [
    "discount_code",
    "description",
    "method",
    "applies_to",
    "allow_override",
    "labor_class_cp",
    "labor_class_wp",
    "labor_class_ip",
    "allow_duplicate",
  ],
  sections: {
    grid_fields: [
      "discount_code",
      "description",
      "method",
      "applies_to",
      "allow_override",
      "labor_class_cp",
      "labor_class_ip",
      "labor_class_wp",
    ],
    generalFieldsTab: {
      general_information: [
        "discount_code",
        "description",
        "method",
        "fixed_price",
        "percentage",
        "target_price",
        "max_discount",
        "applies_to",
        "allow_override",
        "max_override",
        "begin_date",
        "end_date",
        "allow_discount_multiple_times_on_ro",
      ],
    },
    customerPaySettingsTab: {
      labor_type_configuration: [
        "labor_class_cp",
        "labor_type_cp",
        "labor_tax_code_cp",
        "parts_tax_code_cp",
        "include_shop_charges_cp",
      ],
      profitability_controls: [
        "warn_min_profitability_cp",
        "warn_by_cp",
        "min_profit_amount_cp",
        "min_profit_percent_cp",
      ],
      general_ledger_distribution: [
        "split_by_cp",
        "use_labor_type_accounts_cp",
      ],
      corelation_fields: ["labor_accounts_cp", "parts_accounts_cp"],
    },
    internalPaySettingsTab: {
      labor_type_configuration: [
        "labor_class_ip",
        "labor_type_ip",
        "labor_tax_code_ip",
        "parts_tax_code_ip",
        "include_shop_charges_ip",
      ],
      profitability_controls: [
        "warn_min_profitability_ip",
        "warn_by_ip",
        "min_profit_amount_ip",
        "min_profit_percent_ip",
      ],
      general_ledger_distribution: [
        "split_by_ip",
        "use_labor_type_accounts_ip",
      ],
      corelation_fields: ["labor_accounts_ip", "parts_accounts_ip"],
    },
    warrantyPaySettingsTab: {
      labor_type_configuration: [
        "labor_class_wp",
        "labor_type_wp",
        "labor_tax_code_wp",
        "parts_tax_code_wp",
        "include_shop_charges_wp",
      ],
      profitability_controls: [
        "warn_min_profitability_wp",
        "warn_by_wp",
        "min_profit_amount_wp",
        "min_profit_percent_wp",
      ],
      general_ledger_distribution: [
        "split_by_wp",
        "use_labor_type_accounts_wp",
      ],
      corelation_fields: ["labor_accounts_wp", "parts_accounts_wp"],
    },
  },
  dependencies: {
    method: {
      rules: [
        {
          matches: ["Fixed price"],
          fieldsToEnable: ["fixed_price"],
          fieldsToDisableAndClear: [
            "percentage",
            "target_price",
            "max_discount",
          ],
        },
        {
          matches: ["Percentage of sales"],
          fieldsToEnable: ["percentage", "max_discount"],
          fieldsToDisableAndClear: ["fixed_price", "target_price"],
        },
        {
          matches: ["Target price"],
          fieldsToEnable: ["target_price", "max_discount"],
          fieldsToDisableAndClear: ["fixed_price", "percentage"],
        },
      ],
    },
    allow_override: {
      rules: [
        {
          matches: [true],
          fieldsToEnable: ["max_override"],
        },
        {
          matches: [false],
          fieldsToDisableAndClear: ["max_override"],
        },
      ],
    },
    warn_min_profitability_cp: {
      rules: [
        {
          matches: [true],
          fieldsToEnable: ["warn_by_cp"],
        },
        {
          matches: [false],
          fieldsToDisableAndClear: [
            "warn_by_cp",
            "min_profit_amount_cp",
            "min_profit_percent_cp",
          ],
        },
      ],
    },
    warn_by_cp: {
      rules: [
        {
          matches: ["Amount"],
          fieldsToEnable: ["min_profit_amount_cp"],
          fieldsToDisableAndClear: ["min_profit_percent_cp"],
        },
        {
          matches: ["Percent"],
          fieldsToEnable: ["min_profit_percent_cp"],
          fieldsToDisableAndClear: ["min_profit_amount_cp"],
        },
        {
          matches: [null],
          fieldsToDisableAndClear: [
            "min_profit_amount_cp",
            "min_profit_percent_cp",
          ],
        },
      ],
    },
    warn_min_profitability_ip: {
      rules: [
        {
          matches: [true],
          fieldsToEnable: ["warn_by_ip"],
        },
        {
          matches: [false],
          fieldsToDisableAndClear: [
            "warn_by_ip",
            "min_profit_amount_ip",
            "min_profit_percent_ip",
          ],
        },
      ],
    },
    warn_by_ip: {
      rules: [
        {
          matches: ["Amount"],
          fieldsToEnable: ["min_profit_amount_ip"],
          fieldsToDisableAndClear: ["min_profit_percent_ip"],
        },
        {
          matches: ["Percent"],
          fieldsToEnable: ["min_profit_percent_ip"],
          fieldsToDisableAndClear: ["min_profit_amount_ip"],
        },
        {
          matches: [null],
          fieldsToDisableAndClear: [
            "min_profit_amount_ip",
            "min_profit_percent_ip",
          ],
        },
      ],
    },
    warn_min_profitability_wp: {
      rules: [
        {
          matches: [true],
          fieldsToEnable: ["warn_by_wp"],
        },
        {
          matches: [false],
          fieldsToDisableAndClear: [
            "warn_by_wp",
            "min_profit_amount_wp",
            "min_profit_percent_wp",
          ],
        },
      ],
    },
    warn_by_wp: {
      rules: [
        {
          matches: ["Amount"],
          fieldsToEnable: ["min_profit_amount_wp"],
          fieldsToDisableAndClear: ["min_profit_percent_wp"],
        },
        {
          matches: ["Percent"],
          fieldsToEnable: ["min_profit_percent_wp"],
          fieldsToDisableAndClear: ["min_profit_amount_wp"],
        },
        {
          matches: [null],
          fieldsToDisableAndClear: [
            "min_profit_amount_wp",
            "min_profit_percent_wp",
          ],
        },
      ],
    },
    applies_to: {
      rules: [
        {
          matches: ["Both labor and parts", ""],
          fieldsToEnable: [
            "split_by_cp",
            "split_by_ip",
            "split_by_wp",
            "use_labor_type_accounts_cp",
            "use_labor_type_accounts_ip",
            "use_labor_type_accounts_wp",
          ],
          coRelationParentsToEnable: [
            "labor_accounts_cp",
            "labor_accounts_ip",
            "labor_accounts_wp",
            "parts_accounts_cp",
            "parts_accounts_ip",
            "parts_accounts_wp",
          ],
        },
        {
          matches: ["Labor"],
          fieldsToDisableAndClear: [
            "split_by_cp",
            "split_by_ip",
            "split_by_wp",
            "use_labor_type_accounts_cp",
            "use_labor_type_accounts_ip",
            "use_labor_type_accounts_wp",
          ],
          coRelationParentsToEnable: [
            "labor_accounts_cp",
            "labor_accounts_ip",
            "labor_accounts_wp",
          ],
          coRelationParentsToEmptyArray: [
            "parts_accounts_cp",
            "parts_accounts_ip",
            "parts_accounts_wp",
          ],
        },
        {
          matches: ["Parts"],
          fieldsToDisableAndClear: [
            "split_by_cp",
            "split_by_ip",
            "split_by_wp",
            "use_labor_type_accounts_cp",
            "use_labor_type_accounts_ip",
            "use_labor_type_accounts_wp",
          ],
          coRelationParentsToEnable: [
            "parts_accounts_cp",
            "parts_accounts_ip",
            "parts_accounts_wp",
          ],
          coRelationParentsToEmptyArray: [
            "labor_accounts_cp",
            "labor_accounts_ip",
            "labor_accounts_wp",
          ],
        },
      ],
    },
  },
};

export const MOCK_DISCOUNTS_INITIAL_ROW_DATA: RowData = {
  discount_code: "",
  description: "",
  method: "Fixed price",
  fixed_price: null,
  percentage: null,
  target_price: null,
  max_discount: null,
  applies_to: "",
  allow_override: false,
  max_override: null,
  begin_date: null,
  end_date: null,
  allow_discount_multiple_times_on_ro: false,
  labor_class_cp: false,
  labor_type_cp: null,
  labor_tax_code_cp: "",
  parts_tax_code_cp: "",
  include_shop_charges_cp: false,
  warn_min_profitability_cp: false,
  warn_by_cp: null,
  min_profit_amount_cp: null,
  min_profit_percent_cp: null,
  split_by_cp: null,
  use_labor_type_accounts_cp: false,
  labor_accounts_cp: [
    {
      labor_store_cp: "",
      labor_company_cp: "",
      labor_account_cp: "",
      labor_percentage_cp: "",
      active_status: "active",
    },
  ],
  parts_accounts_cp: [
    {
      parts_store_cp: "",
      parts_company_cp: "",
      parts_account_cp: "",
      parts_percentage_cp: "",
      active_status: "active",
    },
  ],
  labor_class_ip: false,
  labor_type_ip: null,
  labor_tax_code_ip: "",
  parts_tax_code_ip: "",
  include_shop_charges_ip: false,
  warn_min_profitability_ip: false,
  warn_by_ip: null,
  min_profit_amount_ip: null,
  min_profit_percent_ip: null,
  split_by_ip: null,
  use_labor_type_accounts_ip: false,
  labor_accounts_ip: [
    {
      labor_store_ip: "",
      labor_company_ip: "",
      labor_account_ip: "",
      labor_percentage_ip: "",
      active_status: "active",
    },
  ],
  parts_accounts_ip: [
    {
      parts_store_ip: "",
      parts_company_ip: "",
      parts_account_ip: "",
      parts_percentage_ip: "",
      active_status: "active",
    },
  ],
  labor_class_wp: false,
  labor_type_wp: null,
  labor_tax_code_wp: "",
  parts_tax_code_wp: "",
  include_shop_charges_wp: false,
  warn_min_profitability_wp: false,
  warn_by_wp: null,
  min_profit_amount_wp: null,
  min_profit_percent_wp: null,
  split_by_wp: null,
  use_labor_type_accounts_wp: false,
  labor_accounts_wp: [
    {
      labor_store_wp: "",
      labor_company_wp: "",
      labor_account_wp: "",
      labor_percentage_wp: "",
      active_status: "active",
    },
  ],
  parts_accounts_wp: [
    {
      parts_store_wp: "",
      parts_company_wp: "",
      parts_account_wp: "",
      parts_percentage_wp: "",
      active_status: "active",
    },
  ],
};

export const MOCK_DISCOUNTS_ROW_DATA: RowData = {
  discount_code: "DISC01",
  description: "Customer Loyalty Discount",
  method: "Percentage of sales",
  fixed_price: null,
  percentage: 10,
  target_price: null,
  max_discount: 500,
  applies_to: "Both labor and parts",
  allow_override: true,
  max_override: 750,
  begin_date: "2024-01-01",
  end_date: "2024-12-31",
  allow_discount_multiple_times_on_ro: false,

  labor_class_cp: true,
  labor_type_cp: "CP01",
  labor_tax_code_cp: 1001,
  parts_tax_code_cp: 1002,
  include_shop_charges_cp: true,
  warn_min_profitability_cp: true,
  warn_by_cp: "Percent",
  min_profit_amount_cp: null,
  min_profit_percent_cp: 15,
  split_by_cp: "Sale Amount",
  use_labor_type_accounts_cp: false,
  labor_accounts_cp: [
    {
      id: "la-cp-001",
      labor_store_cp: "STORE_01",
      labor_company_cp: "CO_01",
      labor_account_cp: "ACC1001",
      labor_percentage_cp: 60,
      active_status: "active",
    },
    {
      id: "la-cp-002",
      labor_store_cp: "STORE_02",
      labor_company_cp: "CO_02",
      labor_account_cp: "ACC1002",
      labor_percentage_cp: 40,
      active_status: "active",
    },
  ],
  parts_accounts_cp: [
    {
      id: "pa-cp-001",
      parts_store_cp: "STORE_01",
      parts_company_cp: "CO_01",
      parts_account_cp: "ACC2001",
      parts_percentage_cp: 70,
      active_status: "active",
    },
    {
      id: "pa-cp-002",
      parts_store_cp: "STORE_02",
      parts_company_cp: "CO_02",
      parts_account_cp: "ACC2002",
      parts_percentage_cp: 30,
      active_status: "active",
    },
  ],

  labor_class_ip: true,
  labor_type_ip: "IP01",
  labor_tax_code_ip: 2001,
  parts_tax_code_ip: 2002,
  include_shop_charges_ip: false,
  warn_min_profitability_ip: true,
  warn_by_ip: "Amount",
  min_profit_amount_ip: 200,
  min_profit_percent_ip: null,
  split_by_ip: "Gross Profit",
  use_labor_type_accounts_ip: false,
  labor_accounts_ip: [
    {
      id: "la-ip-001",
      labor_store_ip: "STORE_01",
      labor_company_ip: "CO_01",
      labor_account_ip: "ACC3001",
      labor_percentage_ip: 50,
      active_status: "active",
    },
    {
      id: "la-ip-002",
      labor_store_ip: "STORE_02",
      labor_company_ip: "CO_02",
      labor_account_ip: "ACC3002",
      labor_percentage_ip: 50,
      active_status: "active",
    },
  ],
  parts_accounts_ip: [
    {
      id: "pa-ip-001",
      parts_store_ip: "STORE_01",
      parts_company_ip: "CO_01",
      parts_account_ip: "ACC4001",
      parts_percentage_ip: 100,
      active_status: "active",
    },
  ],

  labor_class_wp: true,
  labor_type_wp: "WP01",
  labor_tax_code_wp: 3001,
  parts_tax_code_wp: 3002,
  include_shop_charges_wp: true,
  warn_min_profitability_wp: false,
  warn_by_wp: null,
  min_profit_amount_wp: null,
  min_profit_percent_wp: null,
  split_by_wp: "Sale Amount",
  use_labor_type_accounts_wp: false,
  labor_accounts_wp: [
    {
      id: "la-wp-001",
      labor_store_wp: "STORE_01",
      labor_company_wp: "CO_01",
      labor_account_wp: "ACC5001",
      labor_percentage_wp: 100,
      active_status: "active",
    },
  ],
  parts_accounts_wp: [
    {
      id: "pa-wp-001",
      parts_store_wp: "STORE_01",
      parts_company_wp: "CO_01",
      parts_account_wp: "ACC6001",
      parts_percentage_wp: 55,
      active_status: "active",
    },
    {
      id: "pa-wp-002",
      parts_store_wp: "STORE_02",
      parts_company_wp: "CO_02",
      parts_account_wp: "ACC6002",
      parts_percentage_wp: 45,
      active_status: "active",
    },
  ],

  enterprise_id: "ENT_001",
  store_id: "STORE_01",
  active_status: "active",
  department_id: "DEPT_SVC",
  department_name: "Service Department",
  restricted: false,
  record_type: "Base",
};

export const MOCK_INVENTORY_BUILDINGS_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-inventory-building.json",
  title: "InventoryBuildings",
  description:
    "Using Inventory Building Management, dealers can add and configure new inventory buildings, enable or disable them as active inventory locations, map each location to delivery routes, and define how zones are organized within each building. This end?to?end flow gives dealers clear control over which buildings are operational, how inventory flows across mapped routes, and how zone layouts support accurate inventory operations and scaling.",
  type: "object",
  properties: {
    name: {
      title: "Building Name",
      description: "Name of the Building",
      type: "string",
      maxLength: 200,
    },
    priority: {
      title: "Priority",
      description: "Priority of the Building",
      type: ["integer", "null"],
      minimum: 1,
      evalMethod: "getInventoryBuildingsPriority",
      isUnique: true,
      disabled: true,
    },
    address_line_1: {
      title: "Street Address",
      description: "Primary street address of the Building",
      type: ["string", "null"],
      maxLength: 300,
    },
    address_line_2: {
      title: "Address 2",
      description: "Secondary address line for the Building",
      type: ["string", "null"],
      maxLength: 300,
      default: null,
    },
    city: {
      title: "City",
      description: "City of the Building",
      type: ["string", "null"],
      maxLength: 300,
    },
    state: {
      title: "State",
      description: "State code of the Building",
      type: "string",
      enum: [
        "AL",
        "AK",
        "AS",
        "AZ",
        "AR",
        "CA",
        "CO",
        "CT",
        "DE",
        "DC",
        "FM",
        "FL",
        "GA",
        "GU",
        "HI",
        "ID",
        "IL",
        "IN",
        "IA",
        "KS",
        "KY",
        "LA",
        "ME",
        "MH",
        "MD",
        "MA",
        "MI",
        "MN",
        "MS",
        "MO",
        "MT",
        "NE",
        "NV",
        "NH",
        "NJ",
        "NM",
        "NY",
        "NC",
        "ND",
        "MP",
        "OH",
        "OK",
        "OR",
        "PI",
        "PW",
        "PA",
        "PR",
        "RI",
        "SC",
        "SD",
        "TN",
        "TX",
        "UT",
        "VT",
        "VI",
        "VA",
        "WA",
        "WV",
        "WI",
        "WY",
        "AB",
        "BC",
        "LB",
        "MB",
        "NB",
        "NL",
        "NT",
        "NS",
        "ON",
        "PE",
        "PQ",
        "SK",
        "YT",
        "AW",
        "JM",
        "TR",
        "TO",
      ],
    },
    country: {
      title: "Country",
      description: "Country of the Building",
      type: ["string", "null"],
      maxLength: 300,
    },
    zip: {
      title: "Zip",
      description: "Zip code of the Building",
      type: ["string", "null"],
      maxLength: 20,
    },
    is_enabled: {
      title: "Active",
      description: "Building status",
      type: ["boolean", "null"],
      default: true,
    },
    latitude: {
      title: "Latitude",
      description: "Geographical latitude of the building",
      type: ["number", "null"],
      minimum: -90,
      maximum: 90,
      default: null,
    },
    longitude: {
      title: "Longitude",
      description: "Geographical longitude of the building",
      type: ["number", "null"],
      minimum: -180,
      maximum: 180,
      default: null,
    },
    dms_building_id: {
      title: "PG Id",
      description: "PG identifier for the building",
      type: ["string", "null"],
    },
    active_status: {
      title: "Status",
      description: "Determines whether the object is active or inactive.",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
      default: "inactive",
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    store_id: {
      title: "Store",
      description: "Store identifier",
      type: "string",
      minLength: 1,
    },
    department_id: {
      title: "Department id",
      description: "Department id",
      type: "string",
    },
    department_name: {
      title: "Department name",
      description: "Department name",
      type: ["string", "null"],
      default: null,
    },
    cnumber: {
      title: "C Number",
      description: "Customer number identifier",
      type: "string",
      isHidden: true,
    },
    route_names: {
      title: "Associated Route Names",
      description: "List of associated route names for the building",
      type: ["array", "null"],
      items: {
        type: "string",
      },
      default: null,
    },
    zones: {
      title: "Zone Name",
      description: "List of associated zone names for the building",
      type: ["array", "null"],
      items: {
        type: "string",
      },
      default: null,
    },
  },
  required: ["name", "enterprise_id", "store_id", "department_id", "cnumber"],
  sections: {
    details: {
      building_details: [
        "is_enabled",
        "priority",
        "name",
        "address_line_1",
        "address_line_2",
        "city",
        "state",
        "zip",
        "cnumber",
      ],
    },
    zones: {
      zone_details: ["zones"],
    },
    routes: {
      route_details: ["route_names"],
    },
  },
};

export const MOCK_INVOICE_AUTO_POST_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-invoice-auto-post-schema.json",
  title: "InvoiceAutoPost",
  description: "A schema definition for Invoice Auto Post",
  functional_area: "ACCT",
  type: "object",
  properties: {
    auto_post_opt_in: {
      title: "Enable Invoice Auto-Post",
      description:
        "Flag to determine whether invoice auto-posting is enabled for the store",
      type: "boolean",
      default: false,
    },
    amount_exception: {
      title: "Amount Exception",
      description:
        "The threshold amount for exceptions that require manual review when auto-posting invoices. If the invoice amount exceeds this threshold, it will not be auto-posted and will instead be flagged for manual review.",
      type: ["number", "null"],
      default: null,
    },
    new_vendor_exception_months: {
      title: "New Vendor Exception Months",
      description:
        "The number of months since a vendor was added to the system during which invoices from that vendor will be flagged for manual review instead of being auto-posted. This is to mitigate risks associated with new vendors.",
      type: "integer",
      maximum: 96,
      minimum: 0,
      default: 0,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
      default: "inactive",
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    store_id: {
      title: "Store",
      description: "Store identifier",
      type: "string",
      minLength: 1,
    },
    tenant_id: {
      title: "Tenant",
      description: "Tenant identifier",
      type: "string",
      minLength: 1,
    },
    transaction_id: {
      title: "Transaction Id",
      description: "Transaction id from salesforce ",
      type: ["string", "null"],
      minLength: 1,
      default: null,
    },
  },
  required: ["auto_post_opt_in", "enterprise_id", "store_id"],
  sections: {
    exception_info: [
      "auto_post_opt_in",
      "amount_exception",
      "new_vendor_exception_months",
    ],
  },
  sectionsInfo: {
    exception_info:
      "Configure thresholds for invoice amounts and new vendors that should be flagged for manual review instead of auto-posting.",
  },
  dependencies: {
    auto_post_opt_in: {
      rules: [
        {
          matches: [true],
          fieldsToEnable: ["amount_exception", "new_vendor_exception_months"],
        },
        {
          matches: [false],
          fieldsToDisableAndClear: [
            "amount_exception",
            "new_vendor_exception_months",
          ],
        },
      ],
    },
  },
};

export const MOCK_DEFAULT_LABOR_TYPES_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-setup-default-labor-types.json",
  title: "DefaultLaborTypes",
  description: "A schema definition for Default Labor Types setup",
  type: "object",
  properties: {
    make: {
      title: "Make",
      description: "Valid vehicle make in CAR-DESC",
      type: "string",
      typeaheadConfig: {
        url: "/v2/search/Make",
        minChars: 2,
        body: {
          responseFields: ["make", "name"],
        },
        valueField: "make",
        labelField: ["make", "name"],
      },
    },
    model: {
      title: "Model",
      description: "Valid vehicle model in CAR-DESC",
      type: "string",
      typeaheadConfig: {
        url: "/v2/search/Model",
        minChars: 2,
        body: {
          filters: [
            {
              field: "make",
              operator: "EQUALS",
              value: "$make",
            },
          ],
          responseFields: ["model", "description"],
        },
        valueField: "model",
        labelField: ["model", "description"],
      },
    },
    default_labor_type: {
      title: "Writeup type",
      description:
        "Default labor type the system uses for service write-up by make and model selection",
      type: ["string", "null"],
      enum: [
        "Prompt with default and allow override",
        "Prompt with no default, required entry",
        null,
      ],
      default: null,
    },
    writeup_type: {
      title: "Default Labor Type",
      description: "Default Labor Type",
      type: "string",
      evalMethod: "addDefaultLaborTypesEmptyEnumForDefaultLaborType",
    },
    customer_labor_rate: {
      title: "Customer Labor Rate",
      description: "Customer labor rate assigned to this make and model",
      type: "number",
      default: 0,
    },
    customer_pay_type: {
      title: "Customer Pay Type",
      description: "Customer Labor Pay Type",
      type: ["string", "null"],
      evalMethod: "addDefaultLaborTypesEmptyEnumForCustomerPayType",
      default: null,
    },
    warranty_pay_type: {
      title: "Warranty Pay Type",
      description: "Warranty Labor Pay Type",
      type: ["string", "null"],
      evalMethod: "addDefaultLaborTypesEmptyEnumForWarrantyPayType",
      default: null,
    },
    internal_pay_type: {
      title: "Internal Pay Type",
      description: "Internal Labor Pay Type",
      type: ["string", "null"],
      evalMethod: "addDefaultLaborTypesEmptyEnumForInternalPayType",
      default: null,
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    store_id: {
      title: "Store",
      description: "Store identifier",
      type: "string",
      minLength: 1,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
      default: "inactive",
    },
    department_id: {
      title: "Department id",
      description: "Department id",
      type: "string",
    },
    department_name: {
      title: "Department name",
      description: "Department name",
      type: ["string", "null"],
      default: null,
    },
  },
  required: [
    "make",
    "model",
    "writeup_type",
    "enterprise_id",
    "store_id",
    "department_id",
  ],
  sections: {
    grid_fields: [
      "make",
      "model",
      "default_labor_type",
      "writeup_type",
      "customer_labor_rate",
      "customer_pay_type",
      "warranty_pay_type",
      "internal_pay_type",
    ],
    general_fields: ["make", "model"],
    modify_write_up_default_labor_type_and_customer_labor_rate_fields: [
      "default_labor_type",
      "writeup_type",
      "customer_labor_rate",
    ],
    modify_OEM_default_labor_types_fields: [
      "customer_pay_type",
      "warranty_pay_type",
      "internal_pay_type",
    ],
  },
};

export const MOCK_DEFAULT_LABOR_TYPES_ROW_DATA: RowData = {
  id: "b6de0388-fa7a-49e9-bb06-ddbdabd5a3e0",
  department_id: "D100096272",
  department_name: "TOM-S",
  store_id: "S100119367",
  default_labor_type: "2",
  make: "DEFAULT",
  model: "DEFAULT",
  writeup_type: "CP",
  customer_labor_rate: 3.51,
  customer_pay_type: "CE",
  warranty_pay_type: "WBS",
  internal_pay_type: "IBS",
  new: false,
  serial_no: 97,
  enterprise_id: "E339440",
  active_status: "active",
  created_by: "sys-user-dms-admin",
  created_at: "2026-03-16T10:02:24.646+00:00",
  updated_by: "sys-user-dms-admin",
  updated_at: "2026-03-16T10:02:33.663+00:00",
};

export const MOCK_DEFAULT_LABOR_TYPES_INITIAL_ROW_DATA: RowData = {
  make: "",
  model: "",
  default_labor_type: "",
  writeup_type: null,
  customer_labor_rate: 0,
  customer_pay_type: null,
  warranty_pay_type: null,
  internal_pay_type: null,
};

export const MOCK_GROUPING_ACCOUNTS_RECEIVABLE_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-ar-schema.json",
  title: "AccountsReceivable",
  description: "A schema definition for an Accounts Receivable object",
  type: "object",
  properties: {
    ar_group: {
      title: "AR Group",
      description: "Group for ar_company",
      type: "string",
      isEditable: false,
      isGroupId: true,
      storeKey: "ar_store",
      dependentFields: ["ar_account"],
      evalMethod: "updateDefaultFCGroup",
    },
    ar_store: {
      title: "AR Store",
      description: "Store for ar_company",
      type: "string",
      isStore: true,
      disabled: true,
      companyKey: "ar_company",
      evalMethod: "updateDefaultFCStore",
    },
    ar_company: {
      title: "AR Company",
      description: "AR Company used for this setup",
      type: "string",
      disabled: true,
      evalMethod: "updateDefaultFCCompany",
    },
    ar_account: {
      title: "AR Account",
      description: "Chart account used for this setup",
      type: "string",
      isEditable: false,
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "account_type",
              operator: "EQUALS",
              value: "Asset",
            },
            {
              field: "sub_type",
              operator: "EQUALS",
              value: null,
            },
            {
              field: "control_type_code",
              operator: "EQUALS",
              value: "A/R Customer",
            },
          ],
          responseFields: ["account_number", "account_description"],
        },
        storeId: "$ar_store",
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    sub_type: {
      title: "AR Schedule Type",
      description: "Open-Item Receivable or Balance-forward Receivable",
      type: "string",
      enum: ["Open-Item Receivable", "Balance-forward Receivable"],
      evalMethod: "getAccountsReceivableScheduleCodeandScheduleType",
      isEditable: false,
    },
    schedule_code: {
      title: "Schedule Code",
      description: "Schedule code",
      type: "string",
      pattern: "^[A-Z]$",
      isUnique: true,
      disabled: true,
      evalMethod: "getAccountsReceivableSubType",
    },
    schedule_title: {
      title: "Schedule Title",
      description: "Schedule title",
      type: "string",
      default: "AR PARTS AND SERVICE",
    },
    finance_charge_jrnl_group: {
      title: "FC Journal Group",
      description: "FC Journal Group",
      type: "string",
      isGroupId: true,
      storeKey: "finance_charge_jrnl_store",
      dependentFields: ["finance_charge_jrnl"],
    },
    finance_charge_jrnl_store: {
      title: "FC Journal Store",
      description: "FC journal store",
      type: "string",
      isStore: true,
      companyKey: "finance_charge_jrnl_company",
      disabled: true,
    },
    finance_charge_jrnl_company: {
      title: "FC Journal Company",
      description: "FC journal company",
      type: "string",
      disabled: true,
    },
    finance_charge_jrnl: {
      title: "FC Journal",
      description: "FC journal",
      type: "string",
      typeaheadConfig: {
        url: "/v2/search/Journals",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "journal_type",
              operator: "EQUALS",
              value: "Accounts Receivable Finance Charge",
            },
          ],
          responseFields: ["journal_id", "journal_name"],
        },
        storeId: "$finance_charge_jrnl_store",
        valueField: "journal_id",
        labelField: ["journal_id", "journal_name"],
      },
    },
    finance_charge_acct_group: {
      title: "FC Account Group",
      description: "FC Account Group",
      type: "string",
      isGroupId: true,
      storeKey: "finance_charge_acct_store",
      dependentFields: ["finance_charge_acct"],
    },
    finance_charge_acct_store: {
      title: "FC Account Store",
      description: "FC Account company",
      type: "string",
      isStore: true,
      companyKey: "finance_charge_acct_company",
      disabled: true,
    },
    finance_charge_acct_company: {
      title: "FC Account Company",
      description: "FC acct company",
      type: "string",
      disabled: true,
    },
    finance_charge_acct: {
      title: "FC Account",
      description: "FC Account",
      type: "string",
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "account_type",
              operator: "EQUALS",
              value: "Asset",
            },
            {
              field: "control_type_code",
              operator: "IN",
              value: ["Reference", "None"],
            },
          ],
          responseFields: ["account_number", "account_description"],
        },
        storeId: "$finance_charge_acct_store",
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    finance_charge_rate: {
      title: "Finance Charge Percentage",
      description: "Monthly interest rate charged",
      type: ["number", "null"],
      default: null,
    },
    finance_charge_limit: {
      title: "Finance Charge Limit",
      description: "Amount up to which interest will be charged",
      type: ["number", "null"],
      default: null,
    },
    ar_description: {
      title: "AR Description",
      description: "Used as AR posting description",
      type: "string",
      default: "FINANCE CHARGE",
    },
    finance_charge_acct_desc: {
      title: "FC Acct Description",
      description: "Account posting description",
      type: "string",
      default: "FINANCE CHARGE",
    },
    zero_or_credit_print_option: {
      title: "Zero or Credit Print option",
      description: "Zero or Credit Print option",
      type: "string",
      enum: [
        "Print all statements",
        "Suppress printing statements for control numbers with zero balance",
        "Suppress printing statements for control numbers with credit balance",
        "Suppress printing statements for control numbers with either credit or zero balance",
      ],
      default: "Print all statements",
    },
    print_zero_balance_references: {
      title: "Print Zero Balance References",
      description: "Print or suppress zero balance references",
      type: "boolean",
      default: true,
    },
    print_credit_memo_detail: {
      title: "Print Credit Memo Detail",
      description: "Print credit memo detail",
      type: "boolean",
      default: true,
    },
    schedule_type: {
      title: "Schedule Type",
      description: "Schedule type",
      type: ["string", "null"],
      enum: ["AR_OPEN", "AR_BAL", null],
      default: null,
      isHidden: true,
    },
    schedule_required_for_close: {
      title: "Schedule Required For Close",
      description: "Schedule required for close",
      type: "boolean",
      default: true,
    },
    sub_total_by_unit: {
      title: "Sub total by unit",
      description: "Sub total configuration",
      type: "boolean",
      default: false,
    },
    print_lease_statements: {
      title: "Print lease statements",
      description: "Print lease statements decision",
      type: "boolean",
      default: false,
    },
    ar_flag: {
      title: "Account Receivable Flag",
      description:
        "False, A/R has not been started, has been reset, or has been completed. True, Final statement or final schedule is in progress.",
      type: "boolean",
      default: false,
      isHidden: true,
    },
    min_finance_charge_amount: {
      title: "Minimum finance charge amount",
      description: "Minimum finance charge amount",
      type: ["number", "null"],
      default: null,
    },
    ar_close_date: {
      title: "Date of last accounts receivable close",
      description: "Date of last accounts receivable close (DDMMMYYYY format).",
      type: ["string", "null"],
      format: "date",
      default: null,
      disabled: true,
    },
    ar_credit_aging_flag: {
      title: "ARO Credit Aging flag",
      description:
        "False, do not age AR open-item net credit balance invoices. True, age AR open-item net credit balance invoices",
      type: "boolean",
      default: false,
    },
    multiple_finance_charge_flag: {
      title: "Multiple FC reference flag",
      description:
        "False, Using multiple reference numbers when posting finance charges. True, Using single reference when posting finance charges.",
      type: "boolean",
      default: false,
    },
    schedule_field: {
      title: "Schedule Field",
      description: "Additional field to print on schedules",
      type: ["string", "null"],
      default: null,
    },
    aged_trial_balance_field: {
      title: "Aged Trial Balance Field",
      description: "Additional field to print on aged trial balance",
      type: ["string", "null"],
      default: null,
    },
    schedule_fields: {
      title: "Schedule Fields",
      description: "Schedule Fields",
      key: "schedule_field",
      type: "array",
      items: {
        type: "string",
      },
      enum: [
        "NAME",
        "TELEPHONE",
        "INT",
        "CREDIT",
        "HOLD-FLAG",
        "TOTAL-90",
        "CNTRL2",
        "GRP",
      ],
    },
    aged_trial_balance_fields: {
      title: "Aged Trial Balance Fields",
      description: "Aged Trial Balance Fields",
      key: "aged_trial_balance_field",
      type: "array",
      items: {
        type: "string",
      },
      enum: [
        "NAME",
        "TELEPHONE",
        "INT",
        "CREDIT",
        "HOLD-FLAG",
        "TOTAL-90",
        "CNTRL2",
        "GRP",
      ],
    },
    record_type: {
      title: "Record type",
      description: "Identifies the flattened record type",
      type: "string",
      enum: [
        "Base",
        "Interest Control",
        "Schedule Fields",
        "Aged Trial Balance Fields",
      ],
      default: "Base",
    },
    aging_gap: {
      title: "AR aging gap",
      description: "AR aging gap",
      type: "integer",
      enum: [30, 45],
      default: 30,
    },
    statement_cut_off_day: {
      title: "AR Statement Cut-Off Day",
      description:
        "AR Statement Cut-Off day for generating and sending AR Statements to our AR Dealerships Customers so that AR Customers get the statements consistently on the same day of every month.",
      type: ["integer", "null"],
      minimum: 1,
      maximum: 31,
      default: null,
    },
    customer_lock_time_out: {
      title: "Customer lock timeout",
      description:
        "Customer lock timeout during AR Apply Payments so that Customers get unlocked automatically after a certain time .",
      type: "integer",
      minimum: 1,
      maximum: 96,
      default: 30,
    },
    ar_apply_payments_method: {
      title: "AR Apply Payments Method",
      description:
        "Select AR Apply Payments Method either Select my own Invoices or Predefined 4 Auto Selections as below.",
      type: "string",
      minLength: 1,
      enum: [
        "Select my own Invoices",
        "Oldest to Newest",
        "Newest to Oldest",
        "Largest to Smallest",
        "Smallest to Largest",
        "Disable Auto Selection",
      ],
      default: "Select my own Invoices",
    },
    interest_control: {
      title: "Interest Charge",
      description: "Interest Charge",
      maximum: 3,
      type: "array",
      items: {
        type: "object",
        properties: {
          finance_charge_rate: {
            title: "Finance Charge Percentage",
            type: "number",
            default: 1.5,
          },
          finance_charge_limit: {
            title: "Finance Charge Limit",
            type: "number",
            default: 99999999,
          },
        },
        required: ["finance_charge_rate", "finance_charge_limit"],
      },
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    group_id: {
      title: "Group",
      description: "Group identifier",
      type: "string",
      minLength: 1,
    },
    store_id: {
      title: "Store",
      description: "Store identifier",
      type: "string",
      minLength: 1,
    },
    tenant_id: {
      title: "Tenant",
      description: "Tenant identifier",
      type: "string",
      minLength: 1,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
    },
    transaction_id: {
      default: null,
      description: "Transaction id from salesforce ",
      minLength: 1,
      title: "Transaction Id",
      type: ["string", "null"],
    },
  },
  required: [
    "ar_company",
    "ar_account",
    "ar_description",
    "finance_charge_acct",
    "finance_charge_acct_company",
    "finance_charge_acct_desc",
    "finance_charge_jrnl_company",
    "finance_charge_jrnl",
    "zero_or_credit_print_option",
    "print_zero_balance_references",
    "print_credit_memo_detail",
    "schedule_code",
    "schedule_title",
    "schedule_required_for_close",
    "sub_total_by_unit",
    "print_lease_statements",
    "ar_flag",
    "ar_credit_aging_flag",
    "multiple_finance_charge_flag",
    "enterprise_id",
    "store_id",
  ],
  sections: {
    grid_fields: [
      "schedule_code",
      "ar_account",
      "ar_store",
      "schedule_title",
      "finance_charge_jrnl",
      "finance_charge_acct",
    ],
    general_fields: [
      "sub_type",
      "schedule_code",
      "schedule_title",
      "zero_or_credit_print_option",
      "ar_flag",
      "min_finance_charge_amount",
      "ar_close_date",
      "schedule_type",
      "schedule_fields",
      "aged_trial_balance_fields",
      "print_zero_balance_references",
      "print_credit_memo_detail",
      "ar_credit_aging_flag",
      "multiple_finance_charge_flag",
      "schedule_required_for_close",
      "print_lease_statements",
      "sub_total_by_unit",
    ],
    AR_information: [
      "ar_group",
      "ar_store",
      "ar_company",
      "ar_account",
      "ar_description",
    ],
    FC_journal_information: [
      "finance_charge_jrnl_group",
      "finance_charge_jrnl_store",
      "finance_charge_jrnl_company",
      "finance_charge_jrnl",
    ],
    FC_account_information: [
      "finance_charge_acct_group",
      "finance_charge_acct_store",
      "finance_charge_acct_company",
      "finance_charge_acct",
      "finance_charge_acct_desc",
    ],
    AR_Default_Config: [
      "aging_gap",
      "statement_cut_off_day",
      "customer_lock_time_out",
      "ar_apply_payments_method",
    ],
    corelation_fields: ["interest_control"],
  },
  dependencies: {
    print_lease_statements: {
      rules: [
        {
          matches: [true],
          fieldsToEnable: ["sub_total_by_unit"],
        },
        {
          matches: [false],
          fieldsToDisableAndClear: ["sub_total_by_unit"],
        },
      ],
    },
  },
};

export const MOCK_ON_DEMAND_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-odc-schema.json",
  title: "OnDemandChecks",
  description: "A schema definition for ODC Check writing setups",
  type: "object",
  properties: {
    journal_store: {
      title: "Store",
      description: "Store for journal",
      type: ["string", "null"],
      isStore: true,
      companyKey: "journal_company_id",
      dependentFields: ["journal_number"],
    },
    journal_company_id: {
      title: "Company",
      description: "Journal Company identifier",
      type: ["string", "null"],
      disabled: true,
      storeKey: "journal_store",
    },
    journal_number: {
      title: "Journal",
      description: "Journal number",
      type: ["string", "null"],
      typeaheadConfig: {
        url: "/v2/search/Journals",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "journal_type",
              operator: "IN",
              value: [
                "Set Up Schedule Balances",
                "Open-Item Payable",
                "Intercompany Transfer",
                "Install Account Balances",
                "Generic",
              ],
            },
          ],
          responseFields: ["journal_id", "journal_name"],
        },
        storeId: "$journal_store",
        valueField: "journal_id",
        labelField: ["journal_id", "journal_name"],
      },
    },
    cash_account_store: {
      title: "Store",
      description: "Store for Cash Account",
      type: ["string", "null"],
      isStore: true,
      companyKey: "cash_account_company",
      dependentFields: ["cash_account_number"],
    },
    cash_account_company: {
      title: "Company",
      description: "Cash account company",
      type: ["string", "null"],
      disabled: true,
      storeKey: "cash_account_store",
    },
    cash_account_number: {
      title: "Account",
      description: "Cash account number",
      type: ["string", "null"],
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "account_type",
              operator: "EQUALS",
              value: "Asset",
            },
          ],
          responseFields: ["account_description", "account_number"],
        },
        storeId: "$cash_account_store",
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    offset_account_store: {
      title: "Store",
      description: "Store for Offset Account",
      type: ["string", "null"],
      isStore: true,
      companyKey: "offset_account_company",
      dependentFields: ["offset_account_number"],
    },
    offset_account_company: {
      title: "Company",
      description: "Offset account company",
      type: ["string", "null"],
      disabled: true,
      storeKey: "offset_account_store",
    },
    offset_account_number: {
      title: "Account",
      description: "Offset account number",
      type: ["string", "null"],
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "account_type",
              operator: "EQUALS",
              value: "Asset",
            },
          ],
          responseFields: ["account_description", "account_number"],
        },
        storeId: "$offset_account_store",
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    flr_journal_store: {
      title: "Store",
      description: "Store for Flooring journal",
      type: ["string", "null"],
      isStore: true,
      companyKey: "flr_journal_company_id",
      dependentFields: ["flr_journal_number"],
    },
    flr_journal_company_id: {
      title: "Company",
      description: "Flooring Journal Company identifier",
      type: ["string", "null"],
      disabled: true,
      storeKey: "flr_journal_store",
    },
    flr_journal_number: {
      title: "Journal",
      description: "Flooring Journal number",
      type: ["string", "null"],
      typeaheadConfig: {
        url: "/v2/search/Journals",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "journal_type",
              operator: "IN",
              value: [
                "Set Up Schedule Balances",
                "Open-Item Payable",
                "Intercompany Transfer",
                "Install Account Balances",
                "Generic",
              ],
            },
          ],
          responseFields: ["journal_id", "journal_name"],
        },
        storeId: "$flr_journal_store",
        valueField: "journal_id",
        labelField: ["journal_id", "journal_name"],
      },
    },
    flr_cash_account_store: {
      title: "Store",
      description: "Store for flooring Cash Account",
      type: ["string", "null"],
      isStore: true,
      companyKey: "flr_cash_account_company",
      dependentFields: ["flr_cash_account_number"],
    },
    flr_cash_account_company: {
      title: "Company",
      description: "Flooring Cash account company",
      type: ["string", "null"],
      disabled: true,
      storeKey: "flr_cash_account_store",
    },
    flr_cash_account_number: {
      title: "Account",
      description: "Flooring Cash account number",
      type: ["string", "null"],
      default: null,
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "account_type",
              operator: "EQUALS",
              value: "Asset",
            },
          ],
          responseFields: ["account_description", "account_number"],
        },
        storeId: "$flr_cash_account_store",
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    flr_offset_account_store: {
      title: "Store",
      description: "Store for Flooring Offset Account",
      type: ["string", "null"],
      isStore: true,
      companyKey: "flr_offset_account_company",
      dependentFields: ["flr_offset_account_number"],
    },
    flr_offset_account_company: {
      title: "Company",
      description: "Flooring Offset account company",
      type: ["string", "null"],
      disabled: true,
      storeKey: "flr_offset_account_store",
    },
    flr_offset_account_number: {
      title: "Account",
      description: "Flooring Offset account number",
      type: ["string", "null"],
      default: null,
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "account_type",
              operator: "EQUALS",
              value: "Asset",
            },
          ],
          responseFields: ["account_description", "account_number"],
        },
        storeId: "$flr_offset_account_store",
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    cri_reminder_days: {
      title: "CRI Reminder Days",
      description: "Number of CRI reminder days 30 - 1460",
      type: "integer",
      minimum: 30,
      maximum: 1460,
    },
    overflow_remittance: {
      title: "Overflow remittance advice",
      description:
        "Determines how to handle remittance overflow during printing",
      type: ["string", "null"],
      enum: [
        "Print on separate sheet",
        "Print on following check stub",
        "Print from separate laser tray",
        null,
      ],
    },
    check_date_format: {
      title: "Check date format",
      description: "The check date format to be used for print/display",
      type: ["string", "null"],
      enum: [
        "DDMMMYY",
        "M/DD/YY",
        "MMDDYY",
        "DDMMMYYYY",
        "MM/DD/YYYY",
        "YYYY-MM-DD",
        "DD.MM.YYYY",
        null,
      ],
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    store_id: {
      title: "Store",
      description: "Store identifier",
      type: "string",
      minLength: 1,
    },
    tenant_id: {
      title: "Tenant",
      description: "Tenant identifier",
      type: "string",
      minLength: 1,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
    },
    transaction_id: {
      default: null,
      description: "Transaction id from salesforce ",
      minLength: 1,
      title: "Transaction Id",
      type: ["string", "null"],
    },
  },
  required: ["cri_reminder_days", "enterprise_id", "store_id"],
  sections: {
    grid_fields: [
      "journal_store",
      "journal_number",
      "cash_account_store",
      "cash_account_number",
      "offset_account_store",
      "offset_account_number",
      "flr_journal_store",
      "flr_journal_number",
    ],
    general_fields: [
      "cri_reminder_days",
      "overflow_remittance",
      "check_date_format",
    ],
    journal_information: [
      "journal_store",
      "journal_company_id",
      "journal_number",
    ],
    cash_account_information: [
      "cash_account_store",
      "cash_account_company",
      "cash_account_number",
    ],
    offset_account_information: [
      "offset_account_store",
      "offset_account_company",
      "offset_account_number",
    ],
    flooring_journal_information: [
      "flr_journal_store",
      "flr_journal_company_id",
      "flr_journal_number",
    ],
    flooring_cash_account_information: [
      "flr_cash_account_store",
      "flr_cash_account_company",
      "flr_cash_account_number",
    ],
    flooring_offset_information: [
      "flr_offset_account_store",
      "flr_offset_account_company",
      "flr_offset_account_number",
    ],
  },
  sectionsInfo: {
    general_fields:
      "Configure general settings for on-demand checks, including CRI reminder days, remittance overflow handling, and check date format.",
    journal_information: "Primary journal configuration for check processing.",
    cash_account_information: "Cash account used for transactions.",
    offset_account_information:
      "Offset account configuration for balancing entries.",
    flooring_journal_information:
      "Journal configuration specific to flooring transactions.",
    flooring_cash_account_information:
      "Cash account used for flooring-related transactions.",
    flooring_offset_information:
      "Offset account used for flooring transactions.",
  },
};

export const MOCK_AR_PORTAL_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-ar-portal-schema.json",
  title: "ARPortal",
  description: "A schema definition for AR Portal Setup",
  type: "object",
  properties: {
    accounting_account: {
      title: "Accounting Account",
      description: "Accounting Account(Logon)",
      type: "string",
      minLength: 1,
      isEditable: false,
      isUnique: true,
      evalMethod: "addEmptyAccountingAccountEnum",
    },
    drive_user_id: {
      title: "Drive User Id",
      description: "Drive User Id",
      type: ["string", "null"],
      default: null,
    },
    ar_posting_user_id: {
      title: "AR Posting User Id",
      description: "AR Posting User Id",
      type: ["string", "null"],
      default: null,
    },
    ar_balance_due: {
      title: "AR Balance Due Date (In days)",
      description: "Date of the month the AR balance is due",
      type: "string",
    },
    posting_journal_store: {
      title: "Store",
      description: "Store for posting journal",
      type: "string",
      isStore: true,
      companyKey: "posting_journal_company",
      dependentFields: ["posting_journal_number"],
    },
    posting_journal_company: {
      title: "Company",
      description: "Posting Journal Company",
      type: "string",
      disabled: true,
      storeKey: "posting_journal_store",
    },
    posting_journal_number: {
      title: "Journal",
      description: "Posting Journal Number",
      type: "string",
      typeaheadConfig: {
        url: "/v2/search/Journals",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "journal_type",
              operator: "EQUALS",
              value: "Open-Item Cash Receipt",
            },
          ],
          responseFields: ["journal_id", "journal_name"],
        },
        storeId: "$posting_journal_store",
        valueField: "journal_id",
        labelField: ["journal_id", "journal_name"],
      },
    },
    cash_store: {
      title: "Store",
      description: "ACH cash Store ",
      type: "string",
      isStore: true,
      companyKey: "cash_company",
      dependentFields: ["cash_acct"],
    },
    cash_company: {
      title: "Company",
      description: "ACH Company",
      type: "string",
      disabled: true,
      storeKey: "cash_store",
    },
    cash_acct: {
      title: "Account",
      description: "ACH Account",
      type: "string",
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "sub_type",
              operator: "EQUALS",
              value: "Cash",
            },
          ],
          responseFields: ["account_description", "account_number"],
        },
        storeId: "$cash_store",
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    credit_card_posting_acct_store: {
      title: "Store",
      description: "Credit Card Posting Store",
      type: "string",
      isStore: true,
      companyKey: "credit_card_posting_acct_company",
      dependentFields: ["credit_card_gl_posting_acct"],
    },
    credit_card_posting_acct_company: {
      title: "Company",
      description: "Credit Card Posting Account Company",
      type: "string",
      disabled: true,
      storeKey: "credit_card_posting_acct_store",
    },
    credit_card_gl_posting_acct: {
      title: "Account",
      description: "Credit Card GL Posting Account",
      type: "string",
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "sub_type",
              operator: "EQUALS",
              value: "Cash",
            },
          ],
          responseFields: ["account_description", "account_number"],
        },
        storeId: "$credit_card_posting_acct_store",
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    amex_posting_acct_store: {
      title: "Store",
      description: "Amex Card Posting Store",
      type: "string",
      isStore: true,
      companyKey: "amex_posting_acct_company",
      dependentFields: ["amex_gl_posting_acct"],
    },
    amex_posting_acct_company: {
      title: "Company",
      description: "AMEX Posting Account Company",
      type: "string",
      disabled: true,
      storeKey: "amex_posting_acct_store",
    },
    amex_gl_posting_acct: {
      title: "Account",
      description: "AMEX GL Posting Account",
      type: "string",
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "sub_type",
              operator: "EQUALS",
              value: "Cash",
            },
          ],
          responseFields: ["account_description", "account_number"],
        },
        storeId: "$amex_posting_acct_store",
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    cash_clearing_store: {
      title: "Store",
      description: "Cash Clearing Store",
      type: "string",
      isStore: true,
      companyKey: "cash_clearing_company",
      dependentFields: ["cash_clearing_gl_posting_acct"],
    },
    cash_clearing_company: {
      title: "Company",
      description: "Cash Clearing Company",
      type: "string",
      disabled: true,
      storeKey: "cash_clearing_store",
    },
    cash_clearing_gl_posting_acct: {
      title: "Account",
      description: "Cash Clearing GL Posting Account",
      type: "string",
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "sub_type",
              operator: "EQUALS",
              value: "Cash",
            },
          ],
          responseFields: ["account_description", "account_number"],
        },
        storeId: "$cash_clearing_store",
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    ar_posting_account_store: {
      title: "Store",
      description: "AR Store",
      type: "string",
      isStore: true,
      companyKey: "ar_posting_account_company",
      dependentFields: ["ar_gl_posting_account"],
    },
    ar_posting_account_company: {
      title: "Company",
      description: "AR Posting Account Company",
      type: "string",
      disabled: true,
      storeKey: "ar_posting_account_store",
    },
    ar_gl_posting_account: {
      title: "Account",
      description: "AR GL Posting Account",
      type: "string",
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "sub_type",
              operator: "EQUALS",
              value: "Open-Item Receivable",
            },
          ],
          responseFields: ["account_description", "account_number"],
        },
        storeId: "$ar_posting_account_store",
        valueField: "account_number",
        labelField: ["account_number", "account_description"],
      },
    },
    sup_zero_blnc_inv_stmt_display: {
      title: "Suppress Zero Balance Details",
      description:
        "Suppress zero balance invoices for statement display on AR Portal",
      type: "boolean",
      default: false,
    },
    sup_zero_blnc_inv_open_ar_trans: {
      title: "Suppress Zero Balance Invoices for Open AR Transactions",
      description:
        "Suppress zero balance invoices for Open AR Transactions display on AR Portal",
      type: "boolean",
      default: false,
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    store_id: {
      title: "Store",
      description: "Store identifier",
      type: "string",
    },
    tenant_id: {
      title: "Tenant",
      description: "Tenant identifier",
      type: "string",
      format: "uuid",
      minLength: 1,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
      default: "inactive",
    },
    transaction_id: {
      title: "Transaction Id",
      description: "Transaction id from salesforce ",
      type: ["string", "null"],
      minLength: 1,
      default: null,
    },
  },
  required: [
    "ar_balance_due",
    "accounting_account",
    "posting_journal_store",
    "posting_journal_company",
    "posting_journal_number",
    "cash_store",
    "cash_company",
    "cash_acct",
    "credit_card_posting_acct_store",
    "credit_card_posting_acct_company",
    "credit_card_gl_posting_acct",
    "amex_posting_acct_store",
    "amex_posting_acct_company",
    "amex_gl_posting_acct",
    "cash_clearing_store",
    "cash_clearing_company",
    "cash_clearing_gl_posting_acct",
    "ar_posting_account_store",
    "ar_posting_account_company",
    "ar_gl_posting_account",
    "enterprise_id",
    "store_id",
  ],
  sections: {
    grid_fields: [
      "accounting_account",
      "posting_journal_company",
      "posting_journal_number",
      "cash_clearing_company",
      "cash_clearing_gl_posting_acct",
      "ar_posting_account_company",
      "ar_gl_posting_account",
    ],
    general_fields: [
      "accounting_account",
      "ar_posting_user_id",
      "ar_balance_due",
    ],
    options: [
      "sup_zero_blnc_inv_stmt_display",
      "sup_zero_blnc_inv_open_ar_trans",
    ],
    posting_journal_information: [
      "posting_journal_store",
      "posting_journal_company",
      "posting_journal_number",
    ],
    ACH_information: ["cash_store", "cash_company", "cash_acct"],
    credit_card_information: [
      "credit_card_posting_acct_store",
      "credit_card_posting_acct_company",
      "credit_card_gl_posting_acct",
    ],
    amex_card_information: [
      "amex_posting_acct_store",
      "amex_posting_acct_company",
      "amex_gl_posting_acct",
    ],
    cash_clearing_information: [
      "cash_clearing_store",
      "cash_clearing_company",
      "cash_clearing_gl_posting_acct",
    ],
    AR_information: [
      "ar_posting_account_store",
      "ar_posting_account_company",
      "ar_gl_posting_account",
    ],
  },
  sectionsInfo: {
    general_fields: "Basic AR portal configuration and identifiers",
    options: "Display and suppression settings for AR portal transactions",
    posting_journal_information:
      "Configuration for journal used in AR postings.",
    ACH_information: "ACH cash account configuration for AR transactions.",
    credit_card_information: "Credit card posting account configuration.",
    amex_card_information: "American Express posting account configuration.",
    cash_clearing_information:
      "Cash clearing account configuration for AR processing.",
    AR_information: "AR posting account configuration.",
  },
};

export const MOCK_MAKE_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-setup-accounting-make-schema.json",
  title: "Make",
  description:
    "Schema definition for accounting MAKE record. Stores manufacturer make abbreviations and serial number validation metadata used by VEHICLES and related applications.",
  type: "object",
  properties: {
    make: {
      title: "Make",
      description: "Make abbreviation. DMS file record item-ID.",
      type: "string",
      minLength: 1,
      maxLength: 6,
    },
    name: {
      title: "Name",
      description:
        "Full manufacturer’s make name used in reports and displays.",
      type: "string",
      minLength: 1,
    },
    serial_year_position: {
      title: "Serial Year Position",
      description:
        "Position in the serial number where the model year digit appears. A value of 0 means the year is not included in the serial number. Ignored for 1980 and newer models.",
      type: ["number", "null"],
      default: null,
    },
    digit_start_position: {
      title: "Digit Start Position",
      description:
        "Position of the first digit in the serial number’s trailing numeric portion.",
      type: ["number", "null"],
      default: null,
    },
    serial_num_length: {
      title: "Serial Number Length",
      description:
        "Position of the last digit (or total length) of the serial number.",
      type: ["number", "null"],
      default: null,
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier.",
      type: "string",
      minLength: 1,
    },
    store_id: {
      title: "Store",
      description: "Store identifier.",
      type: "string",
      minLength: 1,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store.",
      type: "string",
      enum: ["active", "inactive"],
      default: "inactive",
    },
    department_id: {
      title: "Department ID",
      description: "Identifier of the department.",
      type: "string",
      minLength: 1,
    },
    department_name: {
      title: "Department Name",
      description: "Name of the department.",
      type: ["string", "null"],
      default: null,
    },
  },
  required: ["make", "name", "enterprise_id", "store_id", "department_id"],
  sections: {
    grid_fields: ["make", "name"],
    general_fields: [
      "make",
      "name",
      "serial_year_position",
      "digit_start_position",
      "serial_num_length",
    ],
  },
  sectionsInfo: {
    general_fields:
      "Make configuration including serial number parsing metadata used for vehicle identification and model year validation.",
  },
};

export const MOCK_MODEL_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-setup-accounting-model-schema.json",
  title: "Model",
  description: "Schema definition for accounting Model record",
  type: "object",
  properties: {
    model: {
      title: "Model",
      description: "Model abbreviation. DMS file record item-ID.",
      type: "string",
      minLength: 1,
      maxLength: 6,
    },
    description: {
      title: "Description",
      description:
        "Full model description which prints on displays and in reports.",
      type: "string",
      minLength: 1,
    },
    make: {
      title: "Make",
      description:
        "System uses this information as the item-ID to translate to the MAKE record related to this model.",
      type: "string",
      typeaheadConfig: {
        url: "/search/Make",
        minChars: 2,
        body: {
          responseFields: ["make", "name"],
        },
        valueField: "make",
        labelField: ["make", "name"],
      },
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier.",
      type: "string",
      minLength: 1,
    },
    store_id: {
      title: "Store",
      description: "Store identifier.",
      type: "string",
      minLength: 1,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store.",
      type: "string",
      enum: ["active", "inactive"],
      default: "inactive",
    },
    department_id: {
      title: "Department ID",
      description: "Identifier of the department.",
      type: "string",
      minLength: 1,
    },
    department_name: {
      title: "Department Name",
      description: "Name of the department.",
      type: ["string", "null"],
      default: null,
    },
  },
  required: [
    "model",
    "description",
    "make",
    "enterprise_id",
    "store_id",
    "department_id",
  ],
  sections: {
    grid_fields: ["model", "description", "make"],
    general_fields: ["model", "description", "make"],
  },
  sectionsInfo: {
    general_fields:
      "Model configuration including reference to Make record for vehicle identification.",
  },
};

export const MOCK_RO_SETUPS_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-setup-ro-setups-schema.json",
  title: "ROSetups",
  description:
    "A schema definition for CSI customer, Concern Code, EIGHTHS, GRID-NAMES, HOUR-TYPES, DEPT.TEAM.LIST",
  functional_area: "SVC",
  type: "object",
  properties: {
    customer_service_index: {
      title: "Account Number Reference",
      description: "account number and column name of schedules",
      type: "array",
      items: {
        type: "object",
        properties: {
          vehicle_type: {
            title: "Vehicle Type",
            description: "Vehicle Type Value",
            type: ["string"],
            enum: [
              "NEW",
              "USED",
              "DEMO",
              "L",
              "LU",
              "LSE",
              "R",
              "F",
              "MISC",
              "S",
            ],
          },
          qualifies_flag: {
            title: "Qualifies Flag",
            description:
              "Indicates whether or not vehicles with the corresponding vehicle type value initially qualify their owners for the CSI customer designation",
            type: "boolean",
            default: false,
          },
          time_unit_code: {
            title: "Time Unit Code",
            description: "Time unit code",
            type: ["string"],
            enum: ["DAYS", "WEEKS", "MONTHS", "YEARS"],
          },
          duration: {
            title: "Duration",
            description: "Duration",
            type: "integer",
            minimum: 0,
            maximum: 31,
          },
        },
        required: [
          "vehicle_type",
          "qualifies_flag",
          "time_unit_code",
          "duration",
        ],
      },
    },
    concern_code: {
      title: "Concern code",
      description:
        "Manufacturer code with columns of all the attributes correlated to this code",
      type: "array",
      items: {
        type: "object",
        properties: {
          manufacturer_code: {
            title: "Manufacturer code",
            type: "string",
            description: "Manufacturer code, may be empty",
            default: "ACCOUNT DEFAULT",
            minLength: 1,
          },
          customer_pay: {
            title: "Customer Pay",
            type: "string",
            enum: ["PROMPT", "DO_NOT_PROMPT", "REQUIRED"],
            description: "Customer Pay",
            default: "DO_NOT_PROMPT",
          },
          internal_pay: {
            title: "Internal Pay",
            type: "string",
            enum: ["PROMPT", "DO_NOT_PROMPT", "REQUIRED"],
            description: "Internal Pay",
            default: "DO_NOT_PROMPT",
          },
          warranty_pay: {
            title: "Warranty Pay",
            type: "string",
            enum: ["PROMPT", "DO_NOT_PROMPT", "REQUIRED"],
            description: "Warranty Pay",
            default: "DO_NOT_PROMPT",
          },
          abbreviation_code: {
            title: "Abbreviation Code",
            description:
              "Abbreviation code for Manufacturer Code, can be a string or array of strings",
            type: ["array", "null"],
            items: {
              type: "string",
            },
            isUnique: true,
            default: null,
          },
          concern_prompt_label: {
            title: "Concern Prompt Label",
            type: ["string", "null"],
            description: "Prompt label for concern code",
            default: "CONCERN-CODE",
          },
          abbreviation_concern_code: {
            title: "Abbreviation Concern Code",
            description: "Abbreviation for concern code",
            type: ["string", "null"],
            default: "CC",
          },
        },
        required: [
          "manufacturer_code",
          "customer_pay",
          "internal_pay",
          "warranty_pay",
        ],
      },
    },
    eighths: {
      title: "Eighths",
      description:
        "Labor type for flat rate unit other than 100ths for sold hours",
      type: "array",
      items: {
        type: "object",
        properties: {
          labor_type: {
            title: "Labor Type",
            type: "string",
            description: "Value from the First array",
            minLength: 1,
          },
          labor_type_flat_rate_unit: {
            title: "Labor Type Flat Rate Unit",
            type: "number",
            description: "Corresponding value from the Third array",
            minimum: 1,
            maximum: 99,
          },
        },
        required: ["labor_type", "labor_type_flat_rate_unit"],
      },
    },
    grid_names: {
      title: "Grid names",
      description: "Grid names",
      type: "array",
      items: {
        type: "object",
        properties: {
          grid_accounting_setup: {
            title: "Grid accounting setup",
            description: "Grid accounting setup and default is SERV",
            type: "string",
            default: "SERV",
            minLength: 1,
          },
          grid_description: {
            title: "Grid Description",
            description: "Grid Description for the setups",
            type: ["string", "null"],
            default: "Service Department",
          },
        },
        required: ["grid_accounting_setup", "grid_description"],
      },
    },
    hour_types: {
      title: "Hour Types",
      description:
        "Hour type contains valid hour types used by Post Final Charges",
      type: "array",
      items: {
        type: "object",
        properties: {
          hour_type: {
            title: "technician labor hours type",
            description: "technician labor hours type",
            type: "string",
            minLength: 1,
          },
          hour_type_description: {
            title: "Type of Hours",
            description: "Type of Hours",
            type: ["string", "null"],
          },
          cost_escalator: {
            title: "Cost Escalator",
            description: "Cost Escalator",
            type: "number",
            default: 100.0,
          },
          cost_additional: {
            title: "cost plus additional cost dollars",
            description: "cost plus additional cost dollars",
            type: "number",
            default: 0.0,
          },
        },
        required: [
          "hour_type",
          "hour_type_description",
          "cost_escalator",
          "cost_additional",
        ],
      },
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    store_id: {
      title: "Store",
      description: "Store identifier",
      type: "string",
      minLength: 1,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
      default: "inactive",
    },
    department_id: {
      title: "Department id",
      description: "Department id",
      type: "string",
    },
    department_name: {
      title: "Department name",
      description: "Department name",
      type: "string",
      default: null,
    },
  },
  required: ["enterprise_id", "store_id", "active_status", "department_id"],
  sections: {
    grid_fields: ["enterprise_id", "store_id"],
    corelation_fields: [
      "customer_service_index",
      "concern_code",
      "eighths",
      "grid_names",
      "hour_types",
    ],
  },
};

export const MOCK_SE_FLAG_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-setup-service-se-flag-schema.json",
  title: "SEFlag",
  description: "A schema definition for SE Flag Setup",
  functional_area: "SVC",
  type: "object",
  properties: {
    is_taxable_customer_deductible: {
      title: "Tax on Customer Pay Deductible Amounts Flag",
      description: "Tax on Customer Pay Deductible Amounts Flag",
      type: "boolean",
      default: false,
    },
    estimated_duration: {
      title: "Estimated Duration Prompt",
      description: "Prompt for estimated duration.",
      type: "string",
      enum: ["PROMPT", "DO_NOT_PROMPT", "REQUIRED"],
      default: "DO_NOT_PROMPT",
    },
    is_technician: {
      title: "Prompt for technician",
      description: "Prompt for technician",
      type: ["boolean", "null"],
      default: null,
    },
    is_comeback: {
      title: "Prompt for comebacks",
      description: " Prompt for comebacks",
      type: ["boolean", "null"],
      default: null,
    },
    service_type: {
      title: "Service application Type",
      description:
        "This attribute indicates which Service applications are in use",
      type: "string",
      enum: ["RO_INV", "RO_INV_WITH_DISPATCHING"],
      default: null,
    },
    misc_op_code: {
      title: "Miscellaneous op code",
      description:
        "Miscellaneous op code. Originally set to 9997 byCS-CREATE ACCOUNT-SERVICE (CSA)",
      type: "string",
      default: "9997",
      typeaheadConfig: {
        url: "/search/OpCodes",
        minChars: 2,
        body: {
          filters: [],
          responseFields: ["op_code", "description"],
        },
        valueField: "op_code",
        labelField: ["op_code", "description"],
      },
    },
    lube_op_code: {
      title: "Lube op code",
      description:
        " Lube op code. Originally set to 9998 by CS-CREATE-ACCOUNT SERVICE (CSA)",
      type: "string",
      default: "9998",
      typeaheadConfig: {
        url: "/search/OpCodes",
        minChars: 2,
        body: {
          filters: [],
          responseFields: ["op_code", "description"],
        },
        valueField: "op_code",
        labelField: ["op_code", "description"],
      },
    },
    sublet_op_code: {
      title: "Sublet op code",
      description:
        "Sublet op code. Originally set to 9999 by CS-CREATE-ACCOUNT SERVICE (CSA)",
      type: "string",
      default: "9999",
      typeaheadConfig: {
        url: "/search/OpCodes",
        minChars: 2,
        body: {
          filters: [],
          responseFields: ["op_code", "description"],
        },
        valueField: "op_code",
        labelField: ["op_code", "description"],
      },
    },
    is_work_order_print: {
      title: "WorkOrder Print Prompt",
      description:
        "Indicates whether to prompt for work order printing.True = Prompt, False or null = Do not prompt",
      type: ["boolean", "null"],
      default: null,
    },
    is_work_order_default: {
      title: "WorkOrder Print Default",
      description:
        "Default value of the prompt. True = Yes, False or null = No. Ignored if Work order Print is FALSE or null",
      type: ["boolean", "null"],
      default: null,
    },
    is_customer_po: {
      title: "Customer Purchase order Number",
      description: "Customer purchase order number prompting flag.",
      type: ["boolean", "null"],
      default: null,
    },
    sale_distribution: {
      title: "Sale dollars distribution.",
      description:
        "Determines whether sale dollars printed on an invoice are distributed by actual or sold hours.",
      type: "string",
      enum: ["ACTUAL_HOURS", "SOLD_HOURS"],
      default: "ACTUAL_HOURS",
    },
    is_vehicle_data_visible: {
      title: "Display vehicle data popup",
      description: "Display vehicle data popup before functions",
      type: ["boolean", "null"],
      default: null,
    },
    is_estimate_changed: {
      title: "Estimate Confirmation",
      description: "Enable enhanced estimate change confirmation",
      type: ["boolean", "null"],
      default: null,
    },
    is_post_flag_hours: {
      title: "Post Flag Hours",
      description: "Option to activate posting of flag hours feature",
      type: ["boolean", "null"],
      default: null,
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    store_id: {
      title: "Store",
      description: "Store identifier",
      type: "string",
      minLength: 1,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
      default: "inactive",
    },
    department_id: {
      title: "Department ID",
      description: "Identifier of the department.",
      type: "string",
      minLength: 1,
    },
    department_name: {
      title: "Department name",
      description: "Department name",
      type: ["string", "null"],
      default: null,
    },
  },
  required: [
    "is_technician",
    "service_type",
    "is_work_order_print",
    "is_customer_po",
    "is_vehicle_data_visible",
    "is_estimate_changed",
    "is_post_flag_hours",
    "enterprise_id",
    "store_id",
    "department_id",
  ],
  sections: {
    grid_fields: [
      "is_technician",
      "service_type",
      "is_work_order_print",
      "is_customer_po",
      "is_vehicle_data_visible",
      "is_estimate_changed",
      "is_post_flag_hours",
    ],
    general_fields: [
      "estimated_duration",
      "service_type",
      "misc_op_code",
      "lube_op_code",
      "sublet_op_code",
      "sale_distribution",
    ],
    options: [
      "is_taxable_customer_deductible",
      "is_technician",
      "is_comeback",
      "is_work_order_print",
      "is_work_order_default",
      "is_customer_po",
      "is_vehicle_data_visible",
      "is_estimate_changed",
      "is_post_flag_hours",
    ],
  },
  sectionsInfo: {
    general_fields:
      "General configuration for service entry prompting and op code defaults.",
    options:
      "Flags for prompting and defaulting various service functions and features, as well as op code configuration for service line items.",
  },
};

export const MOCK_SHOP_CHARGES_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-setup-shop-charge-schema.json",
  title: "ShopCharge",
  description: "A schema definition for Shop Charge Table",
  type: "object",
  properties: {
    make_id: {
      title: "Make Identifier",
      description: "Make-specific identifier or default table key.",
      type: "string",
      minLength: 1,
      default: "SHOP-CHARGE-TBL",
      typeaheadConfig: {
        url: "/v2/search/Make",
        minChars: 2,
        body: {
          responseFields: ["make", "name"],
        },
        valueField: "make",
        labelField: ["make", "name"],
      },
      uniqueCombination: ["make_id", "charge_type"],
      isEditable: false,
    },
    label: {
      title: "Label",
      description: "Shop Charge Label (description of the charge).",
      type: ["string", "null"],
      maxLength: 47,
      default: null,
    },
    charge_type: {
      title: "Charge Type",
      description: "Type of charge applied (e.g., customer pay).",
      type: "string",
      enum: ["Customer Pay", "Warranty Pay", "Internal Pay"],
      uniqueCombination: ["make_id", "charge_type"],
      isEditable: false,
    },
    limits: {
      title: "Limits",
      description: "Thresholds and limits for shop charges.",
      type: ["object", "null"],
      properties: {
        min_sale: {
          title: "Minimum Sale Amount",
          description: "Shop Charge Minimum for SALE",
          type: ["number", "null"],
          default: null,
        },
        max_sale: {
          title: "Maximum Sale Amount",
          description: "Shop Charge Maximum for SALE",
          type: ["number", "null"],
          default: null,
        },
        max_cost: {
          title: "Maximum Cost Amount",
          description: "Shop Charge Maximum for COST",
          type: ["number", "null"],
          default: null,
        },
        threshold: {
          title: "Threshold",
          description: "Charge on amount greater than",
          type: ["number", "null"],
          default: null,
        },
      },
    },
    sale_percentages: {
      title: "Sale Percentages",
      description: "Sale Percentages",
      type: "object",
      properties: {
        based_on: {
          title: "Based On",
          description: "Calc Sale Based on",
          type: "string",
          enum: ["SALE", "COST"],
          default: "SALE",
          disabled: true,
        },
        labor: {
          title: "Labor Sale Percentage",
          description: "Labor Sale Percentage",
          type: ["number", "null"],
          default: null,
        },
        parts: {
          title: "Parts Sale Percentage",
          description: "Parts Sale Percentage",
          type: ["number", "null"],
          default: null,
        },
      },
      required: ["based_on"],
    },
    cost_percentages: {
      title: "Cost Percentages",
      description: "Cost Percentages",
      type: "object",
      properties: {
        based_on: {
          title: "Based On",
          description: "Calc Cost Based on",
          type: "string",
          enum: ["SALE", "COST"],
          default: "COST",
          disabled: true,
        },
        labor: {
          title: "Labor Cost Percentage",
          description: "Labor Cost Percentage",
          type: ["number", "null"],
          default: null,
        },
        parts: {
          title: "Parts Cost Percentage",
          description: "Parts Cost Percentage",
          type: ["number", "null"],
          default: null,
        },
      },
      required: ["based_on"],
    },
    included_on: {
      title: "Shop Charges Included On",
      description: "Included on MISC, LUBE, SUBLET",
      type: ["array", "null"],
      items: {
        type: "string",
      },
      enum: ["LUBE", "MISC", "SUBLET"],
    },
    journal: {
      title: "Journal",
      description: "Journal information",
      type: "object",
      properties: {
        source_company_group_id: {
          title: "Source Group Id",
          description: "Source Group Id",
          type: "string",
          isGroupId: true,
          storeKey: "source_store_id",
          dependentFields: ["journal_id"],
        },
        source_store_id: {
          title: "Source Store Id",
          description: "Source Store Id",
          type: "string",
          isStore: true,
          companyKey: "source_company",
          disabled: true,
        },
        source_company: {
          title: "Source Company",
          description: "Source Company",
          type: "string",
          disabled: true,
        },
        journal_id: {
          title: "Journal Id",
          description: "Journal Number",
          type: "string",
          typeaheadConfig: {
            url: "/v2/search/Journals",
            minChars: 2,
            body: {
              filters: [
                {
                  field: "record_type",
                  operator: "EQUALS",
                  value: "Base",
                },
              ],
              responseFields: ["journal_id", "journal_name"],
            },
            storeId: "$source_store_id",
            groupId: "$source_company_group_id",
            valueField: "journal_id",
            labelField: ["journal_id", "journal_name"],
          },
        },
        is_prmt_req: {
          title: "Is Prompt Required",
          description: "Is Prompt Required for Journal",
          type: "boolean",
          default: false,
        },
      },
      required: ["source_company", "journal_id"],
    },
    tax_code: {
      title: "Tax Code",
      description: "Tax Code",
      type: "string",
      default: "DEFAULT",
    },
    sale_mapping: {
      title: "Sale Mapping",
      description: "Sale Mapping",
      type: "object",
      properties: {
        target_company_group_id: {
          title: "Target Group Id",
          description: "Target Group Id",
          type: "string",
          isGroupId: true,
          storeKey: "target_store_id",
          dependentFields: ["target_account"],
        },
        target_store_id: {
          title: "Target Store Id",
          description: "Target Store Id",
          type: "string",
          isStore: true,
          companyKey: "target_company",
          disabled: true,
        },
        target_company: {
          title: "Target Company",
          description: "Sale Target Company",
          type: "string",
          disabled: true,
        },
        target_account: {
          title: "Target Account",
          description: "Sale Target Account",
          type: "string",
          typeaheadConfig: {
            url: "/v2/search/COA",
            minChars: 2,
            body: {
              filters: [
                {
                  field: "record_type",
                  operator: "EQUALS",
                  value: "Base",
                },
              ],
              responseFields: ["account_number", "account_description"],
            },
            storeId: "$target_store_id",
            groupId: "$target_company_group_id",
            valueField: "account_number",
            labelField: ["account_number", "account_description"],
          },
        },
        is_prmt_req: {
          title: "Is Prompt Required",
          description: "Is Prompt Required for Sale",
          type: "boolean",
          default: false,
        },
        ctrl_number: {
          title: "Control Number",
          description: "Sale Control Number ",
          type: ["string", "null"],
          default: null,
        },
        is_ctrl_prmt_req: {
          title: "Is Control Prompt Required",
          description: "Is Control Prompt Required for Sale",
          type: "boolean",
          default: false,
        },
      },
      required: ["target_company", "target_account"],
    },
    debit_mapping: {
      title: "Debit Mapping",
      description: "Debit Mapping",
      type: ["object", "null"],
      default: null,
      properties: {
        target_group_id: {
          title: "Target Group Id",
          description: "Target Group Id",
          type: ["string", "null"],
          default: null,
          isGroupId: true,
          storeKey: "target_store_id",
          dependentFields: ["target_account"],
        },
        target_store_id: {
          title: "Target Store Id",
          description: "Target Store Id",
          type: ["string", "null"],
          default: null,
          isStore: true,
          companyKey: "target_company",
          disabled: true,
        },
        target_company: {
          title: "Target Company",
          description: "Debit Target Company",
          type: ["string", "null"],
          default: null,
          disabled: true,
        },
        target_account: {
          title: "Target Account",
          description: "Debit Target Account",
          type: ["string", "null"],
          default: null,
          typeaheadConfig: {
            url: "/v2/search/COA",
            minChars: 2,
            body: {
              filters: [
                {
                  field: "record_type",
                  operator: "EQUALS",
                  value: "Base",
                },
              ],
              responseFields: ["account_number", "account_description"],
            },
            storeId: "$target_store_id",
            groupId: "$target_group_id",
            valueField: "account_number",
            labelField: ["account_number", "account_description"],
          },
        },
        is_prmt_req: {
          title: "Is Prompt Required",
          description: "Is Prompt Required for Debit",
          type: ["boolean", "null"],
          default: null,
        },
        ctrl_number: {
          title: "Control Number",
          description: "Debit Control Number ",
          type: ["string", "null"],
          default: null,
        },
        is_ctrl_prmt_req: {
          title: "Is Control Prompt Required",
          description: "Is Control Prompt Required for Debit",
          type: ["boolean", "null"],
          default: null,
        },
        is_labor_debit_acc: {
          title: "Is Labor Type Debit Account",
          description: "Is Labor Type Debit Account",
          type: ["boolean", "null"],
          default: null,
        },
      },
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    store_id: {
      title: "Store",
      description: "Store identifier",
      type: "string",
      minLength: 1,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
      default: "inactive",
    },
    department_id: {
      title: "Department id",
      description: "Department id",
      type: "string",
    },
    department_name: {
      title: "Department name",
      description: "Department name",
      type: ["string", "null"],
      default: null,
    },
  },
  required: [
    "make_id",
    "charge_type",
    "sale_percentages",
    "cost_percentages",
    "journal",
    "sale_mapping",
    "enterprise_id",
    "store_id",
    "department_id",
  ],
  sections: {
    grid_fields: ["make_id", "charge_type", "label"],
    general_fields: [
      "make_id",
      "charge_type",
      "label",
      "included_on",
      "tax_code",
    ],
    grouped_fields: [
      "limits",
      "sale_percentages",
      "cost_percentages",
      "journal",
      "sale_mapping",
      "debit_mapping",
    ],
  },
};

export const MOCK_SHOP_CHARGES_ROWDATA: RowData = {
  id: "3786d0a8-d08d-4059-8147-6a8b5cfa81a1",
  make_id: "SHOP-CHARGE-TBL",
  label: "TEST-1",
  charge_type: "Customer Pay",
  limits: {
    min_sale: 10.0,
    max_sale: 100.0,
    max_cost: 50.0,
    threshold: 40.0,
  },
  sale_percentages: {
    based_on: "SALE",
    labor: 5.0,
    parts: 50.0,
  },
  cost_percentages: {
    based_on: "COST",
    labor: 5.0,
    parts: 10.0,
  },
  journal: {
    source_company: "5",
    source_company_group_id: "G000008445",
    source_store_id: "S100119371",
    journal_id: "J1",
    is_prmt_req: false,
  },
  sale_mapping: {
    target_company: "5",
    target_company_group_id: "G000008445",
    target_store_id: "S100119371",
    target_account: "404002",
    is_prmt_req: false,
    ctrl_number: null,
    is_ctrl_prmt_req: false,
  },
  debit_mapping: {
    is_labor_debit_acc: null,
    target_company: "5",
    target_company_group_id: null,
    target_store_id: "S100119371",
    target_account: "403009",
    is_prmt_req: null,
    ctrl_number: null,
    is_ctrl_prmt_req: null,
  },
  included_on: ["LUBE", "SUBLET"],
  tax_code: "DEFAULT",
  store_id: "S100119371",
  department_id: "D100096245",
  department_name: "PL-S",
  serial_no: 152,
  enterprise_id: "E339440",
  active_status: "active",
  created_by: "OM@E339440.com",
  created_at: "2026-05-20T12:01:46.651+00:00",
  updated_by: "OM@E339440.com",
  updated_at: "2026-05-20T12:02:07.262+00:00",
};

export const MOCK_TRUCK_AP_INVOICES_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-truck-ap-invoices-setup-schema.json",
  title: "TruckAPInvoices",
  description: "A schema definition for parts Truck Pending AP Invoices Setup",
  functional_area: "Account",
  type: "object",
  properties: {
    manufacturer_code: {
      title: "Manufacturer Code",
      description: "Manufacturer Code for OEM",
      type: "string",
      minLength: 2,
      uniqueCombination: ["manufacturer_code", "dealer_code"],
      isEditable: false,
      enum: [
        "Paccar",
        "International",
        "Mack Volvo",
        "Hino Motors",
        "Daimler Trucks North America",
      ],
    },
    dealer_code: {
      title: "Dealer Code",
      description: "Dealer Code identifier",
      type: "string",
      minLength: 1,
      uniqueCombination: ["manufacturer_code", "dealer_code"],
      isEditable: false,
    },
    gl_accounts: {
      title: "GL Accounts",
      description: "GL Accounts to apply to AP Invoice",
      type: "array",
      minItems: 1,
      items: {
        type: "object",
        properties: {
          group: {
            title: "Group",
            description: "Group identifier",
            type: ["string", "null"],
            isGroupId: true,
            storeKey: "store",
            dependentFields: ["account"],
          },
          store: {
            title: "Store",
            description: "Store identifier",
            type: ["string", "null"],
            isStore: true,
            companyKey: "company",
            disabled: true,
            isHidden: true,
          },
          company: {
            title: "Company Number",
            description: "Company number to apply to AP Invoice",
            type: ["string", "null"],
            disabled: true,
            isHidden: true,
          },
          account: {
            title: "Account Number",
            description: "G/L Account number to apply to taxation item",
            type: "string",
            typeaheadConfig: {
              url: "/v2/search/COA",
              minChars: 2,
              body: {
                filters: [
                  {
                    field: "record_type",
                    operator: "EQUALS",
                    value: "Base",
                  },
                ],
                responseFields: ["account_number", "account_description"],
              },
              valueField: "account_number",
              labelField: ["account_number", "account_description"],
            },
          },
          tax_item_label: {
            title: "GL Item Label",
            description: "Taxation Item Label to identify the AP Invoice setup",
            type: "string",
            minLength: 1,
          },
          purpose: {
            title: "Purpose",
            description: "Purpose to apply to AP Invoice",
            type: ["string", "null"],
          },
        },
        required: ["tax_item_label", "account"],
      },
    },
    vendor_id: {
      title: "Vendor Id",
      description: "Vendor Id to apply to AP Invoice",
      type: ["string", "null"],
      default: null,
      typeaheadConfig: {
        url: "/RemitToParent",
        minChars: 2,
        body: {
          searchKey: "REMIT_VENDOR",
          responseFields: ["vendorId"],
        },
        evalMethods: ["fetchRemitToParentVendorIds"],
        valueField: "vendorId",
        labelField: ["vendorId"],
      },
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    store_id: {
      title: "Store",
      description: "Store identifier",
      type: "string",
      minLength: 1,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
      default: "inactive",
    },
  },
  required: [
    "manufacturer_code",
    "dealer_code",
    "enterprise_id",
    "store_id",
    "gl_accounts",
  ],
  sections: {
    grid_fields: ["manufacturer_code", "dealer_code", "vendor_id"],
    general_fields: ["manufacturer_code", "dealer_code", "vendor_id"],
    corelation_fields: ["gl_accounts"],
  },
};

export const MOCK_BANK_RECON_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-bank-recon-schema.json",
  title: "BankRecon",
  description: "A schema definition for BankRecon setup AGRR item",
  type: "object",
  properties: {
    bank_recon_code: {
      title: "Bank Recon Code",
      description: "Bank Recon Code",
      type: "string",
      isUnique: true,
      isEditable: false,
    },
    account_details: {
      title: "Account Details",
      description: "Account Details",
      type: ["array", "null"],
      items: {
        type: "object",
        properties: {
          gl_group_id: {
            title: "GL Group Id",
            description: "GL Group Id",
            type: "string",
            isGroupId: true,
            storeKey: "gl_store_id",
            dependentFields: ["account_number"],
          },
          gl_store_id: {
            title: "GL Store Id",
            description: "GL Store Id",
            type: "string",
            isStore: true,
            companyKey: "gl_company_id",
            disabled: true,
          },
          gl_company_id: {
            title: "GL Company Id",
            description: "GL Company Id",
            type: "string",
            disabled: true,
          },
          account_number: {
            title: "Account Number",
            description: "Account Number",
            type: ["string", "null"],
            typeaheadConfig: {
              url: "/v2/search/COA",
              minChars: 2,
              body: {
                filters: [
                  {
                    field: "record_type",
                    operator: "EQUALS",
                    value: "Base",
                  },
                ],
                responseFields: ["account_number", "account_description"],
              },
              storeId: "$gl_store_id",
              groupId: "$gl_group_id",
              valueField: "account_number",
              labelField: ["account_number", "account_description"],
            },
          },
          journal_ids: {
            title: "Journal Id",
            description: "Journal Id",
            type: ["array", "null"],
            items: {
              type: "string",
            },
            typeaheadConfig: {
              url: "/v2/search/Journals",
              minChars: 2,
              body: {
                filters: [
                  {
                    field: "record_type",
                    operator: "EQUALS",
                    value: "Base",
                  },
                ],
                responseFields: ["journal_id", "journal_name"],
              },
              storeId: "$gl_store_id",
              groupId: "$gl_group_id",
              valueField: "journal_id",
              labelField: ["journal_id", "journal_name"],
            },
          },
        },
        required: ["gl_company_id", "gl_store_id", "gl_group_id"],
      },
    },
    is_sort_group_code: {
      title: "Is Sort Group Code",
      description: "Is Sort/Group Code",
      type: "boolean",
      default: true,
    },
    last_capture_date: {
      title: "Last Captured Date",
      description: "Last Captured Date",
      format: "date",
      type: ["string", "null"],
    },
    last_recon_date_time: {
      title: "Last Recon Date Time",
      description: "Last Recon Date Time along with Timezone",
      type: ["string", "null"],
      format: "dateTime",
    },
    last_recon_user: {
      title: "Last Recon User",
      description: "Last Recon User",
      type: ["string", "null"],
    },
    recon_code_desc: {
      title: "Recon Code Desc",
      description: "Recon Code Description",
      type: ["string", "null"],
    },
    is_recon: {
      title: "Is Recon",
      description: "Is Recon",
      type: "boolean",
      default: false,
    },
    begin_balance: {
      title: "Begin Balance",
      description: "Begin Balance",
      type: ["number", "null"],
    },
    end_balance: {
      title: "End Balance",
      description: "End Balance",
      type: ["number", "null"],
    },
    recon_date: {
      title: "Recon Date",
      description: "Recon Date",
      format: "date",
      type: ["string", "null"],
    },
    start_date: {
      title: "Start Date",
      description: "Start Date",
      format: "date",
      type: "string",
    },
    retention_months: {
      title: "Retention Months",
      description: "Retention Months",
      type: "number",
      maximum: 999,
      default: 12,
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
      default: "inactive",
    },
  },
  required: [
    "bank_recon_code",
    "retention_months",
    "is_sort_group_code",
    "is_recon",
    "start_date",
    "enterprise_id",
  ],
  sections: {
    grid_fields: [
      "bank_recon_code",
      "recon_code_desc",
      "is_recon",
      "is_sort_group_code",
      "last_capture_date",
      "last_recon_date_time",
      "last_recon_user",
    ],
    general_fields: [
      "bank_recon_code",
      "recon_code_desc",
      "is_recon",
      "is_sort_group_code",
      "last_capture_date",
      "last_recon_date_time",
      "last_recon_user",
      "begin_balance",
      "end_balance",
      "recon_date",
      "start_date",
      "retention_months",
    ],
    corelation_fields: ["account_details"],
  },
};

export const MOCK_BANK_RECON_ROWDATA: RowData = {
  id: "f976704a-d4bd-43f1-b3bb-1c0e746dcdc0",
  bank_recon_code: "BR1",
  account_details: [
    {
      gl_company_id: "5",
      gl_store_id: "S100119371",
      gl_group_id: "G000008445",
      account_number: "403009",
      journal_ids: ["J1"],
    },
    {
      gl_company_id: "5",
      gl_store_id: "S100119371",
      gl_group_id: "G000008445",
      account_number: "9904",
      journal_ids: ["J1", "J2"],
    },
  ],
  is_sort_group_code: true,
  last_capture_date: "2026-05-07",
  last_recon_date_time: "2026-05-28 22:00:00",
  last_recon_user: "nkelley",
  recon_code_desc: "Test",
  is_recon: true,
  begin_balance: 2300,
  end_balance: 2400,
  recon_date: "2026-05-07",
  start_date: "2026-05-07",
  retention_months: 12,
  cnumber: null,
  serial_no: 2549,
  enterprise_id: "E339440",
  active_status: "active",
  created_by: "OM@E339440.com",
  created_at: "2026-05-28T10:30:17.679+00:00",
  updated_by: "OM@E339440.com",
  updated_at: "2026-05-28T10:30:17.679+00:00",
};

export const MOCK_SETUP_NAVINFO_BY_DEPARTMENT: SetupListNavInfoByDepartment = {
  parts: {
    setups: [
      {
        id: "InventoryBuildings",
        text: "Inventory Buildings",
        department: {
          label: "Parts",
          value: "parts",
          disabled: false,
        },
        description:
          "Manage inventory buildings, configure active inventory locations, map delivery routes, and organize zone layouts to support accurate inventory operations and scalability.",
        permissions: {
          hasView: true,
          hasManage: true,
        },
      },
    ],
    departmentIds: [
      {
        storeId: "S100119370",
        departmentId: "D100096250",
        name: "BDC-I",
      },
      {
        storeId: "S100119371",
        departmentId: "D100096244",
        name: "PL-I",
      },
      {
        storeId: "S100119373",
        departmentId: "D100096230",
        name: "PLF-I",
      },
    ],
  },
  service: {
    setups: [
      {
        id: "SEFlag",
        text: "SE Flags",
        description: "Description is not defined for the setup",
      },
      {
        id: "ServicePricing",
        text: "Service Pricing",
        description: "Description is not defined for the setup",
      },
      {
        id: "ShopCharge",
        text: "Shop Charge",
        description: "Description is not defined for the setup",
      },
    ],
    departmentIds: [
      {
        storeId: "S100119370",
        departmentId: "D100096252",
        name: "BDC-S",
      },
      {
        storeId: "S100119371",
        departmentId: "D100096245",
        name: "PL-S",
      },
      {
        storeId: "S100119373",
        departmentId: "D100096231",
        name: "PLF-S",
      },
    ],
  },
  accounting: {
    setups: [
      {
        id: "AccountsPayable",
        text: "Accounts Payable",
        department: {
          label: "Accounting",
          value: "accounting",
          disabled: false,
        },
        description:
          "A flattened schema definition for an Accounts Payable open item setup object",
        permissions: {
          hasView: true,
          hasManage: true,
        },
      },
      {
        id: "AccountsReceivable",
        text: "Accounts Receivable",
        description: "A schema definition for an Accounts Receivable object",
        permissions: {
          hasView: true,
          hasManage: true,
        },
      },
      {
        id: "ARPortal",
        text: "AR Portal Setup",
        description: "A schema definition for AR Portal Setup",
        permissions: {
          hasView: true,
          hasManage: true,
        },
      },
      {
        id: "COA",
        text: "Chart of Accounts (COA)",
        description: "A flattened schema definition for a COA setup item",
        permissions: {
          hasView: true,
          hasManage: true,
          hasImport: true,
        },
      },
    ],
    departmentIds: [
      {
        storeId: "S100119370",
        departmentId: "D100096248",
        name: "BDC-A",
      },
      {
        storeId: "S100119371",
        departmentId: "D100096236",
        name: "PLF-A",
      },
      {
        storeId: "S100119373",
        departmentId: "D100096236",
        name: "PLF-A",
      },
    ],
  },
};

export const MOCK_PRICING_MATRIX_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-setup-pricing-matrix-table-schema.json",
  title: "PricingMatrix",
  description: "A schema definition for parts pricing matrix.",
  functional_area: "PARTS",
  type: "object",
  properties: {
    source: {
      title: "Source number",
      description:
        "Enter the source number used to identify the price break table. This number is used to reference the price break table in other parts of the system.",
      type: "string",
      isUnique: true,
    },
    price_to_calculate: {
      title: "Price To Calculate",
      description:
        "Select the price field used as the basis for calculating the price adjustment.",
      enum: [
        null,
        "COST",
        "LIST",
        "TRADE",
        "COMPLETED",
        "EXCHANGE",
        "PRICE6",
        "PRICE7",
        "PRICE8",
        "PRICE9",
        "PRICE10",
      ],
      type: ["string", "null"],
    },
    price_break: {
      title: "Price To Break",
      description:
        "Select the price field to which the price adjustment is applied.",
      enum: [
        null,
        "COST",
        "LIST",
        "TRADE",
        "COMPLETED",
        "EXCHANGE",
        "PRICE6",
        "PRICE7",
        "PRICE8",
        "PRICE9",
        "PRICE10",
      ],
      type: ["string", "null"],
    },
    price_escalators: {
      title: "Parts Price Code Escalators",
      description:
        "Define price ranges and the corresponding price adjustments for each range.",
      type: "array",
      items: {
        type: "object",
        properties: {
          minimum: {
            title: "Minimum Price",
            description:
              "Enter the lowest price in this range. When the part price falls within this range, the associated price break formula is applied.",
            type: "number",
            minimum: 0.1,
          },
          maximum: {
            title: "Maximum Price",
            description:
              "Enter the highest price in this range. When the part price falls within this range, the associated price break formula is applied.",
            type: "number",
            minimum: 0.1,
          },
          type: {
            title: "Escalator Type",
            description:
              "Select whether the price adjustment is calculated as a fixed amount or a percentage.",
            type: "string",
            enum: ["PERCENT", "AMOUNT"],
          },
          value: {
            title: "Value",
            description:
              "Enter the amount or percentage to apply to the selected price field.",
            type: "number",
            minimum: 0.1,
          },
        },
        required: ["minimum", "maximum", "type", "value"],
      },
    },
    enterprise_id: {
      title: "Enterprise",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    store_id: {
      title: "Store",
      description: "Store identifier",
      type: "string",
      minLength: 1,
    },
    active_status: {
      title: "Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
      default: "inactive",
    },
    department_id: {
      title: "Department id",
      description: "Department id",
      type: "string",
    },
    department_name: {
      title: "Department name",
      description: "Department name",
      type: ["string", "null"],
    },
  },
  required: [
    "source",
    "price_escalators",
    "enterprise_id",
    "store_id",
    "department_id",
  ],
  sections: {
    grid_fields: ["source", "price_to_calculate", "price_break"],
    general_fields: ["source", "price_to_calculate", "price_break"],
    corelation_fields: ["price_escalators"],
  },
  sectionsInfo: {
    general_fields:
      "Configure the pricing source and select the price fields used to calculate and apply price adjustments.",
    price_escalators:
      "Define price ranges and specify whether each price adjustment is a fixed amount or a percentage.",
  },
};

export const MOCK_PRICING_MATRIX_ROWDATA_LIST: RowData[] = [
  {
    id: "934d9386-3250-43a3-85e0-0a6741d78738",
    store_id: "S100119371",
    department_id: "D100096244",
    department_name: "PL-I",
    source: "300",
    price_to_calculate: "COST",
    price_break: "LIST",
    price_escalators: [
      {
        minimum: 100,
        maximum: 500,
        value: 50,
        type: "PERCENT",
      },
    ],
    serial_no: 35,
    enterprise_id: "E339440",
    active_status: "active",
    created_by: "OM@E339440.com",
    created_at: "2026-09-01T05:13:46.349+00:00",
    updated_by: "OM@E339440.com",
    updated_at: "2026-09-08T06:32:04.511+00:00",
  },
  {
    id: "6b745381-716c-4302-8090-455f23143f44",
    store_id: "S100119371",
    department_id: "D100096244",
    department_name: "PL-I",
    source: "200",
    price_to_calculate: "COST",
    price_break: "LIST",
    price_escalators: [
      {
        minimum: 100,
        maximum: 1000,
        value: 100,
        type: "AMOUNT",
      },
      {
        minimum: 100,
        maximum: 2000,
        value: 100,
        type: "AMOUNT",
      },
    ],
    serial_no: 36,
    enterprise_id: "E339440",
    active_status: "active",
    created_by: "sys-user-cdcm",
    created_at: "2026-09-03T14:33:53.051+00:00",
    updated_by: "OM@E339440.com",
    updated_at: "2026-09-08T06:32:04.511+00:00",
  },
];

export const MOCK_CASH_CLEARING_SCHEMA: JsonSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  $id: "http://cdk.com/schemas/cdcm-setup-cash-clearing-schema.json",
  title: "CashClearingSetup",
  description: "Set up configuration for SimplePay Cash Clearing",
  functional_area: "ACCT",
  type: "object",
  properties: {
    transaction_type: {
      title: "Transaction Type",
      description:
        "Select the payment transaction type for which this cash clearing configuration applies.",
      type: "string",
      enum: ["ACH", "CC", "BUY_NOW_PAY_LATER"],
      enumLabels: {
        ACH: "Bank Account",
        CC: "Credit Card",
        BUY_NOW_PAY_LATER: "Buy Now Pay Later",
      },
      isEditable: false,
      uniqueCombination: ["transaction_type", "integrating_application"],
      default: "ACH",
    },
    integrating_application: {
      title: "Application",
      description:
        "Select the application that uses this cash clearing configuration, if applicable.",
      enum: [
        "cdkservice",
        "driveparts",
        "driveservice",
        "driveaccounting",
        "modernretailing",
        "virtualterminal",
        "legacyfi",
        "modparts",
        "modacc",
        null,
      ],
      enumLabels: {
        cdkservice: "CDK Service",
        driveparts: "Drive Parts",
        driveservice: "Drive Service",
        driveaccounting: "Drive Accounting",
        modernretailing: "Modern Retailing",
        virtualterminal: "Virtual Terminal",
        legacyfi: "Drive F&I",
        modparts: "CDK Parts",
        modacc: "Accounting Modernized",
        null: "Global",
      },
      type: ["string", "null"],
      uniqueCombination: ["transaction_type", "integrating_application"],
      default: null,
    },
    journal_num: {
      title: "Journal ID",
      description:
        "Select the journal used to post cash clearing transactions.",
      type: "string",
      typeaheadConfig: {
        url: "/v2/search/Journals",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
          ],
          responseFields: ["journal_id", "journal_name"],
        },
        valueField: ["journal_id", "journal_name"],
        labelField: ["journal_id", "journal_name"],
      },
    },
    cash_clearing_company_group_id: {
      title: "Cash Clearing GL Company",
      description: "Cash Clearing Group ID",
      type: "string",
      isGroupId: true,
      storeKey: "cash_clearing_company_group_store",
      dependentFields: ["cash_clearing_account"],
    },
    cash_clearing_account: {
      title: "Cash Clearing Account",
      description:
        "Select the Cash Clearing account used to temporarily hold transactions until they are cleared.",
      type: "string",
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        groupId: "$cash_clearing_company_group_id",
        storeId: "$cash_clearing_company_group_store",
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "sub_type",
              operator: "EQUALS",
              value: "Cash",
            },
          ],
          responseFields: ["account_description", "account_number"],
        },
        valueField: ["account_number", "account_description"],
        labelField: ["account_number", "account_description"],
      },
    },
    cash_in_bank_company_group_id: {
      title: "Cash In Bank GL Company",
      description: "Cash In Bank Group ID",
      type: "string",
      isGroupId: true,
      storeKey: "cash_in_bank_company_group_store",
      dependentFields: ["cash_in_bank_account"],
    },
    cash_in_bank_account: {
      title: "Cash In Bank Account",
      description:
        "Select the Cash in Bank account used to record cash receipts for the selected transaction type.",
      type: "string",
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        groupId: "$cash_in_bank_company_group_id",
        storeId: "$cash_in_bank_company_group_store",
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "sub_type",
              operator: "EQUALS",
              value: "Cash",
            },
          ],
          responseFields: ["account_description", "account_number"],
        },
        valueField: ["account_number", "account_description"],
        labelField: ["account_number", "account_description"],
      },
    },
    surcharge_account: {
      title: "Surcharge Account",
      description: "Surcharge Account",
      type: ["string", "null"],
      default: null,
      typeaheadConfig: {
        url: "/v2/search/COA",
        minChars: 2,
        body: {
          filters: [
            {
              field: "record_type",
              operator: "EQUALS",
              value: "Base",
            },
            {
              field: "sub_type",
              operator: "EQUALS",
              value: "Cash",
            },
          ],
          responseFields: ["account_description", "account_number"],
        },
        valueField: ["account_number", "account_description"],
        labelField: ["account_number", "account_description"],
      },
    },
    is_enabled: {
      title: "Is Enabled",
      description:
        "Enable this option to activate the cash clearing configuration for the selected transaction type.",
      type: ["boolean", "null"],
      default: true,
    },
    active_status: {
      title: "Active Status",
      description:
        "Determines whether the object is in active use by the store",
      type: "string",
      minLength: 1,
      enum: ["active", "inactive"],
      default: "active",
    },
    enterprise_id: {
      title: "Enterprise ID",
      description: "Enterprise identifier",
      type: "string",
      minLength: 1,
    },
    store_id: {
      title: "Store ID",
      description: "Store identifier",
      type: "string",
      minLength: 1,
    },
    tenant_id: {
      title: "Tenant",
      description: "Tenant identifier",
      type: "string",
      minLength: 1,
    },
    transaction_id: {
      title: "Transaction Id",
      description: "Transaction id from salesforce ",
      type: ["string", "null"],
      minLength: 1,
      default: null,
    },
  },
  required: [
    "transaction_type",
    "cash_in_bank_account",
    "cash_clearing_account",
    "journal_num",
    "enterprise_id",
    "store_id",
  ],
  dependencies: {
    transaction_type: {
      rules: [
        {
          matches: ["CC"],
          fieldsToEnable: ["surcharge_account"],
        },
        {
          matches: ["ACH", "BUY_NOW_PAY_LATER"],
          fieldsToDisableAndClear: ["surcharge_account"],
        },
      ],
    },
  },
  sections: {
    grid_fields: [
      "integrating_application",
      "transaction_type",
      "journal_num",
      "cash_clearing_company_group_id",
      "cash_clearing_account",
      "cash_in_bank_company_group_id",
      "cash_in_bank_account",
      "surcharge_account",
      "is_enabled",
    ],
    general_fields: [
      "transaction_type",
      "integrating_application",
      "journal_num",
      "is_enabled",
    ],
    cash_clearing_fields: [
      "cash_clearing_company_group_id",
      "cash_clearing_account",
    ],
    cash_in_bank_fields: [
      "cash_in_bank_company_group_id",
      "cash_in_bank_account",
    ],
    surcharge_fields: ["surcharge_account"],
  },
  sectionsInfo: {
    general_fields:
      "Configure the cash clearing setup by defining the transaction type, associated accounts, posting journal, integrating application, and activation status.",
    cash_clearing_fields:
      "Configure the cash clearing account by selecting the appropriate company group and account used to temporarily hold transactions until they are cleared.",
    cash_in_bank_fields:
      "Configure the cash in bank account by selecting the appropriate company group and account used to record cash receipts for the selected transaction type.",
    surcharge_fields:
      "Configure the surcharge account by selecting the appropriate account used to record surcharge fees for credit card transactions. This field is only applicable when the transaction type is set to 'Credit Card'.",
  },
};
